/* UPS Solutions Builder prototype UI (RD.03, Claude 2026-09-27). Needs assets/upsb-solution-builder.js first. */
(function () {
  'use strict';
  var B = window.UPSBBuilder;
  var P91 = window.UPSBP91Capacity;
  var root = document.querySelector('[data-upsb-builder]');
  if (!root || !B) return;
  var T = JSON.parse(root.querySelector('[data-upsb-builder-strings]').textContent);
  var FR = root.getAttribute('data-locale') === 'fr';
  var PREFIX = FR ? '/fr' : '';
  var measure = window.UPSBMeasure && window.UPSBMeasure.forElement ?
    window.UPSBMeasure.forElement(root, 'builder', FR ? 'fr' : 'en') : null;
  function emit(name, fields, key) { if (measure) measure.emit(name, fields, key); }
  Object.assign(T, FR ? {
    count: '{shown} options affichées sur {total} à examiner',
    jump: 'Voir les {n} options',
    addon_why: 'Indiqués par le fabricant pour ce modèle',
    tp_volt: 'Tension d’alimentation', tp_volt_opts: ['À confirmer', '208 V (120/208 V étoile)', '480 V', '600 V'],
    tp_bypass: 'Dérivation de maintenance', tp_bypass_opts: ['Aidez-moi à décider', 'Requise', 'Non requise'],
    tp_seismic: 'Ancrage sismique', tp_seismic_opts: ['À confirmer', 'Requis', 'Non requis'],
    tp_message2: 'Salle triphasée : charge {kw} kW ({w} W), autonomie {m} min, alimentation {v}, dérivation de maintenance : {b}, ancrage sismique : {s}, gestion réseau : {n}.',
    tp_mon_yes: 'requise', tp_mon_no: 'non précisée',
    rl_summary: 'Vous remplacez un UPS? Partez de son modèle', rl_label: 'Modèle de votre UPS actuel', rl_ph: 'ex. SMT1500RM2U, 5PX1500RT, SU2200',
    rl_none: 'Ce code n’est pas dans notre catalogue. Tapez le modèle tel qu’il figure sur l’étiquette, ou décrivez votre besoin ci-dessous.',
    rl_disc: 'discontinué', rl_succ: 'modèle actuel : {s}', rl_use: 'Trouver un remplacement', rl_batt: 'Batteries de remplacement',
    rl_set: 'Point de départ : {m}. Charge réglée à 80 % de sa puissance ({w} W); entrez votre charge réelle si vous la connaissez.',
    rtc_title: 'Autonomie selon la charge (tableau du fabricant)', rtc_x: 'Charge (W)', rtc_internal: 'batteries internes', rtc_packs: '+{n} bloc(s)-batteries', rtc_you: 'votre charge', rtc_need: 'votre autonomie',
    grow_label: 'Marge de croissance', grow_done: 'Ajout de {p} % pour la croissance : {w} W.',
    show_more: 'Afficher {n} autres solutions à examiner',
    cart_runtime_short: 'Cette configuration n’atteint pas l’autonomie demandée. Choisissez plus de blocs-batteries ou demandez une soumission.',
    cart_runtime_unknown: 'L’autonomie de cette configuration reste à confirmer. Ajoutez-la à la soumission pour vérification.',
    cart_card_unknown: 'Aucune carte réseau compatible n’est confirmée pour cette configuration. Demandez une vérification technique.',
    outlet_unknown_hold: 'Confirmez votre prise d’alimentation avant de commander.',
    hardwired_hold: 'Le raccordement fixe nécessite une vérification technique avant commande.',
    cart_stale: 'Le panier contient une ancienne configuration. Vérifiez vos besoins et le panier avant toute commande.',
    input_hold_title: 'Une valeur enregistrée demande votre choix.',
    input_hold_url: 'Le lien contient une valeur non reconnue pour {field} : « {raw} ». Confirmez une valeur ou retirez cette réponse.',
    input_hold_saved: 'Valeur enregistrée non reconnue pour {field} : « {raw} ». Confirmez une valeur ou retirez cette ligne.',
    input_hold_qty: 'Entrez un nombre entier supérieur à zéro pour le nombre de systèmes identiques.',
    input_hold_blocked: 'Confirmez ou retirez les valeurs signalées avant de continuer.',
    input_hold_choose: 'Choisissez une valeur', input_hold_remove: 'Retirer cette réponse non reconnue',
    input_hold_yes: 'Oui', input_hold_no: 'Non',
    input_hold_equipment: 'Matériel demandé : {model}.',
    input_hold_saved_rows: '{n} ligne(s) enregistrée(s) nécessitent une correction ci-dessous.',
    input_field_load: 'la charge', input_field_runtime: 'l’autonomie', input_field_power: 'l’alimentation',
    input_field_outlet: 'la prise', input_field_fit: 'le montage', input_field_rackU: 'l’espace en baie',
    input_field_depth: 'la profondeur', input_field_generator: 'la génératrice',
    input_field_gen: 'la génératrice',
    input_field_card: 'la gestion réseau', input_field_chemistry: 'la chimie des batteries',
    input_field_plugNeed: 'la fiche d’entrée UPS', input_field_qty: 'la quantité',
    input_field_monitorWatts: 'la mesure des watts', input_field_shutdownNeed: 'l’arrêt à distance',
    input_field_shutdownPlatform: 'le système d’exploitation ou la plateforme',
    card_selected: 'carte réseau ajoutée',
    quote_card_included: 'Carte réseau comprise avec cet onduleur; aucune carte supplémentaire ajoutée.',
    quote_card_separate_selected: 'Carte réseau vendue séparément : {model} choisie pour chaque système.',
    quote_card_separate_none: 'Carte réseau vendue séparément; aucune carte choisie.',
    quote_card_unknown: 'Carte réseau comprise ou vendue séparément : à confirmer; aucune carte supplémentaire ajoutée automatiquement.',
    quote_card_unknown_selected: 'Statut de la carte réseau à confirmer; carte supplémentaire {model} demandée pour examen technique.',
    rack_limit: 'baie de {u}U maximum', depth_limit: 'profondeur de {d} po maximum',
    quote_runtime_meets: 'autonomie demandée atteinte', quote_runtime_short: 'autonomie demandée non atteinte',
    quote_runtime_unknown: 'autonomie à confirmer',
    cart_unavailable: 'Un article n’est plus disponible en ligne. Ajoutez cette solution à la soumission.',
    cart_quote_only: 'Le prix actuel exige une soumission. Vérifiez le nouveau total ci-dessus.',
    cart_price_changed: 'Le prix a changé. Vérifiez le nouveau total, puis ajoutez la solution de nouveau.',
    cart_configuration_changed: 'Votre configuration a changé pendant la vérification des produits. Vérifiez la sélection actuelle, puis ajoutez-la de nouveau. Rien n’a été ajouté au panier.',
    cart_error: 'Impossible de vérifier le panier. Réessayez ou ajoutez la solution à la soumission.',
    cart_product_error: 'Impossible de vérifier le prix et la disponibilité actuels. Aucun ajout au panier n’a été tenté; ajoutez la configuration à la soumission ou réessayez plus tard.',
    cart_variant_ambiguous: 'Ce produit a plusieurs variantes. Nous ne pouvons pas confirmer laquelle correspond à votre sélection; aucun article ajouté au panier. Ajoutez la configuration à la soumission pour vérifier la variante exacte.',
    cart_submit_uncertain: 'Le panier n’a pas confirmé cet ajout. Vérifiez le panier avant de réessayer pour éviter un doublon, ou ajoutez la configuration à la soumission.',
    quote_save_limited: 'Votre liste de soumission reste disponible dans cet onglet, mais cet appareil ne peut pas l’enregistrer pour une prochaine visite.',
    index_error: 'Impossible de charger les données des onduleurs. Vos choix sont conservés sur cette page. Réessayez ou ajoutez vos besoins à la liste de soumission.',
    index_retry: 'Réessayer le chargement des onduleurs',
    packs_selected: '{n} bloc(s)-batteries dans cette configuration',
    packs_none: '0 bloc-batteries sélectionné',
    packs_available: '{n} modèle(s) compatible(s) disponible(s)',
    packs_missing: '{n} bloc(s)-batteries sélectionné(s) : modèle enregistré indisponible, à confirmer',
    reconfirm_saved: 'Options enregistrées à confirmer de nouveau (catalogue modifié) : {k}.',
    saved_missing: 'Un accessoire enregistré ({h}) n’est plus dans la liste compatible. Choisissez un remplacement ou retirez-le.',
    saved_included_card: 'NETWORK-M3 est déjà comprise avec cet onduleur. La carte supplémentaire enregistrée doit être examinée; elle n’est ni ajoutée ni facturée.',
    saved_discard: 'Retirer l’option enregistrée : {k}',
    saved_discard_pack: 'Retirer la demande enregistrée de {n} bloc(s)-batteries',
    saved_discard_included_card: 'Utiliser la carte NETWORK-M3 incluse; retirer la carte supplémentaire enregistrée',
    saved_discard_done: 'Option enregistrée retirée après examen.',
    saved_review_title: 'Configurations enregistrées à vérifier',
    saved_review_intro: 'Ces choix enregistrés sont séparés des solutions classées ci-dessous. Vérifiez-les avant toute commande.',
    saved_review_below: 'Configuration enregistrée hors des 12 premières solutions classées. Sa présence ici ne change pas son rang.',
    saved_review_filtered: 'Cet onduleur ne figure pas dans les résultats selon vos besoins actuels. Cela ne prouve pas qu’il est incompatible; ses caractéristiques doivent être vérifiées.',
    saved_review_missing: 'Cet onduleur enregistré ne figure pas dans les données actuelles du configurateur. Conservez-le dans votre demande pour faire vérifier le modèle exact, sa compatibilité et sa disponibilité.',
    saved_review_current: 'Besoins actuellement indiqués : {a}',
    saved_review_pack: '{n} bloc(s)-batteries demandé(s) : {h}',
    saved_review_component: '{k} enregistré : {h}',
    saved_review_unresolved: '{k} enregistré : modèle exact à confirmer',
    saved_review_legacy: '{k} enregistré dans un ancien lien : identité exacte à confirmer',
    saved_review_requirements: 'Vérifier les besoins',
    saved_review_remove: 'Retirer cette configuration enregistrée',
    saved_review_quote: 'Ajouter cette demande à la soumission pour vérification',
    saved_review_quote_one: 'Demande enregistrée à vérifier. Matériel demandé : {model}. {note}',
    saved_review_quote_many: '{n} demandes identiques enregistrées à vérifier. Matériel demandé pour chacune : {model}. {note}',
    saved_review_qty: 'Nombre de demandes identiques',
    saved_review_quote_note: 'Cette configuration enregistrée n’a pas été vérifiée selon vos réponses actuelles. La compatibilité, l’autonomie, le prix et la disponibilité restent à vérifier.',
    saved_review_removed: 'Configuration enregistrée retirée du lien. Les autres choix et la liste de soumission sont conservés.',
    saved_review_bad: 'Ce lien de configuration enregistrée est incomplet ou ambigu. Aucun composant de ce lien n’a été sélectionné. Vérifiez vos besoins avant de continuer.',
    saved_review_bad_remove: 'Retirer le lien enregistré illisible',
    quote_review: 'Voir la liste de soumission ({n})',
    quote_added: 'Ajouté à la liste de soumission ({n}).',
    quote_added_visit: 'Ajouté pour cette visite ({n}); l’enregistrement sur cet appareil est indisponible.',
    quote_qty: 'Nombre de solutions identiques',
    quote_qty_invalid: 'Entrez un nombre entier supérieur à zéro.',
    quote_remove: 'Retirer la solution',
    quote_one: '1 solution. Elle comprend : {model}',
    quote_many: '{n} solutions identiques. Chacune comprend : {model}',
    quote_estimate_current: 'Prix estimé selon notre catalogue',
    quote_estimate_nocross: 'Les prix sont dans des devises différentes ou non vérifiées; aucun total combiné. Demandez une soumission',
    current_store_prices: 'Prix du jour en {cur} : {lines}.',
    quote_estimate_saved: 'Prix enregistré lors d’une visite précédente',
    check_prices: 'Vérifier les prix actuels',
    check_prices_busy: 'Vérification…',
    check_prices_done: 'Prix actuels vérifiés à {time} ({cur}). Les prix peuvent changer avant le paiement.',
    check_prices_fail: 'Prix actuels indisponibles pour cette configuration.',
    check_why_unavailable: 'Un article est indisponible ou son prix n’a pas pu être lu.',
    check_why_variant: 'Un article existe en plusieurs variantes; nous confirmerons la bonne avec vous.',
    check_why_variant_changed: 'La variante enregistrée dans cette configuration n’est plus offerte.',
    check_why_currency: 'La devise du magasin n’a pas pu être lue.',
    check_why_currency_drift: 'La devise du magasin a changé pendant la vérification.',
    check_why_changed: 'La ligne enregistrée a changé pendant la vérification. Réessayez.',
    check_why_amount: 'Le total dépasse la plage de calcul sûre. Demandez une soumission.',
    check_why_failed: 'La vérification n’a pas pu être complétée. Réessayez ou demandez une soumission.',
    quote_estimate_lines: 'Articles par système : {lines}',
    quote_estimate_totals: '{per} par système; {n} système(s) : {total}',
    quote_estimate_unknown: 'Prix complet à confirmer; aucun total établi',
    quote_estimate_disclaimer: 'Prix, disponibilité, taxes et livraison à confirmer.',
    quote_estimate_legacy: 'Prix de cette demande à confirmer.',
    gxt5_adapter: 'Entrée native NEMA L5-20P; adaptateur 5-20P inclus selon le fabricant. Confirmez la prise du site.',
    quote_updated: 'Quantité de solutions mise à jour.',
    quote_changed: 'Quantité modifiée pour cette visite; l’enregistrement sur cet appareil est indisponible.',
    quote_removed: 'Solution retirée de la liste de soumission.',
    quote_cleared: 'Liste de soumission vidée.',
    check_build: 'Faire vérifier cette solution par un spécialiste UPB',
    check_build_line: 'Demande de vérification de solution',
    check_build_added: 'Ajoutée pour vérification. Envoyez-la depuis la liste de soumission.',
    price_note: 'CAD, avant taxes. Livraison calculée au paiement. Installation non incluse.',
    rt_note: 'Batteries neuves à environ 25 °C; moins dans une pièce chaude et à mesure que les batteries vieillissent.',
    near_capacity: 'Près de la capacité : {p} % de la puissance de cet UPS. Sous 80 %, il reste de la marge.',
    outlets: 'Prises de sortie : {rec}',
    tp_kw: 'Charge totale (kW)', tp_kw_blank: 'à confirmer',
    tp_message3: 'Salle triphasée : charge {kw}, autonomie {m} min, alimentation {v}, dérivation de maintenance : {b}, ancrage sismique : {s}, gestion réseau : {n}.',
    quote_transfer_continue: 'Continuer la demande de soumission',
    quote_transfer_review: 'Vérifier le texte de la demande',
    quote_transfer_too_long: 'La demande dépasse 8 000 caractères. Copiez le texte, divisez la demande ou collez une version raccourcie dans le formulaire de soumission.',
    quote_transfer_unavailable: 'Le transfert de cette longue demande est indisponible sur cet appareil. Copiez le texte et collez-le dans le formulaire de soumission.',
    quote_transfer_manual_full: 'Ouvrir le formulaire de soumission pour coller ce texte',
    quote_transfer_manual_short: 'Ouvrir le formulaire de soumission pour coller un texte raccourci',
    req_intro_lithium: 'Des batteries au lithium sont requises. Nous devons confirmer une configuration qui respecte cette exigence et vos autres besoins.',
    req_intro_discuss: 'Vous souhaitez choisir la technologie des batteries avec nous. Cette demande doit être vérifiée par un spécialiste.',
    req_intro_plug: 'Votre exigence de fiche d’entrée UPS précise doit être vérifiée avec la configuration complète.',
    req_secondary: 'La technologie des batteries de l’UPS et des blocs externes, la compatibilité, l’autonomie et la disponibilité seront vérifiées.',
    req_intro_monitoring: 'Vos fonctions de surveillance ou d’arrêt demandées exigent une vérification technique de la configuration exacte.',
    req_secondary_monitoring: 'La mesure des watts, le mode d’arrêt, la plateforme et les fonctions du modèle exact seront vérifiés. Une carte réseau seule ne confirme pas ces fonctions.',
    req_add: 'Ajouter les besoins à la liste de soumission',
    req_already: 'Ces besoins figurent déjà dans la liste.',
    req_label: 'Configuration à confirmer : aucun produit sélectionné.',
    req_one: '1 système demandé. Exigences pour ce système : {facts}',
    req_many: '{n} systèmes identiques demandés. Exigences pour chacun : {facts}',
    req_qty: 'Nombre de systèmes identiques demandés',
    req_remove: 'Retirer ces besoins',
    req_load: '{w} W par système', req_load_tbc: 'charge à confirmer',
    req_runtime: 'au moins {m} min', req_runtime_tbc: 'autonomie demandée à confirmer',
    req_lithium: 'batteries au lithium requises', req_discuss: 'technologie des batteries à choisir ensemble',
    req_chem_unspecified: 'aucune technologie de batterie précisée',
    req_power_unknown: 'tension à confirmer', req_power_three: 'alimentation triphasée',
    req_plug: 'fiche {p} exigée', req_hardwired: 'raccordement fixe exigé',
    req_outlet: 'prise murale {o}', req_outlet_unknown: 'prise murale à confirmer',
    req_card: 'gestion réseau requise', req_card_no: 'gestion réseau non demandée',
    req_watts: 'requis : mesure des watts; fonction à confirmer',
    req_shutdown_safe: 'requis : arrêt sécuritaire des ordinateurs ou serveurs sous {platform}; fonction à confirmer',
    req_shutdown_power: 'requis : coupure à distance des sorties UPS; fonction à confirmer',
    req_shutdown_both: 'requis : arrêt sécuritaire des ordinateurs ou serveurs sous {platform} et coupure à distance des sorties UPS; fonctions à confirmer',
    req_shutdown_help: 'mode d’arrêt à choisir avec un spécialiste; fonctions à confirmer',
    req_shutdown_platform_tbc: 'système d’exploitation ou plateforme à confirmer',
    req_shutdown_mode_tbc: 'mode d’arrêt à confirmer pour la plateforme {platform}',
    req_models: 'modèles UPS et blocs externes, quantités, compatibilité, autonomie et disponibilité à confirmer',
    req_prior_unchecked: 'Les solutions déjà enregistrées n’ont pas été vérifiées selon ces nouveaux besoins.',
    req_not_in_list: 'Ajoutez vos besoins actuels à la liste avant de continuer.',
    req_invalid: 'Vérifiez {field} : entrez un nombre valide avant d’ajouter ces besoins ou de continuer.',
    req_platform_invalid: 'Vérifiez la plateforme : utilisez au maximum 120 caractères sans retour à la ligne.',
    req_snapshot_hold: 'Corrigez la réponse indiquée dans le formulaire avant d’enregistrer ces besoins.',
    req_field_load: 'la charge', req_field_runtime: 'l’autonomie',
    req_field_rackU: 'l’espace libre en U', req_field_depth: 'la profondeur maximale',
    req_depth_limit: 'profondeur maximale {d} po',
    req_header: 'Demande du configurateur :',
    req_mixed: 'Les solutions enregistrées auparavant sont distinctes et ne sont pas vérifiées selon les besoins à confirmer.',
    req_locale_link: 'Read this request in English',
    candidate_title: 'Configuration proposée pour examen',
    candidate_intro: 'Eaton 9PX1500RTN-L avec un module externe au lithium 9PXEBM48RT-L par système. La carte réseau NETWORK-M3 est incluse dans l’onduleur.',
    candidate_one: '1 système : 1 onduleur et 1 module de batteries externe.',
    candidate_many: '{n} systèmes identiques : {n} onduleurs et {n} modules de batteries externes.',
    candidate_space: 'Équipement : 3U. Profondeur approximative : 17,7 po pour l’onduleur et 17,6 po pour le module. Le dégagement nécessaire dans la baie reste à confirmer.',
    candidate_disclosure: 'Les données du graphique du fabricant appuient votre objectif d’autonomie. La disponibilité des systèmes complets, la compatibilité de l’installation et le prix final restent à confirmer.',
    candidate_evidence: 'Pourquoi cette configuration est proposée',
    candidate_runtime: 'Pour {w} W et un objectif de {target} min, le point publié à {gw} W indique {gm} min avec un module externe. Nous utilisons ce point de charge supérieure et tenons compte d’une variation d’environ 15 % pour cet examen. Ce n’est ni une mesure exacte à {w} W ni une garantie d’autonomie.',
    candidate_source: 'Voir le graphique d’autonomie Eaton',
    candidate_add: 'Inclure cette configuration dans ma demande de soumission',
    candidate_remove: 'Retirer la configuration proposée',
    candidate_save_first: 'Enregistrez d’abord vos besoins dans la liste de soumission.',
    candidate_selected: 'Configuration proposée ajoutée à vos besoins; achat et disponibilité à confirmer.',
    candidate_unselected: 'Configuration proposée retirée; vos besoins restent enregistrés.',
    req_candidate_label: 'Besoins à confirmer : configuration proposée ajoutée pour examen.',
    candidate_revision: 'Sources du fabricant vérifiées : RD.04 v1, 2026-09-27.',
    candidate_quote_ref: 'Référence de preuve : RD.04 v1 (2026-09-27), graphique Eaton 9PX1500RTN-L avec un module externe : https://eg.eaton.com/ups-battery-runtime/en-us/9PX1500RTN-L',
    fit_supported: 'Autonomie demandée appuyée par cette configuration; vérifiez les détails d’installation ci-dessous.',
    fit_review: 'Certains détails de compatibilité ou d’autonomie restent à vérifier pour votre installation. Comparez cette option ou ajoutez-la à votre demande de soumission.',
    fit_runtime_short: 'Les blocs-batteries sélectionnés n’atteignent pas l’autonomie demandée.',
    fit_card_needed: 'La carte réseau requise n’est pas sélectionnée dans cette configuration.',
    fit_runtime_card: 'Les blocs-batteries sélectionnés n’atteignent pas l’autonomie demandée et la carte réseau requise n’est pas sélectionnée.',
    fit_card_inclusion_review: 'La présence d’une carte réseau avec cet onduleur doit être confirmée avant la commande. Demandez une soumission technique.',
    fit_wrong_outlet: 'La fiche d’entrée ne correspond pas à la prise indiquée.',
    physical_mounting: 'Choisissez une installation en baie ou en tour pour vérifier l’espace indiqué.',
    physical_tower_unsupported: 'Un élément choisi ne permet pas une installation en tour.',
    physical_u_over: 'Nécessite au moins {u}U; vous avez indiqué {available}U disponibles.',
    physical_u_over_exact: 'Nécessite {u}U; vous avez indiqué {available}U disponibles.',
    physical_u_total: 'Configuration choisie : {u}U sur {available}U disponibles.',
    physical_u_unlimited: 'Configuration choisie : {u}U; espace disponible à préciser.',
    physical_u_min: 'Espace connu : au moins {u}U; total à confirmer.',
    physical_depth_over: 'Profondeur installée : au moins {d} po; limite indiquée : {available} po.',
    physical_depth_total: 'Profondeur installée requise : {d} po.',
    physical_depth_min: 'Profondeur connue : au moins {d} po; dégagement installé à confirmer.',
    physical_missing: '{handle} ({n}) : {fact} à confirmer.',
    physical_review: 'L’encombrement de la configuration choisie doit être vérifié avant commande.',
    physical_confirm: 'Confirmez l’espace en baie ou en tour avant de commander : les dimensions de cette configuration ne sont pas encore vérifiées.',
    physical_per_system: 'Encombrement pour chaque système :',
    physical_fact_selected_pack: 'modèle de bloc-batteries',
    physical_fact_bundle_components: 'contenu physique de l’offre groupée',
    physical_fact_rack_role: 'rôle de montage en baie',
    physical_fact_rack_u: 'hauteur en baie',
    physical_fact_rack_enclosure_handles: 'relation exacte avec le boîtier choisi',
    physical_fact_rack_depth_role: 'rôle du dégagement',
    physical_fact_rack_installed_depth_in: 'profondeur installée',
    physical_fact_tower_role: 'montage en tour',
    physical_fact_tower_enclosure_handles: 'emplacement de la carte interne dans ce modèle et quantité de carte prise en charge',
    physical_fact_tower_selected_ups_handles: 'relation exacte entre le bloc-batterie et cet onduleur, pour un seul bloc en tour',
    bundle_review: 'Le fabricant décrit le contenu de ce lot. Vérifiez le contenu de l’offre UPB actuelle, l’autonomie, le branchement et l’installation. Ajoutez sa référence exacte à la soumission.',
    bundle_quote_review: 'Lot précis à vérifier : contenu de l’offre UPB actuelle, autonomie, branchement et installation non confirmés.',
    bundle_source_heading: 'Description du lot par le fabricant (liste de février 2026)',
    bundle_source_offer_hold: 'Le contenu de l’offre UPB actuelle reste à confirmer; ces composants décrits ne sont pas facturés une seconde fois.',
    bundle_source_unavailable: 'Description du lot du fabricant indisponible; contenu à confirmer.',
    bundle_source_stale: 'La source du lot a changé ou manque; reconfirmez les composants avant de traiter cette demande.',
    bundle_component_ups_power_module: 'module onduleur',
    bundle_component_battery_module: 'module de batteries',
    bundle_component_battery_class: 'module de batteries (classe {u}U; modèle exact à confirmer)',
    bundle_component_four_post_rail_kit: 'ensemble(s) de rails pour baie à quatre montants (modèle à confirmer)',
    bundle_component_bypass: 'module de dérivation',
    bundle_component_transformer: 'transformateur d’isolement',
    bundle_component_adapter: 'adaptateur(s) (code exact à confirmer)',
    bundle_component_line_cord: 'cordon d’alimentation',
    bundle_component_Tower_Stands: 'supports de tour (quantité non précisée)',
    bundle_component_Software: 'logiciel (quantité non précisée)',
    bundle_runtime_reference: 'Référence du fabricant : {m} min à {w} W avec un bloc {pack}, à une sortie de 240 V. L’estimation ne confirme pas l’offre UPB ni l’installation.',
    bundle_runtime_output_hold: 'L’autonomie doit être vérifiée selon votre charge et votre tension de sortie. Ajoutez cette configuration à votre demande de soumission pour vérification.',
    bundle_runtime_transformer_hold: 'Le transformateur peut modifier l’autonomie des batteries. Ajoutez cette configuration à votre demande de soumission pour faire vérifier le système complet.',
    bundle_runtime_load_hold: 'Votre charge est hors des points d’autonomie disponibles pour cette configuration. Envoyez une demande de soumission pour obtenir de l’aide à choisir un système adapté.',
    bundle_runtime_source_hold: 'Nous ne pouvons pas encore associer cette configuration aux bonnes données d’autonomie. Ajoutez-la à votre demande de soumission pour vérification.',
    bundle_saved_pack: 'Demande enregistrée : {n} bloc(s)-batteries du modèle {h}. Conservée pour examen technique; aucun bloc supplémentaire ajouté ni facturé.',
    bundle_saved_addon: 'Demande enregistrée : {k} {h}. Conservée pour examen technique; article non ajouté ni facturé.',
    bundle_saved_reconfirm: 'Les accessoires enregistrés doivent être examinés avant de configurer cette offre groupée.',
    bundle_no_extra: 'Aucun bloc supplémentaire sélectionné; contenu de l’offre groupée à confirmer.'
  } : {
    count: 'Showing {shown} of {total} options to review',
    jump: 'See the {n} options',
    addon_why: 'Listed by the manufacturer for this model',
    tp_volt: 'Supply voltage', tp_volt_opts: ['Not sure', '208 V (120/208 V wye)', '480 V', '600 V'],
    tp_bypass: 'Maintenance bypass', tp_bypass_opts: ['Help me decide', 'Needed', 'Not needed'],
    tp_seismic: 'Seismic anchoring', tp_seismic_opts: ['Not sure', 'Required', 'Not required'],
    tp_message2: 'Three-phase room: load {kw} kW ({w} W), runtime {m} min, supply {v}, maintenance bypass: {b}, seismic anchoring: {s}, network monitoring: {n}.',
    tp_mon_yes: 'required', tp_mon_no: 'not specified',
    rl_summary: 'Replacing a UPS? Start from its model', rl_label: 'Model of your current UPS', rl_ph: 'e.g. SMT1500RM2U, 5PX1500RT, SU2200',
    rl_none: 'That code is not in our catalogue. Type the model as printed on its label, or describe your needs below.',
    rl_disc: 'discontinued', rl_succ: 'current model: {s}', rl_use: 'Find replacements', rl_batt: 'Replacement batteries',
    rl_set: 'Starting point: {m}. Load set to 80 % of its rating ({w} W); enter your real load if you know it.',
    rtc_title: 'Runtime by load (maker table)', rtc_x: 'Load (W)', rtc_internal: 'internal batteries', rtc_packs: '+{n} battery pack(s)', rtc_you: 'your load', rtc_need: 'your runtime',
    grow_label: 'Room to grow', grow_done: 'Added {p} % for growth: {w} W.',
    show_more: 'Show {n} more options to review',
    cart_runtime_short: 'This setup does not meet your requested runtime. Choose more battery packs or add it to your quote list.',
    cart_runtime_unknown: 'Runtime for this setup is unconfirmed. Add it to your quote list for a technical check.',
    cart_card_unknown: 'No compatible network card is confirmed for this setup. Request a technical check.',
    outlet_unknown_hold: 'Confirm your power outlet before ordering.',
    hardwired_hold: 'Hardwired connection needs a technical check before ordering.',
    cart_stale: 'The cart contains an earlier configuration. Review your requirements and cart before ordering.',
    input_hold_title: 'A saved value needs your choice.',
    input_hold_url: 'The link contains an unrecognized value for {field}: “{raw}”. Confirm a value or remove this answer.',
    input_hold_saved: 'Unrecognized saved value for {field}: “{raw}”. Confirm a value or remove this row.',
    input_hold_qty: 'Enter a whole number greater than zero for identical systems.',
    input_hold_blocked: 'Confirm or remove the flagged values before continuing.',
    input_hold_choose: 'Choose a value', input_hold_remove: 'Remove this unrecognized answer',
    input_hold_yes: 'Yes', input_hold_no: 'No',
    input_hold_equipment: 'Requested equipment: {model}.',
    input_hold_saved_rows: '{n} saved row(s) need correction below.',
    input_field_load: 'load', input_field_runtime: 'runtime', input_field_power: 'supply',
    input_field_outlet: 'outlet', input_field_fit: 'mounting', input_field_rackU: 'rack space',
    input_field_depth: 'depth', input_field_generator: 'generator',
    input_field_gen: 'generator',
    input_field_card: 'network management', input_field_chemistry: 'battery chemistry',
    input_field_plugNeed: 'UPS input plug', input_field_qty: 'quantity',
    input_field_monitorWatts: 'measured watts', input_field_shutdownNeed: 'remote shutdown',
    input_field_shutdownPlatform: 'operating system or platform',
    card_selected: 'network card added',
    quote_card_included: 'Network card included with this UPS; no extra card added.',
    quote_card_separate_selected: 'Network card sold separately: {model} selected for each system.',
    quote_card_separate_none: 'Network card sold separately; no card selected.',
    quote_card_unknown: 'Whether a network card is included or sold separately needs confirmation; no extra card was added automatically.',
    quote_card_unknown_selected: 'Network-card inclusion needs confirmation; extra {model} requested for technical review.',
    rack_limit: 'rack limit {u}U', depth_limit: 'depth limit {d} in',
    quote_runtime_meets: 'requested runtime met', quote_runtime_short: 'requested runtime not met',
    quote_runtime_unknown: 'runtime to confirm',
    cart_unavailable: 'An item is no longer available online. Add this solution to your quote list.',
    cart_quote_only: 'The current price requires a quote. Check the updated total above.',
    cart_price_changed: 'The price changed. Check the updated total, then add the solution again.',
    cart_configuration_changed: 'Your configuration changed while we checked the products. Review the current selection, then add it again. Nothing was added to the cart.',
    cart_error: 'Could not verify the cart. Try again or add this solution to your quote list.',
    cart_product_error: 'We could not verify current price and availability. No cart add was attempted. Add this configuration to your quote list or try again later.',
    cart_variant_ambiguous: 'This product has multiple variants. We cannot confirm which one matches your selection; nothing was added to the cart. Add this configuration to your quote list to verify the exact variant.',
    cart_submit_uncertain: 'The cart did not confirm this add. Check the cart before trying again to avoid a duplicate, or add the configuration to your quote list.',
    quote_save_limited: 'Your quote list remains available in this tab, but this device cannot save it for a future visit.',
    index_error: 'We could not load the UPS data. Your choices remain on this page. Try again, or add your requirements to the quote list.',
    index_retry: 'Try loading UPS data again',
    packs_selected: '{n} battery pack(s) in this configuration',
    packs_none: '0 battery packs selected',
    packs_available: '{n} compatible model(s) available',
    packs_missing: '{n} battery pack(s) selected: saved pack model unavailable, reconfirm',
    reconfirm_saved: 'Saved add-on choices need reconfirmation (catalogue changed): {k}.',
    saved_missing: 'A saved accessory ({h}) is no longer in the compatible list. Choose a replacement or remove it.',
    saved_included_card: 'NETWORK-M3 is already included in this UPS. The saved extra card needs review; it is neither added nor charged.',
    saved_discard: 'Remove saved {k} choice',
    saved_discard_pack: 'Remove saved battery pack request ({n})',
    saved_discard_included_card: 'Use included NETWORK-M3; remove saved extra card',
    saved_discard_done: 'Saved choice removed after review.',
    saved_review_title: 'Saved configurations to review',
    saved_review_intro: 'These saved choices are separate from the ranked solutions below. Review them before any purchase.',
    saved_review_below: 'Saved configuration outside the first 12 ranked solutions. Showing it here does not change its rank.',
    saved_review_filtered: 'This UPS is not shown for your current requirements. That does not prove incompatibility; its fit needs a technical check.',
    saved_review_missing: 'This saved UPS is not in the current Builder data. Keep it in your request so we can check the exact model, fit and availability.',
    saved_review_current: 'Current requirements shown: {a}',
    saved_review_pack: '{n} battery pack(s) requested: {h}',
    saved_review_component: 'Saved {k}: {h}',
    saved_review_unresolved: 'Saved {k}: exact model to confirm',
    saved_review_legacy: 'Saved {k} from an older link: exact identity to confirm',
    saved_review_requirements: 'Review requirements',
    saved_review_remove: 'Remove this saved configuration',
    saved_review_quote: 'Add this request to quote list for review',
    saved_review_quote_one: 'Saved request for technical review. Requested equipment: {model}. {note}',
    saved_review_quote_many: '{n} identical saved requests for technical review. Requested equipment for each: {model}. {note}',
    saved_review_qty: 'Number of identical requests',
    saved_review_quote_note: 'This saved configuration has not been checked against your current answers. Compatibility, runtime, price and availability need review.',
    saved_review_removed: 'Saved configuration removed from this link. Other choices and the quote list are unchanged.',
    saved_review_bad: 'This saved configuration link is incomplete or ambiguous. No component from that link was selected. Review your requirements before continuing.',
    saved_review_bad_remove: 'Discard unreadable saved link',
    quote_review: 'Review quote ({n})',
    quote_added: 'Added to quote list ({n}).',
    quote_added_visit: 'Added for this visit ({n}); saving on this device is unavailable.',
    quote_qty: 'Number of identical solutions',
    quote_qty_invalid: 'Enter a whole number greater than zero.',
    quote_remove: 'Remove solution',
    quote_one: '1 solution. It includes: {model}',
    quote_many: '{n} identical solutions. Each includes: {model}',
    quote_estimate_current: 'Estimated price from our catalogue',
    quote_estimate_nocross: 'Prices are in different or unverified currencies; no combined total. Request a quote',
    current_store_prices: 'Today’s store prices in {cur}: {lines}.',
    quote_estimate_saved: 'Price saved on an earlier visit',
    check_prices: 'Check current prices',
    check_prices_busy: 'Checking…',
    check_prices_done: 'Current prices checked at {time} ({cur}). Prices can change before checkout.',
    check_prices_fail: 'Current prices are unavailable for this configuration.',
    check_why_unavailable: 'An item is unavailable or its price could not be read.',
    check_why_variant: 'An item has multiple variants; we will confirm the right one with you.',
    check_why_variant_changed: 'The saved product variant is no longer offered.',
    check_why_currency: 'The store currency could not be read.',
    check_why_currency_drift: 'The store currency changed during the check.',
    check_why_changed: 'The saved row changed during the check. Please try again.',
    check_why_amount: 'The total exceeds the safe calculation range. Request a quote.',
    check_why_failed: 'The check could not be completed. Please try again or request a quote.',
    quote_estimate_lines: 'Items per system: {lines}',
    quote_estimate_totals: '{per} per system; {n} system(s): {total}',
    quote_estimate_unknown: 'Complete price to confirm; no total established',
    quote_estimate_disclaimer: 'Price, availability, tax and shipping to confirm.',
    quote_estimate_legacy: 'Price for this request to confirm.',
    gxt5_adapter: 'Native NEMA L5-20P input; 5-20P adapter included by the manufacturer. Confirm the site outlet.',
    quote_updated: 'Solution quantity updated.',
    quote_changed: 'Quantity changed for this visit; saving on this device is unavailable.',
    quote_removed: 'Solution removed from quote list.',
    quote_cleared: 'Quote list cleared.',
    check_build: 'Have a UPB specialist check this build',
    check_build_line: 'Check my build request',
    check_build_added: 'Added for a check. Send it from the quote list.',
    price_note: 'CAD, before tax. Shipping calculated at checkout. Installation not included.',
    rt_note: 'New batteries at about 25 °C; less in a hot room and as batteries age.',
    near_capacity: 'Near capacity: {p} % of this UPS’s watt rating. Under 80 % leaves room to grow.',
    outlets: 'Output outlets: {rec}',
    tp_kw: 'Total load (kW)', tp_kw_blank: 'to confirm',
    tp_message3: 'Three-phase room: load {kw}, runtime {m} min, supply {v}, maintenance bypass: {b}, seismic anchoring: {s}, network monitoring: {n}.',
    quote_transfer_continue: 'Continue to quote request',
    quote_transfer_review: 'Review request text',
    quote_transfer_too_long: 'This request exceeds 8,000 characters. Copy the text, split the request, or paste a shorter version into the quote form.',
    quote_transfer_unavailable: 'Transfer of this long request is unavailable on this device. Copy the text and paste it into the quote form.',
    quote_transfer_manual_full: 'Open the quote form to paste this text',
    quote_transfer_manual_short: 'Open the quote form to paste a shorter request',
    req_intro_lithium: 'Lithium batteries are required. We need to confirm a configuration that meets this and your other requirements.',
    req_intro_discuss: 'You would like help choosing battery technology. A specialist needs to review this request.',
    req_intro_plug: 'Your exact UPS input-plug requirement needs a check against the whole configuration.',
    req_secondary: 'Battery technology for the UPS and any external packs, compatibility, runtime and availability will be checked.',
    req_intro_monitoring: 'Your requested monitoring or shutdown functions need a technical check of the exact setup.',
    req_secondary_monitoring: 'Measured watts, shutdown mode, platform and exact-model functions need checking. A network card alone does not confirm these functions.',
    req_add: 'Add requirements to quote list',
    req_already: 'These requirements are already in your quote list.',
    req_label: 'Configuration to confirm: no products selected.',
    req_one: '1 system requested. Requirements for it: {facts}',
    req_many: '{n} identical systems requested. Requirements for each: {facts}',
    req_qty: 'Number of identical systems requested',
    req_remove: 'Remove requirements',
    req_load: '{w} W per system', req_load_tbc: 'load to confirm',
    req_runtime: 'at least {m} min', req_runtime_tbc: 'requested runtime to confirm',
    req_lithium: 'lithium batteries required', req_discuss: 'battery technology to choose together',
    req_chem_unspecified: 'no battery technology specified',
    req_power_unknown: 'supply voltage to confirm', req_power_three: 'three-phase supply',
    req_plug: '{p} plug required', req_hardwired: 'hardwired connection required',
    req_outlet: '{o} wall outlet', req_outlet_unknown: 'wall outlet to confirm',
    req_card: 'network management required', req_card_no: 'network management not requested',
    req_watts: 'required: measured watts; capability to confirm',
    req_shutdown_safe: 'required: safe computer or server shutdown on {platform}; capability to confirm',
    req_shutdown_power: 'required: remotely switch UPS outputs off; capability to confirm',
    req_shutdown_both: 'required: safe computer or server shutdown on {platform} and remote UPS output power-off; capabilities to confirm',
    req_shutdown_help: 'shutdown mode to choose with a specialist; capabilities to confirm',
    req_shutdown_platform_tbc: 'operating system or platform to confirm',
    req_shutdown_mode_tbc: 'shutdown mode to confirm for platform {platform}',
    req_models: 'UPS and external-pack models, quantities, compatibility, runtime and availability to confirm',
    req_prior_unchecked: 'Previously saved solutions have not been checked against these new requirements.',
    req_not_in_list: 'Add your current requirements to the list before continuing.',
    req_invalid: 'Check {field}: enter a valid number before adding these requirements or continuing.',
    req_platform_invalid: 'Check the platform: use at most 120 characters without a line break.',
    req_snapshot_hold: 'Correct the highlighted answer in the form before saving these requirements.',
    req_field_load: 'load', req_field_runtime: 'runtime',
    req_field_rackU: 'rack space', req_field_depth: 'maximum depth',
    req_depth_limit: 'maximum depth {d} in',
    req_header: 'Builder request:',
    req_mixed: 'Previously saved solutions are separate and have not been checked against the requirements-only request.',
    req_locale_link: 'Lire cette demande en français',
    candidate_title: 'Technical candidate for review',
    candidate_intro: 'Eaton 9PX1500RTN-L with one external lithium-ion 9PXEBM48RT-L module per system. The NETWORK-M3 network card is included in the UPS.',
    candidate_one: '1 system: 1 UPS unit and 1 external battery module.',
    candidate_many: '{n} identical systems: {n} UPS units and {n} external battery modules.',
    candidate_space: 'Equipment height: 3U. Approximate depth: 17.7 in for the UPS and 17.6 in for the module. Required rack clearance still needs confirmation.',
    candidate_disclosure: 'Manufacturer graph data supports your runtime target. Availability for the complete systems, installation fit and final pricing still need confirmation.',
    candidate_evidence: 'Why this configuration is proposed',
    candidate_runtime: 'For {w} W and a {target} min target, the published point at {gw} W shows {gm} min with one external module. We use that higher-load point and allow about 15% variation for this review. This is neither an exact measurement at {w} W nor a runtime guarantee.',
    candidate_source: 'View Eaton runtime graph',
    candidate_add: 'Include this candidate in my quote request',
    candidate_remove: 'Remove proposed candidate',
    candidate_save_first: 'Save your requirements to the quote list first.',
    candidate_selected: 'Proposed candidate added to your requirements; purchase and availability remain unconfirmed.',
    candidate_unselected: 'Proposed candidate removed; your requirements remain saved.',
    req_candidate_label: 'Requirements to confirm: technical candidate included for review.',
    candidate_revision: 'Manufacturer sources checked: RD.04 v1, 2026-09-27.',
    candidate_quote_ref: 'Evidence reference: RD.04 v1 (2026-09-27), Eaton 9PX1500RTN-L one-EBM graph: https://eg.eaton.com/ups-battery-runtime/en-us/9PX1500RTN-L',
    fit_supported: 'This configuration supports your runtime target; check the installation details below.',
    fit_review: 'Some fit or runtime details still need checking for your site. Compare this option or add it to your quote request.',
    fit_runtime_short: 'The selected battery packs do not meet your runtime target.',
    fit_card_needed: 'The required network card is not selected in this configuration.',
    fit_runtime_card: 'The selected battery packs do not meet your runtime target, and the required network card is not selected.',
    fit_card_inclusion_review: 'Whether a network card comes with this UPS needs confirmation before ordering. Request a technical quote.',
    fit_wrong_outlet: 'The UPS input plug does not match your stated outlet.',
    physical_mounting: 'Choose rack or tower installation to check the space you entered.',
    physical_tower_unsupported: 'A selected component does not support tower installation.',
    physical_u_over: 'Requires at least {u}U; you entered {available}U available.',
    physical_u_over_exact: 'Requires {u}U; you entered {available}U available.',
    physical_u_total: 'Selected setup: {u}U of {available}U available.',
    physical_u_unlimited: 'Selected setup: {u}U; available rack space not specified.',
    physical_u_min: 'Known space: at least {u}U; total to confirm.',
    physical_depth_over: 'Installed depth: at least {d} in; your limit is {available} in.',
    physical_depth_total: 'Required installed depth: {d} in.',
    physical_depth_min: 'Known depth: at least {d} in; installed clearance to confirm.',
    physical_missing: '{handle} ({n}): {fact} to confirm.',
    physical_review: 'The selected setup needs a physical-fit check before ordering.',
    physical_confirm: 'Confirm your rack or tower space before ordering: the dimensions of this setup are not verified yet.',
    physical_per_system: 'Physical space for each system:',
    physical_fact_selected_pack: 'battery pack model',
    physical_fact_bundle_components: 'physical bundle contents',
    physical_fact_rack_role: 'rack mounting role',
    physical_fact_rack_u: 'rack height',
    physical_fact_rack_enclosure_handles: 'exact relation to a selected enclosure',
    physical_fact_rack_depth_role: 'clearance role',
    physical_fact_rack_installed_depth_in: 'installed depth',
    physical_fact_tower_role: 'tower mounting',
    physical_fact_tower_enclosure_handles: 'internal card fit in this exact model and supported card quantity',
    physical_fact_tower_selected_ups_handles: 'exact battery-pack pairing with this UPS and one-pack tower support',
    bundle_review: 'The manufacturer describes this bundle’s contents. Confirm the current UPB offer, runtime, connection and installation. Add its exact SKU to your quote list.',
    bundle_quote_review: 'Exact bundle to review: current UPB offer contents, runtime, connection and installation are unconfirmed.',
    bundle_source_heading: 'Manufacturer bundle description (February 2026 list)',
    bundle_source_offer_hold: 'Current UPB offer contents remain unverified; these described components are not charged again.',
    bundle_source_unavailable: 'Manufacturer bundle description unavailable; contents need confirmation.',
    bundle_source_stale: 'Bundle source changed or is missing; reconfirm the components before handling this request.',
    bundle_component_ups_power_module: 'UPS power module',
    bundle_component_battery_module: 'battery module',
    bundle_component_battery_class: 'battery module ({u}U class; exact model to confirm)',
    bundle_component_four_post_rail_kit: 'four-post rail kit(s) (exact model to confirm)',
    bundle_component_bypass: 'bypass module',
    bundle_component_transformer: 'isolation transformer',
    bundle_component_adapter: 'adapter(s) (exact code to confirm)',
    bundle_component_line_cord: 'line cord',
    bundle_component_Tower_Stands: 'tower stands (quantity unspecified)',
    bundle_component_Software: 'software (quantity unspecified)',
    bundle_runtime_reference: 'Manufacturer reference: {m} min at {w} W with one {pack} pack at 240 V output. This estimate does not verify the UPB offer or installation.',
    bundle_runtime_output_hold: 'Runtime needs checking for your load and output voltage. Add this configuration to your quote request for review.',
    bundle_runtime_transformer_hold: 'The transformer can affect battery runtime. Add this configuration to your quote request so we can check the complete system.',
    bundle_runtime_load_hold: 'Your load is outside the runtime points available for this configuration. Send a quote request for help choosing a suitable system.',
    bundle_runtime_source_hold: 'We cannot yet match this configuration to the right battery runtime data. Add it to your quote request for review.',
    bundle_saved_pack: 'Saved request: {n} battery pack(s), model {h}. Kept for technical review; no extra pack added or charged.',
    bundle_saved_addon: 'Saved request: {k} {h}. Kept for technical review; item not added or charged.',
    bundle_saved_reconfirm: 'Saved accessories need review before this bundle can be configured.',
    bundle_no_extra: 'No extra pack selected; bundle contents to confirm.'
  });
  Object.assign(T, FR ? {
    tower_placement_title: 'Emplacement en tour',
    tower_placement_more: 'Options en tour à examiner',
    tower_placement_p80_1500: 'P80-1500 : placez l’onduleur debout sur les pieds fournis, à 70 mm du bord de l’appareil. Choisissez un endroit sec, loin du soleil direct et des appareils de chauffage, et gardez toutes les ouvertures de ventilation dégagées. Les 70 mm indiquent la position des pieds, pas un dégagement mural.',
    tower_placement_p80_3000: 'P80-3000V2 : les pieds de tour sont fournis. Gardez les ouvertures de ventilation dégagées. Les 70 mm du manuel indiquent la position des pieds par rapport au bord de l’onduleur, et non un dégagement mural.',
    tower_placement_p91_1500: 'P91-1500 : placez l’onduleur debout sur ses pieds fournis, sur une surface plane et propre, à l’intérieur, loin des vibrations, de la poussière, de l’humidité, de la chaleur et des contaminants. Gardez au moins 100 mm devant et dessous, et 300 mm derrière et de chaque côté, de l’onduleur aux obstacles. Les pieds ne prouvent pas à eux seuls le dégagement inférieur.',
    tower_placement_p91_3000: 'P91-3000 : posez l’onduleur sur une surface plane et propre, à l’intérieur. Prévoyez au moins 100 mm devant et dessous, et 300 mm derrière et de chaque côté, de l’onduleur aux obstacles. Les pieds fournis ne prouvent pas à eux seuls le dégagement inférieur.',
    tower_pack_setup: 'Avec un {pack}, placez l’onduleur et le bloc debout, côte à côte, sur le support élargi fourni avec le bloc. Utilisez le câble fourni entre les connecteurs arrière comme dans le manuel.',
    tower_pack_clearance: 'Placez les pieds à 70 mm du bord de chaque appareil. Gardez les ouvertures de ventilation de l’onduleur et du bloc dégagées. Laissez au moins 20 cm derrière le bloc-batterie jusqu’au mur ou à tout obstacle.',
    tower_pack_environment: 'Choisissez un endroit propre à l’intérieur, de 0 à 40 °C et de 30 à 90 % d’humidité sans condensation, loin de la poussière, de la corrosion et des matières inflammables.',
    tower_pack_scope: 'La source montre un seul bloc adjacent. Le support de deux blocs en tour et la portée du câble si le bloc est éloigné restent à vérifier.',
    tower_placement_question: 'Pouvez-vous respecter les conditions d’emplacement ci-dessus pour cette configuration?',
    tower_placement_yes: 'Oui', tower_placement_no: 'Non, ces conditions ne sont pas réunies',
    tower_placement_unsure: 'Je ne sais pas. Demander une vérification',
    tower_placement_unanswered: 'sans réponse',
    tower_placement_review: 'L’emplacement en tour doit être confirmé; vous pouvez demander une vérification technique.',
    tower_placement_details: 'Détails de la source',
    tower_placement_source: 'Conditions tirées des fiches Xtreme Power 2026 et du manuel P80 (p. 4, 8–9) ou P91 (p. 8–9), selon le modèle. Votre réponse décrit l’emplacement; elle ne constitue pas une inspection du site.',
    tower_pack_source: 'Pour le bloc P90-BP48 ou P90-BP72 avec son P80 précis : fiche P80 2026 et manuel P80, p. 9 et 36–38. La limite d’un bloc décrit l’installation en tour illustrée; elle ne représente pas une limite électrique du fabricant. Votre réponse ne constitue pas une inspection du site.',
    tower_placement_revision: 'Référence : {version}; empreinte source {source}',
    tower_placement_quote: 'Tour; emplacement déclaré pour un système lors de l’enregistrement : {answer}. Confirmez chaque emplacement si plusieurs systèmes sont demandés. Conditions Xtreme Power 2026, liste de vérification v3',
    tower_placement_quote_pack: 'Tour avec un bloc {pack} adjacent; emplacement déclaré pour un système lors de l’enregistrement : {answer}. Confirmez chaque emplacement si plusieurs systèmes sont demandés. Conditions Xtreme Power 2026, liste de vérification v3'
  } : {
    tower_placement_title: 'Tower placement',
    tower_placement_more: 'Tower options to review',
    tower_placement_p80_1500: 'P80-1500: place the UPS upright on its included tower feet, 70 mm from the unit edge. Choose a dry location away from direct sunlight and heaters, and keep every ventilation opening clear. The 70 mm is a foot position, not a wall clearance.',
    tower_placement_p80_3000: 'P80-3000V2: tower feet are included. Keep the ventilation openings clear. The manual’s 70 mm locates the feet from the UPS edge; it is not a wall clearance.',
    tower_placement_p91_1500: 'P91-1500: place the UPS upright on its included feet on a clean, flat indoor surface away from vibration, dust, moisture, heat and contaminants. Allow at least 100 mm in front and below and 300 mm behind and on each side, measured from the UPS to obstructions. The feet alone do not prove bottom clearance.',
    tower_placement_p91_3000: 'P91-3000: use a clean, flat indoor surface. Allow at least 100 mm in front and below and 300 mm behind and on each side, measured from the UPS to obstructions. The included feet do not by themselves prove the bottom clearance.',
    tower_pack_setup: 'With one {pack}, stand the UPS and pack upright side by side on the extended stand supplied with the pack. Use its supplied cable between the rear connectors as shown in the manual.',
    tower_pack_clearance: 'Position the feet 70 mm from each unit edge. Keep the UPS and pack vents open. Leave at least 20 cm behind the battery pack to the wall or another obstruction.',
    tower_pack_environment: 'Use a clean indoor location at 0–40 °C and 30–90% non-condensing humidity, away from dust, corrosion and flammable materials.',
    tower_pack_scope: 'The source shows one adjacent pack. Tower support for two packs and cable reach when separated remain unverified.',
    tower_placement_question: 'Can you meet the placement conditions above for this configuration?',
    tower_placement_yes: 'Yes', tower_placement_no: 'No, these conditions cannot be met',
    tower_placement_unsure: 'Not sure. Request a review',
    tower_placement_unanswered: 'unanswered',
    tower_placement_review: 'Tower placement needs your confirmation; you can request a technical review.',
    tower_placement_details: 'Source details',
    tower_placement_source: 'Conditions come from the Xtreme Power 2026 flyers and the P80 manual (pp. 4, 8–9) or P91 manual (pp. 8–9), as applicable. Your answer reports your placement; it is not a site inspection.',
    tower_pack_source: 'For P90-BP48 or P90-BP72 with its exact P80: Xtreme Power 2026 P80 flyer and P80 manual pp. 9 and 36–38. The one-pack ceiling describes the depicted tower setup, not an OEM electrical limit. Your answer is not a site inspection.',
    tower_placement_revision: 'Reference: {version}; source fingerprint {source}',
    tower_placement_quote: 'Tower; placement reported for one system when saved: {answer}. Confirm each placement if multiple systems are requested. Xtreme Power 2026 conditions, checklist v3',
    tower_placement_quote_pack: 'Tower with one adjacent {pack} pack; placement reported for one system when saved: {answer}. Confirm each placement if multiple systems are requested. Xtreme Power 2026 conditions, checklist v3'
  });
  Object.assign(T, FR ? {
    p91_status: 'Correspondance possible : capacité de sortie à vérifier',
    p91_unavailable: 'Données de qualification indisponibles. Demandez une vérification technique de la capacité et de l’autonomie.',
    p91_nameplate: 'Puissance publiée : {va} VA / {w} W à 127 V de sortie; l’alimentation d’entrée {supply} V ne confirme pas la sortie.',
    p91_unknown: 'Réglage de sortie de l’appareil livré inconnu; VA et W disponibles à confirmer.',
    p91_127: 'La puissance nominale publiée est basée sur une sortie de 127 V. Le réglage livré et l’autonomie pour votre charge restent à vérifier.',
    p91_120: '120 V est la tension de sortie nominale. Nous n’avons pas encore vérifié la puissance disponible à ce réglage. Envoyez une demande de soumission pour vérification.',
    p91_lower: 'À {output} V, la capacité en VA/W de ce modèle exact n’est pas établie; certains modèles sont déclassés.',
    p91_other: '{output} V ne figure pas parmi les réglages du document actuel; vérification requise.',
    p91_runtime: 'Autonomie et application au réglage livré à confirmer avant achat.',
    p91_runtime_verdict: 'Autonomie à vérifier',
    p91_cmp: 'Capacité de sortie', p91_cart: 'La puissance disponible et l’autonomie doivent être vérifiées à la tension de sortie demandée. Ajoutez ce P91 à votre demande de soumission pour vérification.',
    p91_quote: 'Vérification technique P91 : {model}; charge {load} W; alimentation d’entrée {supply} V; sortie demandée {output}; puissance publiée {va} VA / {w} W à 127 V; donnée d’autonomie {runtime}; bloc-batterie {pack}; capacité au réglage livré et application du graphique à confirmer. Source : fiche XPC P91 1–3 kVA, rév. 9/11/26, p. 2.',
    p91_output_unknown: 'inconnue', p91_pack_none: 'aucun',
    p91_runtime_unknown: 'aucune donnée applicable établie pour ce système sélectionné',
    p91_runtime_exact: 'point publié : {m} min à {w} W',
    p91_runtime_estimate: 'environ {m} min à {w} W (estimation dérivée des données d’autonomie fabricant)',
    p91_runtime_bound: 'au moins {m} min à {w} W (borne inférieure dérivée d’un point publié à charge plus élevée)',
    input_field_outputV: 'la tension de sortie ASI',
    p91_input_label: 'alimentation d’entrée {supply}', p91_output_label: 'sortie ASI demandée {output}',
    p91_only_saved: 'Préférence de sortie {output} réservée aux quatre modèles P91; non utilisée pour évaluer les autres modèles.'
  } : {
    p91_status: 'Potential match: output capacity needs review',
    p91_unavailable: 'Qualification data unavailable. Request a technical check of capacity and runtime.',
    p91_nameplate: 'Published nameplate: {va} VA / {w} W at 127 V output; {supply} V incoming supply does not confirm UPS output.',
    p91_unknown: 'Delivered unit output setting unknown; available VA and W need confirmation.',
    p91_127: 'The published power rating uses 127 V output. We still need to check the delivered setting and runtime for your load.',
    p91_120: '120 V is the nominal output. We have not yet verified the available power at that setting. Add a quote request for review.',
    p91_lower: 'At {output} V, this exact model’s VA/W capacity is not established; some models derate.',
    p91_other: '{output} V is not among the current flyer’s listed settings; review required.',
    p91_runtime: 'Runtime and applicability to the delivered output setting require confirmation before purchase.',
    p91_runtime_verdict: 'Runtime suitability needs review',
    p91_cmp: 'Output capacity', p91_cart: 'Power capacity and runtime need checking for your requested output voltage. Add this P91 to your quote request for review.',
    p91_quote: 'P91 technical review: {model}; {load} W load; {supply} V incoming supply; requested UPS output {output}; published nameplate {va} VA / {w} W at 127 V; runtime evidence {runtime}; battery pack {pack}; delivered-setting capacity and chart applicability to confirm. Source: XPC P91 1–3 kVA flyer, Rev 9/11/26, p. 2.',
    p91_output_unknown: 'unknown', p91_pack_none: 'none',
    p91_runtime_unknown: 'no applicable runtime evidence established for this selected system',
    p91_runtime_exact: 'published point: {m} min at {w} W',
    p91_runtime_estimate: 'about {m} min at {w} W (estimate derived from manufacturer runtime data)',
    p91_runtime_bound: 'at least {m} min at {w} W (lower bound from a published higher-load point)',
    input_field_outputV: 'UPS output voltage',
    p91_input_label: 'incoming supply {supply}', p91_output_label: 'requested UPS output {output}',
    p91_only_saved: 'Requested {output} output applies only to the four P91 models; it is not used to assess other models.'
  });
  Object.assign(T, FR ? {
    input_voltage_cmp: 'Alimentation d’entrée', input_voltage_details: 'Détails de la source d’entrée',
    input_voltage_missing: 'Alimentation d’entrée à confirmer pour ce modèle et cette charge.',
    input_voltage_unspecified: 'Indiquez votre alimentation d’entrée pour examiner ce modèle.',
    input_voltage_exact: '208–240 V couvre plusieurs tensions. Ajoutez ce modèle à votre demande de soumission; indiquez la tension exacte du site dans « Autres précisions » si vous la connaissez. Sinon, nous la confirmerons avec vous.',
    input_voltage_listed: 'La fiche indique {supply} V; la configuration du modèle fourni reste à confirmer.',
    input_voltage_unlisted: '{supply} V ne figure pas dans la liste d’entrée actuelle; vérifiez le modèle fourni.',
    input_voltage_range: 'La plage d’entrée dépend de la charge; aucune tension nominale d’entrée n’est indiquée.',
    input_voltage_nominal: 'La fiche indique {nominal} V nominal; la charge et le modèle fourni restent à confirmer.',
    input_voltage_other_nominal: 'La fiche indique {nominal} V nominal; votre demande de {supply} V exige une vérification.',
    input_voltage_printed: 'Entrée indiquée par le fabricant : {literal}.',
    input_voltage_range_detail: 'Plage de fonctionnement indiquée : {range}.',
    input_voltage_load_detail: 'La plage d’entrée utilisable dépend de la charge.',
    input_voltage_reference: 'Source : fiche technique XPC, page {page}.',
    input_voltage_source_link: 'Voir la fiche du fabricant',
    input_voltage_delivery: 'La configuration de l’appareil fourni reste à confirmer.',
    input_voltage_none: 'non indiquée', input_voltage_saved: 'Alimentation d’entrée de ce modèle à réévaluer selon la source actuelle; l’ancienne valeur scalaire ne prouve pas le réglage fourni.',
    input_voltage_quote: 'Vérification d’entrée : {model}; alimentation demandée {supply}; {summary} Entrée indiquée {literal}; configuration et conditions d’entrée de l’appareil fourni à confirmer. Source : fiche technique XPC, page {page}.'
  } : {
    input_voltage_cmp: 'Incoming supply', input_voltage_details: 'Input source details',
    input_voltage_missing: 'Input supply needs confirmation for this model and load.',
    input_voltage_unspecified: 'Enter your incoming supply to review this model.',
    input_voltage_exact: '208–240 V covers several supply voltages. Add this model to your quote request; enter your site’s exact voltage in Additional notes if known. Otherwise, we will confirm it with you.',
    input_voltage_listed: 'The source lists {supply} V; the supplied model’s configuration still needs confirmation.',
    input_voltage_unlisted: '{supply} V is not in the current input list; verify the supplied model.',
    input_voltage_range: 'Input range is load dependent; a nominal input voltage is not stated.',
    input_voltage_nominal: 'The source states {nominal} V nominal; load and delivered model still need confirmation.',
    input_voltage_other_nominal: 'The source states {nominal} V nominal; your {supply} V request needs review.',
    input_voltage_printed: 'Manufacturer input listing: {literal}.',
    input_voltage_range_detail: 'Published operating range: {range}.',
    input_voltage_load_detail: 'The usable input range depends on load.',
    input_voltage_reference: 'Source: XPC specification, page {page}.',
    input_voltage_source_link: 'View manufacturer specification',
    input_voltage_delivery: 'The delivered unit’s configuration still needs confirmation.',
    input_voltage_none: 'not stated', input_voltage_saved: 'Recheck this model’s incoming supply against the current source; an older scalar value does not prove the delivered setting.',
    input_voltage_quote: 'Input review: {model}; requested supply {supply}; {summary} Published input {literal}; delivered unit configuration and input conditions to confirm. Source: XPC specification, page {page}.'
  });
  Object.assign(T, FR ? {
    output_connection_tx91: 'Sortie : raccordement fixe par bornier. Une PDU optionnelle peut ajouter des prises; confirmez la distribution choisie et l’installation.',
    output_connection_ita2: 'Sortie : raccordement fixe standard. Des options POD intégrées peuvent ajouter des groupes de prises; confirmez la distribution choisie et l’installation.'
  } : {
    output_connection_tx91: 'Output: hardwired terminal blocks. An optional PDU may add receptacles; confirm the selected distribution and installation.',
    output_connection_ita2: 'Output: hardwired as standard. Integrated POD options may add outlet banks; confirm the selected distribution and installation.'
  });
  var BASE = { rackU: 0, depth: 0, generator: false, card: false,
    monitorWatts: false, shutdownNeed: 'unspecified', shutdownPlatform: '' };
  var OUTPUTS = ['', '100', '110', '115', '120', '127'];
  var POWERS = ['120', '208-240', 'three-phase', '230', 'unknown'];
  var OUTLETS = ['5-15R', '5-20R', 'L5-20R', 'L5-30R', 'L6-20R', 'L6-30R', 'HW', 'unknown'];
  var FITS = ['either', 'rack', 'tower'];
  var TOWER_HANDLES = ['xpc-p80-1500', 'xpc-p80-3000v2', 'xpc-p91-1500', 'xpc-p91-3000'];
  var P80_TOWER_PACKS = { 'xpc-p90-bp48': 'xpc-p80-1500', 'xpc-p90-bp72': 'xpc-p80-3000v2' };
  var P80_TOWER_PACK_LABELS = { 'xpc-p90-bp48': 'P90-BP48', 'xpc-p90-bp72': 'P90-BP72' };
  var CHEMISTRIES = ['unspecified', 'required_lithium', 'discuss'];
  var PLUG_NEEDS = ['unspecified', '5-15P', '5-20P', 'L5-20P', 'L5-30P', 'L6-20P', 'L6-30P', 'HW'];
  var SHUTDOWN_NEEDS = ['unspecified', 'safe_os', 'power_off', 'both', 'help'];
  function validPlatform(value) {
    return typeof value === 'string' && value.length <= 120 && !/[\u0000-\u001f\u007f]/.test(value);
  }
  // Builder UX pass (Christian 09-30: "needs a lot of UX polishing"): status line, short cards, outlet picker.
  Object.assign(T, FR ? {
    count: 'Meilleures options : {shown} sur {total}',
    fit_supported: 'Répond à votre autonomie et à votre prise.',
    status_ready: 'Prêt à commander', status_check: 'Commandable : un détail à vérifier',
    status_outlet: 'Choisissez votre prise pour commander', status_quote: 'Vérification technique requise',
    status_bad: 'Ne convient pas à vos réponses', status_short: 'Autonomie sous votre cible',
    over_limit_quote: 'Plus de 10\u00a0000\u00a0$\u00a0: cette configuration passe par une soumission.',
    discontinued_succ: 'Modèle abandonné par le fabricant; modèle actuel : {m}.',
    details: 'Détails et vérifications ({n})', ups_alone: 'UPS seul : ',
    with_n_packs: 'avec {n} blocs-batteries : ', with_n_packs_1: 'avec 1 bloc-batteries : ',
    packs_selected: '{n} blocs-batteries dans cette configuration', packs_selected_1: '1 bloc-batteries dans cette configuration',
    packs_available: '{n} modèles compatibles disponibles', packs_available_1: '1 modèle compatible disponible',
    rt_with_packs: 'autonomie avec {n} blocs-batteries : à confirmer', rt_with_packs_1: 'autonomie avec 1 bloc-batteries : à confirmer',
    physical_dims_unverified: 'Dimensions en baie ou en tour pas encore vérifiées : confirmez votre espace avant de commander.',
    physical_convertible: 'En baie ou en tour, à votre choix',
    outlet_pick_title: 'Dans quelle prise murale l’UPS sera-t-il branché?',
    outlet_pick_intro: 'Choisissez-la pour voir les options à commander dès maintenant.',
    outlet_pick_hint: 'Le type est inscrit sur la prise. Une prise de bureau standard est une 5-15R.',
    outlet_pick_hint_208: 'Le type est inscrit sur la prise; un électricien peut le confirmer.',
    outlet_pick_120: [['5-15R', 'Standard (5-15R)'], ['5-20R', '20 A (5-20R)'], ['L5-20R', 'Verrouillable 20 A (L5-20R)'],
      ['L5-30R', 'Verrouillable 30 A (L5-30R)'], ['HW', 'Raccordement fixe']],
    outlet_pick_208: [['L6-20R', 'L6-20R (20 A)'], ['L6-30R', 'L6-30R (30 A)'], ['HW', 'Raccordement fixe']],
    addons: 'Blocs-batteries et accessoires', best_match: 'Meilleur choix pour vos réponses', refurbished: 'Remis à neuf',
    spec_load: 'charge {p} %', sort_label: 'Trier', sort_best: 'Meilleur choix', sort_price: 'Prix le plus bas',
    sort_runtime: 'Autonomie la plus longue', brand_label: 'Marque', brand_all: 'Toutes les marques',
    short_add_packs: 'Ajoutez des blocs-batteries (Blocs-batteries et accessoires) pour atteindre {m} min.',
    short_pick_other: 'Ce modèle n’atteint pas {m} min à votre charge; choisissez une autre option.',
    review_list_title: 'Options à examiner avec un spécialiste',
    review_list_intro: 'Elles correspondent à vos autres réponses. Ajoutez celles qui vous intéressent à votre liste de soumission avec vos exigences; un spécialiste les vérifie avant la commande.',
    review_reason_monitoring: 'Arrêt ou surveillance à confirmer pour votre installation : ajoutez cette option à votre liste de soumission.',
    review_reason_lithium: 'Option lithium à confirmer : ajoutez-la à votre liste de soumission.',
    review_reason_plug: 'La fiche correspond à votre exigence; l’ensemble est vérifié avec votre soumission.',
    review_reason_discuss: 'Technologie des batteries à choisir avec un spécialiste : ajoutez cette option à votre liste de soumission.',
    empty_title: 'Aucun UPS de notre catalogue ne répond à toutes vos réponses',
    empty_load: 'Aucun UPS monophasé de notre catalogue ne fournit {w} W sur cette alimentation.',
    empty_other: 'Essayez une autre alimentation, une autonomie plus courte ou « Baie ou tour », ou envoyez-nous vos besoins.',
    empty_quote: 'Envoyer mes besoins pour une soumission', empty_three: 'Soumission triphasée',
    empty3_title: '{w} W demande un UPS triphasé',
    empty3_text: 'Notre plus gros UPS monophasé fournit {max} W. Le configurateur triphasé dimensionne votre UPS à partir de {kw} kW et liste les modèles qui conviennent.',
    empty3_btn: 'Dimensionner un UPS triphasé pour {kw} kW',
    emptyv_title: 'Aucun UPS {supply} ne fournit {w} W',
    emptyv_text: 'En 208-240 V monophasé, nos UPS vont jusqu’à {max} W.', emptyv_btn: 'Voir les UPS 208-240 V',
    tray_cmp: 'Comparer ({n})', tray_quote: 'Soumission ({n})', tray_cmp_more: 'Choisissez une autre option à comparer',
    load_help: 'Vous ne connaissez pas votre charge? Estimez-la', load_total: 'Total estimé : {w} W',
    load_apply: 'Utiliser ce total', load_note: 'Valeurs typiques pour dimensionner. Utilisez la plaque signalétique ou un wattmètre si vous les avez.',
    load_devices: [['srv1', 'Serveur 1U', 300], ['srv2', 'Serveur 2U ou tour', 500], ['sw', 'Commutateur réseau', 100],
      ['poe', 'Commutateur PoE (chargé)', 400], ['fw', 'Pare-feu ou routeur', 50], ['nas', 'Stockage ou NAS', 200],
      ['pc', 'Ordinateur de bureau', 150], ['mon', 'Écran', 30], ['nvr', 'Enregistreur vidéo (NVR)', 100], ['pbx', 'Système téléphonique', 100]],
    rt_chips_note: '5 à 10 min : le temps d’arrêter proprement. 30 min et plus : traverser une panne plus longue.',
    too_big_u: 'Trop haut pour votre baie : {ru}U, vous avez {free}U de libre.',
    too_big_depth: 'Trop profond pour votre baie : {dp} po, votre maximum est {max} po.',
    typed_limit_review: 'Nous vérifions l’espace indiqué avant la commande : ajoutez cette option à votre liste de soumission, ou videz les champs d’espace et de profondeur pour commander maintenant.',
    circuit_note: '{w} W dépasse la charge continue habituelle d’un circuit {o} (environ {max} W, soit 80 % de sa capacité). Un circuit plus gros donne plus d’options et de marge; faites-le confirmer par un électricien.'
  } : {
    count: 'Best matches: {shown} of {total} options',
    fit_supported: 'Meets your runtime and your outlet.',
    status_ready: 'Ready to order', status_check: 'Can be ordered: check one detail',
    status_outlet: 'Choose your outlet to order', status_quote: 'Needs a technical check',
    status_bad: 'Does not fit your answers', status_short: 'Runtime below your target',
    over_limit_quote: 'Over $10,000: this setup goes through a quote.',
    discontinued_succ: 'Discontinued by the manufacturer; current model: {m}.',
    details: 'Details and checks ({n})', ups_alone: 'UPS alone: ',
    with_n_packs: 'with {n} battery packs: ', with_n_packs_1: 'with 1 battery pack: ',
    packs_selected: '{n} battery packs in this configuration', packs_selected_1: '1 battery pack in this configuration',
    packs_available: '{n} compatible models available', packs_available_1: '1 compatible model available',
    rt_with_packs: 'runtime with {n} battery packs: to confirm', rt_with_packs_1: 'runtime with 1 battery pack: to confirm',
    physical_dims_unverified: 'Rack or tower dimensions not verified yet: confirm your space before ordering.',
    physical_convertible: 'Rack or tower: your choice',
    outlet_pick_title: 'Which wall outlet will the UPS plug into?',
    outlet_pick_intro: 'Choose it to see the options you can order now.',
    outlet_pick_hint: 'The type is marked on the receptacle. A standard office outlet is 5-15R.',
    outlet_pick_hint_208: 'The type is marked on the receptacle; an electrician can confirm it.',
    outlet_pick_120: [['5-15R', 'Standard (5-15R)'], ['5-20R', '20 A (5-20R)'], ['L5-20R', 'Twist-lock 20 A (L5-20R)'],
      ['L5-30R', 'Twist-lock 30 A (L5-30R)'], ['HW', 'Hardwired']],
    outlet_pick_208: [['L6-20R', 'L6-20R (20 A)'], ['L6-30R', 'L6-30R (30 A)'], ['HW', 'Hardwired']],
    addons: 'Battery packs and accessories', best_match: 'Best match for your answers', refurbished: 'Refurbished',
    spec_load: '{p}% load', sort_label: 'Sort', sort_best: 'Best match', sort_price: 'Lowest price',
    sort_runtime: 'Longest runtime', brand_label: 'Brand', brand_all: 'All brands',
    short_add_packs: 'Add battery packs (under Battery packs and accessories) to reach {m} min.',
    short_pick_other: 'This model cannot reach {m} min at your load; pick another option.',
    review_list_title: 'Options to review with a specialist',
    review_list_intro: 'These match your other answers. Add the ones you like to your quote list with your requirements; a specialist checks them before you order.',
    review_reason_monitoring: 'Shutdown or monitoring to confirm for your setup: add it to your quote list.',
    review_reason_lithium: 'Lithium option to confirm: add it to your quote list.',
    review_reason_plug: 'The plug matches your requirement; the whole setup is checked with your quote.',
    review_reason_discuss: 'Battery technology to choose with a specialist: add it to your quote list.',
    empty_title: 'No UPS in our catalogue matches all your answers',
    empty_load: 'No single-phase UPS in our catalogue delivers {w} W on this supply.',
    empty_other: 'Try another supply, a shorter runtime or "Tower or rack", or send us your requirements.',
    empty_quote: 'Send my requirements for a quote', empty_three: 'Three-phase quote',
    empty3_title: '{w} W needs a three-phase UPS',
    empty3_text: 'Our largest single-phase UPS delivers {max} W. The three-phase designer sizes your UPS from {kw} kW and lists the models that fit.',
    empty3_btn: 'Size a three-phase UPS for {kw} kW',
    emptyv_title: 'No {supply} UPS delivers {w} W',
    emptyv_text: 'On 208-240 V single-phase, our UPS go up to {max} W.', emptyv_btn: 'Show 208-240 V UPS',
    tray_cmp: 'Compare ({n})', tray_quote: 'Quote list ({n})', tray_cmp_more: 'Pick one more option to compare',
    load_help: 'Not sure of your load? Estimate it', load_total: 'Estimated total: {w} W',
    load_apply: 'Use this total', load_note: 'Typical values for sizing. Use the nameplate or a power meter when you have them.',
    load_devices: [['srv1', '1U server', 300], ['srv2', '2U or tower server', 500], ['sw', 'Network switch', 100],
      ['poe', 'PoE switch (loaded)', 400], ['fw', 'Firewall or router', 50], ['nas', 'Storage or NAS', 200],
      ['pc', 'Desktop computer', 150], ['mon', 'Monitor', 30], ['nvr', 'Video recorder (NVR)', 100], ['pbx', 'Phone system', 100]],
    rt_chips_note: '5 to 10 min: time to shut down safely. 30 min or more: ride through a longer outage.',
    too_big_u: 'Too tall for your rack: {ru}U, you have {free}U free.',
    too_big_depth: 'Too deep for your rack: {dp} in, your maximum is {max} in.',
    typed_limit_review: 'We check it against the space you entered before you order: add it to your quote list, or clear the rack space and depth fields to order now.',
    circuit_note: '{w} W is above the usual continuous load for a {o} circuit (about {max} W, 80% of its rating). A larger circuit gives more options and headroom; have an electrician confirm it.'
  });
  // Builder X (Master, 3 Oct 2026; Christian: "execute everything" on the 20-item list). Store wording reused:
  // availability as on product pages, reply time and hours as on the contact and quote pages.
  Object.assign(T, FR ? {
    rb_one: 'Ses batteries durent environ 3 à 5 ans. Remplacement : {p}.', rb_from: 'Ses batteries durent environ 3 à 5 ans. Remplacement à partir de {p}.',
    rb_see: 'Voir les batteries',
    whatif_label: 'Et si la charge change?', whatif_at: 'À {w} W :', whatif_none: 'hors du tableau du fabricant.',
    sheet_close: 'Fermer', build_label: 'Votre configuration :',
    linkbar_title: 'Vos réponses', linkbar_edit: 'Modifier les réponses', pinned_label: 'Votre UPS de départ',
    outlet_std: 'Prise de bureau standard', outlet_tiles_title: 'Touchez la prise qui ressemble à la vôtre',
    outlet_unknown_tile: 'Je ne sais pas',
    picks_title: 'Trois choix rapides', pick_low: 'Prix le plus bas qui répond à vos besoins', pick_best: 'Meilleur choix',
    pick_long: 'Autonomie la plus longue', pick_see: 'Voir cette option', pick_rt: 'environ {m} min',
    budget_label: 'Budget', budget_any: 'Tous', budget_1: 'Moins de 1 000 $',
    budget_2: '1 000 $ à 3 000 $', budget_3: 'Plus de 3 000 $',
    nopack_label: 'Sans bloc-batteries supplémentaire',
    filter_empty: 'Aucune option ne correspond à ce filtre.', filter_clear: 'Retirer les filtres',
    avail_in: 'En stock', avail_order: 'Disponible sur commande', avail_quote: 'Prix confirmé par soumission',
    avail_made: 'Assemblé sur commande', status_freight: 'Soumission avec transport', freight_btn: 'Soumission avec transport',
    freight_reason: 'Une pièce de plus de 67,95 kg voyage par transporteur sur palette : nous confirmons le transport dans une soumission avant le paiement.',
    get_price: 'Obtenir un prix', get_price_note: 'Nous répondons dans un délai d’un jour ouvrable.',
    talk_line: 'Vous préférez en parler? 438-881-3363, du lundi au vendredi, 8 h 30 à 16 h 30 HE.',
    email_build: 'Envoyer par courriel', email_subject: 'Configuration UPS (configurateur UPSPLUSBATTERY)',
    email_answers: 'Mes réponses : {a}', email_options: 'Options :', email_link: 'Ouvrir cette configuration :',
    email_ready: 'prêt à commander', email_check: 'commandable, un détail à vérifier', email_quote: 'sur soumission',
    batt_disc_title: 'Votre UPS est abandonné par le fabricant',
    batt_disc_text: 'Des batteries neuves le remettent en service. Si vous préférez le remplacer, voici le modèle actuel ou un UPS de la même puissance.',
    batt_disc_succ: 'Voir le modèle actuel : {m}', batt_disc_build: 'Trouver un UPS de remplacement'
  } : {
    rb_one: 'Its batteries last about 3 to 5 years. Replacement: {p}.', rb_from: 'Its batteries last about 3 to 5 years. Replacement from {p}.',
    rb_see: 'See the batteries',
    whatif_label: 'What if the load changes?', whatif_at: 'At {w} W:', whatif_none: 'outside the maker table.',
    sheet_close: 'Close', build_label: 'Your build:',
    linkbar_title: 'Your answers', linkbar_edit: 'Edit answers', pinned_label: 'Your starting UPS',
    outlet_std: 'Standard office outlet', outlet_tiles_title: 'Tap the outlet that looks like yours',
    outlet_unknown_tile: 'Not sure',
    picks_title: 'Three quick picks', pick_low: 'Lowest price that meets your needs', pick_best: 'Best match',
    pick_long: 'Longest runtime', pick_see: 'See this option', pick_rt: 'about {m} min',
    budget_label: 'Budget', budget_any: 'Any', budget_1: 'Under $1,000', budget_2: '$1,000 to $3,000', budget_3: 'Over $3,000',
    nopack_label: 'Without extra battery pack',
    filter_empty: 'No option matches this filter.', filter_clear: 'Clear the filters',
    avail_in: 'In stock', avail_order: 'Available on order', avail_quote: 'Price confirmed by quote',
    avail_made: 'Assembled to order', status_freight: 'Freight quote', freight_btn: 'Request a freight quote',
    freight_reason: 'A piece over 67.95 kg ships by freight on a pallet: we confirm the freight in a quote before you pay.',
    get_price: 'Get a price', get_price_note: 'We reply within one business day.',
    talk_line: 'Prefer to talk? 438-881-3363, Monday to Friday, 8:30 to 16:30 ET.',
    email_build: 'Email this build', email_subject: 'UPS setup (UPSPLUSBATTERY Solutions Builder)',
    email_answers: 'My answers: {a}', email_options: 'Options:', email_link: 'Open this build:',
    email_ready: 'ready to order', email_check: 'can be ordered, one detail to check', email_quote: 'by quote',
    batt_disc_title: 'The maker has discontinued this UPS',
    batt_disc_text: 'New batteries put it back in service. If you would rather replace it, here is the current model or a UPS of the same size.',
    batt_disc_succ: 'See the current model: {m}', batt_disc_build: 'Find a replacement UPS'
  });
  // Exact OEM facts accepted for an optional quote-only candidate. This is not a
  // general lithium filter or a sellable accessory mapping in the Builder index.
  var CANDIDATE_ID = 'eaton-9px1500rtn-l-9pxebm48rt-l-rd04-v1';
  var CANDIDATE_POINTS = [[270, 145], [405, 98], [540, 74], [675, 60], [810, 50],
    [944, 43], [1080, 37], [1215, 33], [1350, 29]];
  var PRESETS = {
    closet: { load: 350, runtime: 30, power: '120', outlet: '5-15R', fit: 'rack' },
    servers: { load: 1200, runtime: 20, power: '120', outlet: 'unknown', fit: 'rack' },
    school: { load: 350, runtime: 30, power: '120', outlet: '5-15R', fit: 'rack', generator: true },
    lab: { load: 1000, runtime: 15, power: '208-240', outlet: 'unknown', fit: 'either', generator: true },
    room: { load: 4000, runtime: 15, power: '208-240', outlet: 'unknown', fit: 'rack' }
  };
  var q = { load: 1200, runtime: 20, power: '120', outputV: '', outlet: 'unknown', fit: 'either', rackU: 0, depth: 0,
    generator: false, card: false, chemistry: 'unspecified', plugNeed: 'unspecified',
    monitorWatts: false, shutdownNeed: 'unspecified', shutdownPlatform: '', towerPlacement: {} };
  var builderViewed = false, committedSnapshot = null, measuredRevision = 0, lastResultsRevision = -1;
  function quoteFeedback(text, saved) { return text + (saved ? '' : ' ' + T.quote_save_limited); }
  function quoteChanged(action, saved) {
    emit('upsb_quote_list_changed', { action: action, row_count: quote.length,
      storage: saved ? 'persisted' : 'failed' });
  }
  function batteryModeFromUrl() {
    try { return new URLSearchParams(location.search).get('mode') === 'battery'; }
    catch (e) { return false; }
  }
  var batteryMode = batteryModeFromUrl();
  var generatorExplicit = false; // a buyer or saved link chose yes/no; presets cannot replace it
  var generatorSuggested = false; // school/lab default remains visible until the buyer chooses
  var initialNumericFromUrl = {};
  var index = null;
  var p91Projection = null;
  var indexStatus = 'loading', indexRequestId = 0;
  var lastRes = [];
  var sel = {};      // add-on choices per UPS handle, set only once the buyer touches them (else the engine default)
  var unmatchedSaved = {}; // valid saved links whose UPS is not a current result; never erase them silently
  var invalidSavedRaw = []; // malformed/duplicate a= payloads: visible hold; no default cart or quote continuation
  var openAdd = {};  // add-on panels left open across re-renders
  var inCart = {};   // submitted configuration fingerprint by UPS handle; stale answers never show checkout-ready
  var cartNotice = {}; // A live price or availability change needs a fresh buyer decision.
  var cartPending = {}; // survives card re-renders until the same click settles
  var cartUncertain = {}; // an unconfirmed POST needs cart inspection before any further add in this page
  var shownCount = 12; // G27: normal-entry visibility — rendered result count; requirement changes reset it
  // RD.03d: saved add-on choices that could not be restored exactly (removed item, or a
  // legacy positional link whose original accessory cannot be proven). Keyed by UPS handle:
  // { kinds: ['pack model'|'network card'|...], missing: ['handle', ...] }. The row shows a
  // visible reconfirmation line and opens its add-on panel; nothing is silently swapped.
  var reconfirm = {};
  var urlHolds = {}; // supplied-but-invalid URL values; absent legacy fields have no hold
  var quote = [];
  var cmpHandles = [];
  var cmpMsgTimer = null;
  function normalizedRequirements(x) {
    function between(v, min, max) { var n = Number(v); return Number.isFinite(n) && n >= min && n <= max ? n : 0; }
    function oneOf(v, choices, fallback) { return choices.indexOf(v) !== -1 ? v : fallback; }
    return { load: between(x.load, 50, 1000000), runtime: between(x.runtime, 1, 10000),
      power: oneOf(x.power, POWERS, 'unknown'), outputV: oneOf(String(x.outputV || ''), OUTPUTS, ''), outlet: oneOf(x.outlet, OUTLETS, 'unknown'),
      fit: oneOf(x.fit, FITS, 'either'), rackU: between(x.rackU, 1, 42), depth: between(x.depth, 10, 48),
      generator: x.generator === true, card: x.card === true,
      chemistry: oneOf(x.chemistry, CHEMISTRIES, 'unspecified'),
      plugNeed: oneOf(x.plugNeed, PLUG_NEEDS, 'unspecified'),
      monitorWatts: x.monitorWatts === true,
      shutdownNeed: oneOf(x.shutdownNeed, SHUTDOWN_NEEDS, 'unspecified'),
      shutdownPlatform: validPlatform(x.shutdownPlatform) &&
        (x.shutdownNeed === 'safe_os' || x.shutdownNeed === 'both' || !x.shutdownNeed ||
          x.shutdownNeed === 'unspecified') ?
        x.shutdownPlatform : '' };
  }
  var INPUT_CHOICES = { power: POWERS, outputV: OUTPUTS, outlet: OUTLETS, fit: FITS,
    chemistry: CHEMISTRIES, plugNeed: PLUG_NEEDS, shutdownNeed: SHUTDOWN_NEEDS };
  var INPUT_BOUNDS = { load: [50, 1000000], runtime: [1, 10000],
    rackU: [1, 42], depth: [10, 48] };
  function suppliedValid(field, value) {
    if (INPUT_CHOICES[field]) return INPUT_CHOICES[field].indexOf(value) !== -1;
    if (field === 'generator' || field === 'card' || field === 'monitorWatts') return value === true || value === false;
    if (field === 'shutdownPlatform') return validPlatform(value);
    if (INPUT_BOUNDS[field]) {
      if (typeof value !== 'number' || !Number.isFinite(value)) return false;
      if (value === 0) return true; // existing normalized saved rows use numeric zero for an unknown value
      var bounds = INPUT_BOUNDS[field];
      return value >= bounds[0] && value <= bounds[1] &&
        (field !== 'runtime' && field !== 'rackU' || Number.isInteger(value));
    }
    return true;
  }
  function urlNumberValid(field, raw) {
    var bounds = INPUT_BOUNDS[field], value = Number(raw);
    if (!bounds || String(raw).trim() === '' || !Number.isFinite(value) ||
      value < bounds[0] || value > bounds[1]) return false;
    var step = field === 'load' ? 50 : (field === 'depth' ? 0.5 : 1);
    return Math.abs((value - bounds[0]) / step - Math.round((value - bounds[0]) / step)) < 1e-8;
  }
  function acceptUrlCorrection(field, raw) {
    var key = field === 'generator' ? 'gen' : field;
    if (!urlHolds[key]) return false;
    var valid = field === 'generator' || field === 'card' || field === 'monitorWatts' ? typeof raw === 'boolean' :
      (INPUT_BOUNDS[field] ? (raw === '' && (field === 'rackU' || field === 'depth')) ||
        urlNumberValid(field, raw) : suppliedValid(field, raw));
    if (valid) delete urlHolds[key];
    return valid;
  }
  function rawText(value) {
    var raw = typeof value === 'string' ? value : JSON.stringify(value);
    if (raw === undefined) raw = String(value);
    return raw.length > 100 ? raw.slice(0, 100) + '…' : raw;
  }
  function suppliedHolds(source) {
    var holds = [];
    Object.keys(INPUT_CHOICES).concat(Object.keys(INPUT_BOUNDS),
      ['generator', 'card', 'monitorWatts', 'shutdownPlatform']).forEach(function (field) {
      if (Object.prototype.hasOwnProperty.call(source, field) && !suppliedValid(field, source[field]))
        holds.push({ field: field, raw: source[field], rawType: typeof source[field] });
    });
    return holds;
  }
  function rowHolds(x) { return x.holds || []; }
  function hasInputHolds() { return !!Object.keys(urlHolds).length || quote.some(function (x) { return rowHolds(x).length > 0; }); }
  function holdText(hold, isUrl) {
    var display = !isUrl && hold.field === 'qty' && hold.rawType === 'string' ?
      JSON.stringify(rawText(hold.raw)) : rawText(hold.raw);
    return fill(isUrl ? T.input_hold_url : T.input_hold_saved,
      { field: T['input_field_' + hold.field] || hold.field,
        raw: display + (hold.rawType === 'string' ? '' : ' (' + hold.rawType + ')') });
  }
  function safeDefault(field) {
    return { load: 0, runtime: 0, power: 'unknown', outputV: '', outlet: 'unknown', fit: 'either',
      rackU: 0, depth: 0, generator: false, card: false, monitorWatts: false,
      chemistry: 'unspecified', plugNeed: 'unspecified', shutdownNeed: 'unspecified',
      shutdownPlatform: '' }[field];
  }
  function choiceLabel(field, value) {
    if (field === 'generator' || field === 'card' || field === 'monitorWatts')
      return value === 'true' ? T.input_hold_yes : T.input_hold_no;
    var select = $('[data-upsb-form]').elements[field];
    var option = select && Array.prototype.find.call(select.options, function (o) { return o.value === value; });
    return option ? option.textContent : value;
  }
  function correctSavedField(row, field, value) {
    row.sourceRequirements[field] = value;
    row.requirements = normalizedRequirements(row.sourceRequirements);
    row.holds = suppliedHolds(row.sourceRequirements);
    if (Object.prototype.hasOwnProperty.call(row, 'sourceQty'))
      row.holds.push({ field: 'qty', raw: row.sourceQty, rawType: typeof row.sourceQty });
    if (!row.holds.length) { delete row.holds; delete row.sourceRequirements; }
  }
  function correctSavedQty(row, next) {
    row.qty = next;
    if (!Object.prototype.hasOwnProperty.call(row, 'sourceQty')) return;
    delete row.sourceQty;
    row.holds = rowHolds(row).filter(function (h) { return h.field !== 'qty'; });
    if (!row.holds.length) { delete row.holds; delete row.sourceRequirements; }
  }
  function candidateEvidence(r) {
    // Use the next heavier exact OEM graph point, not an optimistic interpolated
    // result. Eaton says actual runtimes may vary about 15% from typical values.
    if (r.monitorWatts || (r.shutdownNeed && r.shutdownNeed !== 'unspecified') || r.shutdownPlatform ||
        r.chemistry !== 'required_lithium' || r.power !== '120' || r.outlet !== '5-15R' ||
        r.plugNeed !== '5-15P' || r.fit !== 'rack' || !r.card || r.generator ||
        (r.rackU && r.rackU < 3) || (r.depth && r.depth < 17.7) ||
        r.load < 270 || r.load > 1350 || r.runtime < 1) return null;
    for (var i = 0; i < CANDIDATE_POINTS.length; i++) {
      var point = CANDIDATE_POINTS[i];
      if (r.load <= point[0]) return r.runtime <= point[1] * 0.85 ?
        { load: point[0], minutes: point[1] } : null;
    }
    return null;
  }
  function candidateEligible(r) { return !!candidateEvidence(r); }
  function needsTechnicalReview() {
    return q.chemistry !== 'unspecified' || q.plugNeed !== 'unspecified' || q.monitorWatts ||
      q.shutdownNeed !== 'unspecified' || !!q.shutdownPlatform ||
      !!(urlHolds.monitorWatts || urlHolds.shutdownNeed || urlHolds.shutdownPlatform);
  }
  function requirementFormError() {
    var f = $('[data-upsb-form]'), first = null;
    [
      ['load', 50, 1000000, 50, true], ['runtime', 1, 10000, 1, true],
      ['rackU', 1, 42, 1, false], ['depth', 10, 48, 0.5, false]
    ].forEach(function (spec) {
      var el = f.elements[spec[0]], raw = String(el.value || '').trim(), n = Number(raw);
      var bad = (!raw && spec[4]) || (el.validity && !el.validity.valid) ||
        (raw && (!Number.isFinite(n) || n < spec[1] || n > spec[2] ||
          Math.abs((n - spec[1]) / spec[3] - Math.round((n - spec[1]) / spec[3])) > 1e-8));
      if (bad) { el.setAttribute('aria-invalid', 'true'); if (!first) first = { element: el, field: spec[0] }; }
      else el.removeAttribute('aria-invalid');
    });
    var platform = f.elements.shutdownPlatform;
    if (!validPlatform(platform.value)) {
      platform.setAttribute('aria-invalid', 'true');
      if (!first) first = { element: platform, field: 'shutdownPlatform' };
    } else platform.removeAttribute('aria-invalid');
    return first;
  }
  try {
    var savedQuote = JSON.parse(localStorage.getItem('upsbBuilderQuote') || '[]');
    if (Array.isArray(savedQuote)) savedQuote.forEach(function (x) {
      if (!x || typeof x !== 'object') return;
      if (x.estimate && typeof x.estimate === 'object') x.estimate.restored = true;   // G32: a restored estimate is historical, never current
      var suppliedQty = Object.prototype.hasOwnProperty.call(x, 'sourceQty') ? x.sourceQty : x.qty;
      var qtyBad = Object.prototype.hasOwnProperty.call(x, 'sourceQty') ||
        (Object.prototype.hasOwnProperty.call(x, 'qty') &&
          (!Number.isSafeInteger(suppliedQty) || suppliedQty <= 0));
      var qty = qtyBad ? 1 : (Number.isSafeInteger(suppliedQty) && suppliedQty > 0 ? suppliedQty : 1);
      var qtyHold = qtyBad ? [{ field: 'qty', raw: suppliedQty, rawType: typeof suppliedQty }] : [];
      if (x.kind === 'requirements' && x.requirements && typeof x.requirements === 'object') {
        var source = x.sourceRequirements && typeof x.sourceRequirements === 'object' ?
          x.sourceRequirements : x.requirements;
        var reqHolds = suppliedHolds(source), requirements = normalizedRequirements(source);
        var reqRow = { kind: 'requirements', qty: qty, requirements: requirements,
          candidate: !reqHolds.length && !qtyBad && x.candidate === CANDIDATE_ID &&
            candidateEligible(requirements) ? CANDIDATE_ID : '' };
        if (reqHolds.length) reqRow.sourceRequirements = source;
        if (qtyBad) reqRow.sourceQty = suppliedQty;
        if (reqHolds.length || qtyBad) reqRow.holds = reqHolds.concat(qtyHold);
        quote.push(reqRow);
      } else if (typeof x.model === 'string') {
        var row = { kind: x.kind === 'saved_review' ? 'saved_review' : 'solution', model: x.model,
          qty: qty, note: typeof x.note === 'string' ? x.note : '' };
        if (Object.prototype.hasOwnProperty.call(x, 'inputSource')) row.inputSource = x.inputSource;
        if (Object.prototype.hasOwnProperty.call(x, 'bundleSource')) row.bundleSource = x.bundleSource;
        if (typeof x.req === 'string') row.req = x.req;
        if (x.kind !== 'saved_review' && validEstimate(x.estimate, row.model)) row.estimate = x.estimate;
        if (qtyBad) { row.sourceQty = suppliedQty; row.holds = qtyHold; }
        if (/(^|\W)xpc-p91-(1000|1500|2000|3000)(\W|$)/.test(row.model) && row.note.indexOf(T.p91_cart) < 0)
          row.note += ' | ' + T.p91_cart + ' | ' + fill(T.p91_output_label, { output: T.p91_output_unknown });
        quote.push(row);
      }
    });
  } catch (e) { quote = []; }
  // G.04 (Lane D, 2 Oct 2026): "Check my build" puts a first line on the quote request; kept while the list has rows.
  var checkBuild = false;
  try { checkBuild = quote.length > 0 && localStorage.getItem('upsbBuilderCheckBuildV1') === '1'; } catch (e) { /* no storage */ }
  function setCheckBuild(on) {
    checkBuild = !!on;
    try { if (checkBuild) localStorage.setItem('upsbBuilderCheckBuildV1', '1'); else localStorage.removeItem('upsbBuilderCheckBuildV1'); }
    catch (e) { /* in-memory flag still applies */ }
  }

  function persistQuote() {
    var saved = false;
    try { localStorage.setItem('upsbBuilderQuote', JSON.stringify(quote)); saved = true; }
    catch (e) { /* Keep the live in-memory list intact. */ }
    var status = $('[data-quote-global-status]');
    if (status) {
      if (!saved) status.textContent = T.quote_save_limited;
      else if (status.textContent === T.quote_save_limited) status.textContent = '';
    }
    return saved;
  }

  // RD.03b: shareable link. Builder answers live in the URL query; any other query
  // parameter (the ?view= that renders this prototype, utm tags) is preserved untouched.
  var URL_KEYS = ['load', 'runtime', 'power', 'outlet', 'fit', 'rackU', 'depth', 'gen', 'genSuggested', 'card',
    'chemistry', 'plugNeed', 'monitorWatts', 'shutdownNeed', 'shutdownPlatform', 'outputV', 'tp'];

  function applyUrlParams() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return false; }
    var seen = false;
    function hold(key, raw) {
      urlHolds[key] = { field: key, raw: raw, rawType: 'string' }; seen = true;
    }
    function choice(key, choices) {
      if (!p.has(key)) return;
      var raw = p.get(key);
      if (choices.indexOf(raw) !== -1) { q[key] = raw; seen = true; }
      else hold(key, raw);
    }
    function num(key) {
      var raw = p.get(key), v = raw === '' ? 0 : Number(raw);
      if (urlNumberValid(key, raw)) {
        q[key] = v; initialNumericFromUrl[key] = raw; seen = true;
      } else { initialNumericFromUrl[key] = raw; hold(key, raw); }
    }
    choice('chemistry', CHEMISTRIES);
    choice('plugNeed', PLUG_NEEDS);
    choice('shutdownNeed', SHUTDOWN_NEEDS);
    if (p.has('shutdownPlatform')) {
      var platform = p.get('shutdownPlatform');
      if (validPlatform(platform)) { q.shutdownPlatform = platform; seen = true; }
      else hold('shutdownPlatform', platform);
    }
    if (p.get('load') != null) num('load');
    if (p.get('runtime') != null) num('runtime');
    choice('power', POWERS);
    choice('outputV', OUTPUTS);
    choice('outlet', OUTLETS);
    choice('fit', FITS);
    if (p.get('rackU') != null) num('rackU');
    if (p.get('depth') != null) num('depth');
    ['gen', 'card', 'monitorWatts'].forEach(function (k) {
      var v = p.get(k);
      if (v === '1' || v === '0') {
        q[k === 'gen' ? 'generator' : k] = v === '1';
        if (k === 'gen') generatorExplicit = true;
        seen = true;
      }
      else if (v !== null) hold(k, v);
    });
    if (p.get('genSuggested') === '1' && q.generator && !urlHolds.gen) {
      generatorSuggested = true;
      generatorExplicit = false;
      seen = true;
    }
    if (p.has('tp') && p.get('tp').length <= 2000) {
      try {
        var savedPlacement = JSON.parse(p.get('tp'));
        if (savedPlacement && typeof savedPlacement === 'object' && !Array.isArray(savedPlacement))
          TOWER_HANDLES.forEach(function (handle) {
            var a = savedPlacement[handle];
            if (a && typeof a === 'object' && !Array.isArray(a) &&
                ['yes', 'no', 'unsure'].indexOf(a.answer) >= 0 &&
                ['version', 'manifest', 'orientation', 'items', 'at'].every(function (k) {
                  return typeof a[k] === 'string' && a[k].length <= 160;
                })) q.towerPlacement[handle] = a;
          });
      } catch (e) { /* A malformed placement answer cannot assert a fit. */ }
    }
    return seen;
  }

  function updatePrintReopen() {
    var link = $('[data-print-reopen]');
    if (!link) return;
    link.href = location.href;
    link.textContent = location.href;
  }
  function syncUrl() {
    try {
      var p = new URLSearchParams(location.search);
      var preview = window.UPSBQuoteTransfer && window.UPSBQuoteTransfer.previewThemeId &&
        window.UPSBQuoteTransfer.previewThemeId();
      if (preview) p.set('preview_theme_id', preview);
      else if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main')
        p.delete('preview_theme_id');
      URL_KEYS.forEach(function (k) { p.delete(k); });
      if (q.towerPlacement && Object.keys(q.towerPlacement).length)
        p.set('tp', JSON.stringify(q.towerPlacement));
      p.set('load', q.load);
      p.set('runtime', q.runtime);
      p.set('power', q.power);
      if (q.outputV) p.set('outputV', q.outputV);
      p.set('outlet', q.outlet);
      p.set('fit', q.fit);
      if (q.chemistry !== 'unspecified') p.set('chemistry', q.chemistry);
      if (q.plugNeed !== 'unspecified') p.set('plugNeed', q.plugNeed);
      if (q.monitorWatts) p.set('monitorWatts', '1');
      if (q.shutdownNeed !== 'unspecified') p.set('shutdownNeed', q.shutdownNeed);
      if (q.shutdownPlatform && (q.shutdownNeed === 'safe_os' || q.shutdownNeed === 'both' ||
          q.shutdownNeed === 'unspecified')) p.set('shutdownPlatform', q.shutdownPlatform);
      if (q.rackU) p.set('rackU', q.rackU);
      if (q.depth) p.set('depth', q.depth);
      if (generatorExplicit) p.set('gen', q.generator ? '1' : '0');
      else if (q.generator) p.set('gen', '1');
      if (generatorSuggested && q.generator && !generatorExplicit) p.set('genSuggested', '1');
      if (q.card) p.set('card', '1');
      if (needsTechnicalReview()) {
        var form = $('[data-upsb-form]');
        ['load', 'runtime', 'rackU', 'depth'].forEach(function (key) {
          var raw = String(form.elements[key].value).trim();
          if (raw || key === 'load' || key === 'runtime') p.set(key, raw);
          else p.delete(key);
        });
      }
      Object.keys(urlHolds).forEach(function (key) { p.set(key, String(urlHolds[key].raw)); });
      // RD.03c/RD.03d: add-on choices, one a= value with ~ between touched solutions:
      //   a=<upsHandle>:<packQty>.<packModelHandle>.<cardHandle>.<bypassHandle>.<railHandle>~...
      // Shopify's page redirect drops all but the last repeated a= query parameter.
      // Accessory fields are STABLE product handles ('' = none picked); the engine sorts
      // option lists by live stock and price, so positional indexes (the RD.03c format)
      // could silently select a different accessory after a catalogue refresh and are no
      // longer written. Handles never contain ':' or '.' (Shopify slug rule).
      // a= serialization uses the STORED identity strings (sel[h].ids), independent of
      // the current results: on first render lastRes is still empty and resolving from
      // it would erase a perfectly valid incoming link. '?' marks an unresolved hold and
      // round-trips it; a missing accessory keeps its saved handle. Before the index is
      // in, the a= params are left exactly as they arrived.
      if (index) {
        p.delete('a');
        if (invalidSavedRaw.length) {
          p.set('a', invalidSavedRaw.join('~'));
        } else {
        var savedValues = [];
        Object.keys(unmatchedSaved).forEach(function (h) { savedValues.push(unmatchedSaved[h].raw); });
        Object.keys(sel).forEach(function (h) {
          var ids = sel[h].ids || {};
          var r = reconfirm[h], miss = {};
          if (r) r.missing.forEach(function (m) { miss[m.key] = m.handle; });
          function field(key) { return ids[key] === '?' || ids[key] ? ids[key] : (miss[key] || ''); }
          savedValues.push(h + ':' + sel[h].e + '.' + field('eI') + '.' + field('c') + '.' +
            field('x') + '.' + field('r'));
        });
        if (savedValues.length) p.set('a', savedValues.join('~'));
        }
      }
      var s2 = p.toString();
      history.replaceState(null, '', location.pathname + (s2 ? '?' + s2 : '') + location.hash);
    } catch (e) { /* file:// and sandboxed previews can refuse; the builder keeps working */ }
    updatePrintReopen();
  }

  function showMode(next, moveFocus) {
    batteryMode = !!next;
    $('[data-upsb-builder-main]').hidden = batteryMode;
    $('[data-upsb-battery-mode]').hidden = !batteryMode;
    if (!batteryMode) maybeViewBuilder();
    if (moveFocus) {
      var focusTarget = batteryMode ? $('[data-upsb-bf-input]') : $('[data-battery-entry]');
      if (focusTarget && focusTarget.focus) focusTarget.focus();
    }
  }
  function chooseMode(next) {
    if (batteryMode === !!next) return;
    syncUrl();
    try {
      var params = new URLSearchParams(location.search);
      if (next) params.set('mode', 'battery'); else params.delete('mode');
      var query = params.toString();
      history.pushState(null, '', location.pathname + (query ? '?' + query : '') + location.hash);
    } catch (e) { /* Keep the in-memory draft usable when history is unavailable. */ }
    showMode(next, true);
  }

  // RD.03c/RD.03d: raw a= entries from the URL; validated against the results once the
  // index is in. Each accessory field is either a product handle (new format), a legacy
  // positional integer (RD.03c links), or '' for "none". Single-entry links still work.
  function parseAddonParams() {
    var out = [], values = [];
    try {
      var p = new URLSearchParams(location.search);
      values = p.getAll('a');
      var seen = {};
      values.forEach(function (v) { v.split('~').forEach(function (entry) {
        var ci = entry.indexOf(':');
        if (ci < 1 || entry.length > 512) throw new Error('invalid saved entry');
        var handle = entry.slice(0, ci);
        if (!/^[A-Za-z0-9][A-Za-z0-9-]{0,127}$/.test(handle) || seen[handle])
          throw new Error('invalid or duplicate saved handle');
        seen[handle] = true;
        var parts = entry.slice(ci + 1).split('.');
        if (parts.length !== 5) throw new Error('invalid saved fields');
        var qty = /^-?\d+$/.test(parts[0]) ? parseInt(parts[0], 10) : NaN;
        if (!Number.isSafeInteger(qty) || qty < 0 || qty > B.MAX_PACKS)
          throw new Error('invalid saved pack count');
        function field(x) {
          if (x === '') return { none: true };
          if (x === '?') return { unresolved: true };   // a hold this site wrote and must keep
          if (/^-?\d+$/.test(x)) return { legacy: parseInt(x, 10) };
          if (/^[A-Za-z0-9-]+$/.test(x)) return { handle: x };
          return null;
        }
        var f = parts.slice(1).map(field);
        if (f.some(function (x) { return x === null; })) throw new Error('invalid saved component');
        out.push({ h: handle, e: qty, fields: f, raw: entry });
      }); });
    } catch (e) { invalidSavedRaw = values.length ? values : ['?']; return []; }
    return out;
  }

  var ADDON_KIND_LABEL = null;   // set after T is merged with the locale strings
  function addonKindLabels() {
    if (!ADDON_KIND_LABEL) ADDON_KIND_LABEL = [T.addon_pack, T.addon_card, T.addon_bypass, T.addon_rails];
    return ADDON_KIND_LABEL;
  }

  function applyAddonParams(list) {
    if (!list.length || !index) return;
    list.forEach(function (a) { delete reconfirm[a.h]; });   // idempotent for reloads
    var res = B.solve(index, q, null, qualifyP91);
    list.forEach(function (a) {
      var e = null;
      for (var i = 0; i < res.length; i++) if (res[i].u.h === a.h) { e = res[i]; break; }
      if (!e) { unmatchedSaved[a.h] = a; return; } // preserve a valid saved request outside current results
      delete unmatchedSaved[a.h];
      var kinds = addonKindLabels();
      var s = { e: (a.e >= 0 && a.e <= B.MAX_PACKS) ? a.e : 0, eI: 0, c: -1, x: -1, r: -1,
                 ids: { eI: '', c: '', x: '', r: '' } };   // identity strings for the URL
      var need = { kinds: [], missing: [] };      // kinds: [{key,label}], missing: [{handle,key,label}]
      var optsLists = [e.opts.e, e.opts.c, e.opts.x, e.opts.r];
      var selKeys = ['eI', 'c', 'x', 'r'];
      a.fields.forEach(function (f, k) {
        var key = selKeys[k], opts = optsLists[k];
        var hold = function () { need.kinds.push({ key: key, label: kinds[k] }); s.ids[key] = '?'; };
        var missing = function () {
          need.missing.push({ handle: f.handle, key: key, label: kinds[k] });
          need.kinds.push({ key: key, label: kinds[k] });
          s.ids[key] = f.handle;
          if (key === 'eI') s.eI = -1; else s[key] = -1;
        };
        if (f.unresolved) {                       // this site's own hold marker: keep the hold
          hold();
          if (key === 'eI') s.eI = -1; else s[key] = -1;
        } else if (f.none) {
          if (key === 'eI' && s.e > 0) {          // blank pack with a positive quantity: which model?
            hold(); s.eI = -1;
          }                                       // else "none picked": restorable, no hold
        } else if (f.handle) {
          var at = -1;
          for (var j = 0; j < opts.length; j++) if (String(opts[j][0]) === f.handle) { at = j; break; }
          if (at >= 0) {
            s[key] = at;                          // stable identity: exact restore
            s.ids[key] = f.handle;
          } else {
            // removed from the catalogue or no longer compatible with this UPS. Keep the
            // saved identity visible, select NO substitute, and hold the row: for a pack
            // the saved quantity stays (eI -1 adds nothing to the configured solution).
            missing();
          }
        } else if (f.legacy >= 0) {
          // RD.03c positional link. Without the option list as it was at save time the
          // original accessory cannot be proven, even when one option remains today, and
          // even when the index is out of range today (the list may have SHRUNK; the
          // saved index 3 with one option left still means a real selection existed).
          // Every old nonnegative selected index is unresolved: nothing is selected,
          // nothing is guessed, the buyer reconfirms. Legacy -1 meant "none": safe.
          if (key !== 'eI' || s.e > 0 || f.legacy > 0) {
            hold();
            if (key === 'eI') s.eI = -1; else s[key] = -1;
          }
        }
      });
      sel[a.h] = s;
      if (need.kinds.length || need.missing.length) reconfirm[a.h] = need;
    });
  }

  // RD.03d: fact lines for rows whose saved choices need the buyer's eye again.
  function reconfirmFacts(e) {
    var h = e.u.h;
    var out = [], r = reconfirm[h];
    if (!r) return out;
    for (var i = 0; i < r.missing.length; i++) {
      var m = r.missing[i];
      if (e.bundleReview) {
        var request = m.key === 'eI' && sel[h] && sel[h].e > 0 ?
          fill(T.bundle_saved_pack, { n: sel[h].e, h: m.handle }) :
          fill(T.bundle_saved_addon, { k: m.label, h: m.handle });
        out.push(['confirm', request]);
        continue;
      }
      var includedCard = h === '9px1500rtn-l' && m.key === 'c' && m.handle === 'eaton-network-m3';
      var line = includedCard ? T.saved_included_card : fill(T.saved_missing, { h: m.handle });
      if (m.key === 'eI' && sel[h] && sel[h].e > 0) line = fill(T.packs_missing, { n: sel[h].e }) + ' (' + m.handle + ')';
      out.push(['confirm', line]);
    }
    if (r.kinds.length) out.push(['confirm', e.bundleReview ? T.bundle_saved_reconfirm :
      fill(T.reconfirm_saved, { k: r.kinds.map(function (k) { return k.label; }).join(', ') })]);
    return out;
  }

  function $(sel) { return root.querySelector(sel); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function num(m) { return (Math.round(m * 10) / 10).toString().replace('.', FR ? ',' : '.'); }
  // round 14: the load echo with a thousands separator (15 000 W / 15,000 W), as the prices on the same card
  function watts(w) { var n = Math.round(Number(w) || 0); return FR ? n.toLocaleString('fr-CA').replace(/\s/g, '\u00a0') : n.toLocaleString('en-CA'); }
  function money(c) {
    if (!c) return T.quote_price;
    var v = c / 100;
    return FR ? v.toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' $'
              : '$' + v.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fill(s, map) { return s.replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function selFor(e) { return sel[e.u.h] || e.def; }
  function conf(e) { return B.configure(e, selFor(e)); }
  function physical(e) { return B.buyerPhysicalFit(e, selFor(e), q, index); }
  function placementContext(e) { return B.towerPlacementContext(e, selFor(e), index); }
  function placementAnswer(e) { return B.towerPlacementAnswer(e, selFor(e), q, index); }
  function selectedTowerPack(e) {
    var handle = e.u.h;
    var items = conf(e).items;
    return items.find(function (it) { return P80_TOWER_PACKS[it[0]] === handle; }) || null;
  }
  function placementCard(e) {
    var context = placementContext(e);
    if (!context || q.fit !== 'tower') return '';
    var answer = placementAnswer(e), h = e.u.h;
    var pack = selectedTowerPack(e);
    var conditions = T['tower_placement_' + ({
      'xpc-p80-1500': 'p80_1500', 'xpc-p80-3000v2': 'p80_3000',
      'xpc-p91-1500': 'p91_1500', 'xpc-p91-3000': 'p91_3000'
    })[h]];
    var choices = [['yes', T.tower_placement_yes], ['no', T.tower_placement_no],
      ['unsure', T.tower_placement_unsure]];
    return '<fieldset class="upsb-sb__placement" data-placement-h="' + esc(h) + '">' +
      '<legend>' + esc(T.tower_placement_title) + '</legend><p>' + esc(conditions) + '</p>' +
      (pack ? '<ul>' + [T.tower_pack_setup, T.tower_pack_clearance, T.tower_pack_environment].map(function (line) {
        return '<li>' + esc(fill(line, { pack: P80_TOWER_PACK_LABELS[pack[0]] })) + '</li>'; }).join('') +
        '</ul><p>' + esc(T.tower_pack_scope) + '</p>' : '') +
      '<p>' + esc(T.tower_placement_question) + '</p>' +
      choices.map(function (choice) { return '<label><input type="radio" name="tower-placement-' + esc(h) +
        '" value="' + choice[0] + '" data-placement-answer="' + esc(h) + '"' +
        (answer === choice[0] ? ' checked' : '') + '> ' + esc(choice[1]) + '</label>'; }).join('') +
      '<details><summary>' + esc(T.tower_placement_details) + '</summary><p>' +
      esc(pack ? T.tower_pack_source : T.tower_placement_source) + '</p><p>' + esc(fill(T.tower_placement_revision,
        { version: context.version, source: context.manifest })) + '</p></details></fieldset>';
  }
  function placementQuoteLine(e) {
    var context = placementContext(e);
    if (!context || q.fit !== 'tower') return '';
    var answer = placementAnswer(e);
    var pack = selectedTowerPack(e);
    var label = answer === 'yes' ? T.tower_placement_yes :
      (answer === 'no' ? T.tower_placement_no :
      (answer === 'unsure' ? T.tower_placement_unsure : T.tower_placement_unanswered));
    return fill(pack ? T.tower_placement_quote_pack : T.tower_placement_quote,
      { answer: label, pack: pack ? P80_TOWER_PACK_LABELS[pack[0]] : '' });
  }
  function physicalLines(e) {
    var p = physical(e), lines = [];
    if (p.reasons.indexOf('mounting_choice') >= 0) return [(q.rackU || q.depth) ? T.physical_mounting : T.physical_convertible];
    if (p.orientation !== 'rack') {
      if (p.reasons.indexOf('tower_unsupported') >= 0) lines.push(T.physical_tower_unsupported);
      if (p.reasons.indexOf('tower_placement') >= 0) lines.push(T.tower_placement_review);
      return lines.concat(missingLines(p));
    }
    if (p.available_u && p.known_min_u > p.available_u)
      lines.push(fill(p.required_u === null ? T.physical_u_over : T.physical_u_over_exact,
        { u: num(p.known_min_u), available: num(p.available_u) }));
    else if (p.required_u !== null)
      lines.push(fill(p.available_u ? T.physical_u_total : T.physical_u_unlimited,
        { u: num(p.required_u), available: num(p.available_u) }));
    else if (p.known_min_u) lines.push(fill(T.physical_u_min, { u: num(p.known_min_u) }));
    if (p.available_depth_in && p.known_min_depth_in > p.available_depth_in)
      lines.push(fill(T.physical_depth_over,
        { d: num(p.known_min_depth_in), available: num(p.available_depth_in) }));
    else if (p.required_depth_in !== null && p.required_depth_in > 0)
      lines.push(fill(T.physical_depth_total, { d: num(p.required_depth_in) }));
    else if (p.known_min_depth_in)
      lines.push(fill(T.physical_depth_min, { d: num(p.known_min_depth_in) }));
    return lines.concat(missingLines(p));
  }
  // Builder UX pass: unverified rack/tower dimensions read as one plain line, not one line per product handle.
  function missingLines(p) {
    var out = [], dims = false;
    p.missing.forEach(function (m) {
      if (/^(rack|tower)\./.test(m.fact)) { dims = true; return; }
      out.push(fill(T.physical_missing,
        { handle: m.handle, n: m.quantity, fact: T['physical_fact_' + m.fact.replace(/\./g, '_')] || T.cmp_unknown }));
    });
    if (dims) out.unshift(T.physical_dims_unverified);
    return out;
  }
  // 2026-09-29 (Christian: the quote-only builder "needs to be fixed"): unknown dimensions no longer
  // block Add to cart. A known conflict (rack U, depth, tower unsupported), a buyer's "no" to the tower
  // placement question, a rack-space or depth limit the buyer entered but we cannot check, or a missing
  // non-dimension fact (selected pack, bundle contents) still blocks.
  // Every other cart rule (outlet, runtime, card, price, CAD 10,000 quote-only) is unchanged.
  function physicalCartOk(e) {
    var p = physical(e);
    if (p.status === 'pass') return true;
    if (p.status !== 'review') return false;
    // A rack-space or depth limit the buyer typed must be checked, not warned about.
    if ((q.rackU || q.depth) && p.orientation !== 'tower') return false;
    if (p.reasons.some(function (r) { return r !== 'mounting_choice' && r !== 'tower_placement'; })) return false;
    if (p.reasons.indexOf('tower_placement') >= 0 && placementAnswer(e) === 'no') return false;
    return p.missing.every(function (m) { return /^(rack|tower)\./.test(m.fact); });
  }
  function physicalHeadline(e) {
    var p = physical(e);
    if (p.status === 'pass') return '';
    if (p.status === 'review') return p.reasons.indexOf('mounting_choice') >= 0 ? ((q.rackU || q.depth) ? T.physical_mounting : '') :
      (physicalCartOk(e) ? T.physical_confirm : T.physical_review);
    if (p.reasons.indexOf('rack_u') >= 0)
      return fill(p.required_u === null ? T.physical_u_over : T.physical_u_over_exact,
        { u: num(p.known_min_u), available: num(p.available_u) });
    if (p.reasons.indexOf('depth') >= 0)
      return fill(T.physical_depth_over, { d: num(p.known_min_depth_in), available: num(p.available_depth_in) });
    return p.reasons.indexOf('tower_unsupported') >= 0 ? T.physical_tower_unsupported : T.physical_review;
  }
  function selectedRuntime(e) {
    var s = selFor(e);
    return s.e > 0 ? B.packRuntime(e, s, q.load) : e.rt;
  }
  function runtimeStatus(e) {
    var rt = selectedRuntime(e);
    return !rt || !(rt.min > 0) ? 'unknown' : (rt.min >= q.runtime ? 'meets' : 'short');
  }
  function networkReady(e) { var s = selFor(e);
    if (e.u.card === '' && s.c >= 0 && e.opts.c[s.c]) return false; // selected extra needs commercial review
    return !q.card || e.u.card === '1' || (e.u.card === '0' && s.c >= 0 && !!e.opts.c[s.c]); }
  function outletIssue(e) {
    if (q.outlet === 'unknown') return T.outlet_unknown_hold;
    if (q.outlet === 'HW' || /HARD ?WIRE/i.test(e.u.plug || '')) return T.hardwired_hold;
    if (e.mismatch) return T.fit_wrong_outlet;
    if (e.plugUnknown || B.plugFits(q.outlet, e.u.plug) !== 'yes') return T.plug_confirm;
    return '';
  }
  function updateP91OutputContext() {
    var panel = $('[data-p91-output-context]');
    if (!panel) return;
    var relevant = lastRes.some(function (e) { return p91Target(e.u.h); }) ||
      Object.keys(sel).some(p91Target) || Object.keys(unmatchedSaved).some(p91Target) ||
      quote.some(function (row) { return /(^|\W)xpc-p91-(1000|1500|2000|3000)(\W|$)/.test(row.model || ''); });
    panel.hidden = !(relevant || q.outputV || urlHolds.outputV);
    if (q.outputV || urlHolds.outputV) panel.open = true;
  }

  function p91Target(handle) { return /^xpc-p91-(1000|1500|2000|3000)$/.test(handle || ''); }
  function qualifyP91(e) {
    if (!p91Target(e.u.h)) return e;
    if (P91 && P91.decorateOne) return P91.decorateOne(p91Projection, e, q);
    var copy = Object.assign({}, e);
    copy.confirm = e.confirm + 1;
    copy.p91Capacity = { state: 'projection_unavailable', purchase_approved: false };
    return copy;
  }
  function p91Detail(e) {
    var review = e.p91Capacity;
    if (!review) return '';
    if (review.state === 'projection_unavailable') return T.p91_unavailable;
    var intro = fill(T.p91_nameplate, { va: review.published_nameplate_va,
      w: review.published_nameplate_w, supply: review.incoming_supply_v || T.p91_output_unknown });
    var key = review.state === 'published_basis_watt_candidate' ? 'p91_127' :
      review.state === 'nominal_120_capacity_unestablished' ? 'p91_120' :
      review.state === 'lower_setting_capacity_unestablished' ? 'p91_lower' :
      review.state === 'requested_setting_not_in_current_flyer' ? 'p91_other' : 'p91_unknown';
    return intro + ' ' + fill(T[key], { output: review.requested_output_v }) + ' ' + T.p91_runtime;
  }
  function p91RuntimeEvidence(rt) {
    if (!rt || !(rt.min > 0) || !Number.isFinite(rt.min)) return T.p91_runtime_unknown;
    var key = rt.atLeast ? 'p91_runtime_bound' : (rt.est ? 'p91_runtime_estimate' : 'p91_runtime_exact');
    return fill(T[key], { m: num(rt.min), w: num(q.load) });
  }
  function p91Quote(e, rt) {
    var r = e.p91Capacity, s = selFor(e), pack = s.e > 0 && e.opts.e[s.eI] ?
      s.e + ' x ' + e.opts.e[s.eI][0] : (s.e > 0 ? s.e + ' x ' + T.cmp_unknown : T.p91_pack_none);
    var runtime = p91RuntimeEvidence(rt);
    return fill(T.p91_quote, { model: e.u.h, load: q.load,
      supply: q.power, output: q.outputV ? q.outputV + ' V' : T.p91_output_unknown,
      va: r.published_nameplate_va == null ? T.cmp_unknown : r.published_nameplate_va,
      w: r.published_nameplate_w == null ? T.cmp_unknown : r.published_nameplate_w,
      runtime: runtime, pack: pack }) + (r.state === 'projection_unavailable' ? ' ' + T.p91_unavailable : '');
  }

  function typedInputSummary(e) {
    var r = e.inputVoltage;
    if (!r) return '';
    var key = { source_unavailable: 'input_voltage_missing', supply_unspecified: 'input_voltage_unspecified',
      exact_supply_needed: 'input_voltage_exact', listed_candidate: 'input_voltage_listed',
      not_listed_review: 'input_voltage_unlisted', range_only_review: 'input_voltage_range',
      nominal_candidate: 'input_voltage_nominal', different_nominal_review: 'input_voltage_other_nominal' }[r.state] || 'input_voltage_missing';
    return fill(T[key], { supply: r.requested_supply, nominal: r.nominal_input_v });
  }
  function typedInputDetail(e) {
    var r = e.inputVoltage;
    if (!r) return '';
    var parts = [fill(T.input_voltage_printed, { literal: r.literal_input_expression || T.input_voltage_none })];
    if (r.operating_range_v) parts.push(fill(T.input_voltage_range_detail,
      { range: r.operating_range_v.join('–') + ' V' }));
    if (/depending on load level/i.test(r.load_footnote || '')) parts.push(T.input_voltage_load_detail);
    if (r.source_page) parts.push(fill(T.input_voltage_reference, { page: r.source_page }));
    parts.push(T.input_voltage_delivery);
    return parts.join(' ');
  }
  function typedInputSourceUrl(e) {
    var url = e.inputVoltage && e.inputVoltage.source_url;
    return typeof url === 'string' && /^https:\/\/xpcc\.com\/wp-content\/uploads\/[a-z0-9._-]+\.pdf$/i.test(url) ? url : '';
  }
  function typedInputQuote(e) {
    var r = e.inputVoltage;
    var supply = r && r.requested_supply;
    return r ? fill(T.input_voltage_quote, { model: e.u.h,
      supply: /^\d+(?:-\d+)?$/.test(String(supply)) ? supply + ' V' :
        (supply === 'three-phase' ? T.req_power_three : T.req_power_unknown),
      summary: typedInputSummary(e), literal: r.literal_input_expression || T.input_voltage_none,
      page: r.source_page || T.input_voltage_none }) : '';
  }
  function typedInputProvenance(e) {
    var r = e.inputVoltage, overlay = index && index.input_voltage_v2;
    var record = r && overlay && overlay.records && overlay.records[e.u.h];
    if (!r || r.state === 'source_unavailable' || !record || !record.typed ||
        !record.typed.evidence) return null;
    return { factSha: r.source_fact_sha256, documentSha: record.typed.evidence.sha256,
      sidecarSha: overlay.source_sidecar_sha256, url: r.source_url,
      revision: r.source_revision, page: r.source_page, kind: r.source_kind };
  }


  Object.assign(T, FR ? {
    j60_review: 'Onduleur J60 : vérifiez la version {voltage} V fournie, la marge de profondeur installée et l’autonomie réelle avant achat.',
    j60_missing: 'Source J60 indisponible : caractéristiques et configuration à confirmer.',
    j60_exact: 'La plage 208–240 V ne précise pas la tension exacte du site; confirmez-la pour la version J60Ci 230 V.',
    j60_details: 'Détails du fabricant J60',
    j60_outlets: 'Quatre prises {type} sont secourues par batterie; la cinquième est protégée contre les surtensions seulement.',
    j60_runtime: 'Tableau d’autonomie approximatif à 25 °C, de 30 à 360 W. Le vieillissement et les conditions du site peuvent modifier l’autonomie.',
    j60_depth: 'Châssis 1U, profondeur 8,5 po; la marge pour les câbles et la profondeur installée restent à confirmer.',
    j60_source: 'Voir la fiche technique du fabricant',
    j60_quote: 'Version J60, quatre prises secourues et une prise surtension, profondeur installée et autonomie réelle à confirmer.'
  } : {
    j60_review: 'J60 UPS: confirm the supplied {voltage} V variant, installed depth clearance and actual runtime before purchase.',
    j60_missing: 'J60 source unavailable: specifications and configuration need review.',
    j60_exact: 'The 208–240 V range does not specify the site’s exact supply; confirm it for the 230 V J60Ci variant.',
    j60_details: 'J60 manufacturer details',
    j60_outlets: 'Four {type} outlets have battery backup; the fifth is surge-only.',
    j60_runtime: 'Approximate 25 °C runtime table covers 30–360 W. Battery age and site conditions can change runtime.',
    j60_depth: '1U chassis, 8.5 in deep; cable clearance and installed depth still need confirmation.',
    j60_source: 'View manufacturer specification',
    j60_quote: 'Confirm J60 variant, four backed and one surge-only outlet, installed depth and actual runtime.'
  });
  function j60Summary(e) {
    if (!e.j60 || !e.j60.source) return T.j60_missing;
    return e.j60.state === 'exact_supply_needed' ? T.j60_exact :
      fill(T.j60_review, { voltage: e.j60.source.nominal_input_v });
  }
  function j60Detail(e) {
    if (!e.j60 || !e.j60.source) return '';
    var record = e.j60.source;
    return '<details class="upsb-sb__j60-source"><summary>' + esc(T.j60_details) +
      '</summary><p>' + esc(fill(T.j60_outlets, { type: record.outlet_type })) +
      '</p><p>' + esc(T.j60_runtime) + '</p><p>' + esc(T.j60_depth) +
      '</p><p><a href="https://xpcc.com/wp-content/uploads/J60C-flyer.pdf" target="_blank" rel="noopener noreferrer">' +
      esc(T.j60_source) + '</a></p></details>';
  }

  function cartEligible(e) { return !needsTechnicalReview() && !e.tooBig && !e.j60 && !e.inputVoltage && !p91Target(e.u.h) && !e.bundleReview && !invalidSavedRaw.length && !hasInputHolds() && !outletIssue(e) && q.load > 0 && q.runtime > 0 && runtimeStatus(e) === 'meets' && networkReady(e) && physicalCartOk(e) && !reconfirm[e.u.h] && !discontinuedNoStock(e); }
  // A discontinued model with no stock cannot be promised: quote path only (Master, round 4, 09-30).
  function discontinuedNoStock(e) { return e.u.lc === 'D' && !e.u.stk; }
  function cartBlockedReason(e) {
    if (p91Target(e.u.h)) return 'capacity_review';
    if (e.j60) return 'j60_source_review';
    if (e.inputVoltage) return 'input_voltage_review';
    if (invalidSavedRaw.length) return 'invalid_saved';
    if (hasInputHolds() || q.load <= 0 || q.runtime <= 0) return 'invalid_requirements';
    if (outletIssue(e)) return 'outlet';
    if (!physicalCartOk(e)) return 'physical_fit';
    if (reconfirm[e.u.h]) return 'saved_review';
    if (e.bundleReview || !networkReady(e)) return 'required_component';
    if (runtimeStatus(e) !== 'meets') return 'runtime';
    return 'unknown';
  }
  function cartFingerprint(e) { return JSON.stringify(normalizedRequirements(q)) + '|' + JSON.stringify(conf(e).items) + '|' + JSON.stringify(physical(e)) + '|' + (e.inputVoltage ? e.inputVoltage.source_fact_sha256 || 'source-unavailable' : ''); }
  function cartCurrent(e) { return inCart[e.u.h] && cartEligible(e) && inCart[e.u.h] === cartFingerprint(e); }
  function itemLabel(it) { return (it[3] > 1 ? it[3] + ' x ' : '') + it[1]; }
  function optLabel(it) { return it[1] + ' (' + money(it[2]) + ')'; }

  // The row heading cut short at the first capacity/voltage number: vendor, family, model
  // as the row shows it (e.g. "Xtreme Power P91-3000"). Bare numbers ("700", "3,000") and
  // capacity tokens ("3000VA") end it; model numbers with letters ("17071-01R") pass through.
  function shortModel(u) {
    var words = String(u.t || u.h || '').split(/\s+/), out = [];
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (/^[\d.,]+$/.test(w) || /^\d+(?:[.,]\d+)?(?:VA|W|kVA|kW)$/i.test(w)) break;
      out.push(w);
    }
    return out.join(' ') || u.h;
  }

  // Add-ons panel (W1): one choice per kind from the evidenced compatible accessories, pack quantity 0-8.
  function addons(e, i) {
    var o = e.opts, s = selFor(e), h = '';
    function pick(k, label) {
      if (!o[k].length) return '';
      var opts = '<option value="-1">' + esc(T.none) + '</option>' + o[k].map(function (it, j) {
        return '<option value="' + j + '"' + (s[k] === j ? ' selected' : '') + '>' + esc(optLabel(it)) + '</option>';
      }).join('');
      return '<label>' + esc(label) + '<select data-addon="' + k + '" data-i="' + i + '">' + opts + '</select></label>';
    }
    if (o.e.length) {
      var qn = '';
      for (var n = 0; n <= B.MAX_PACKS; n++) qn += '<option value="' + n + '"' + (s.e === n ? ' selected' : '') + '>' + n + '</option>';
      h += '<label>' + esc(T.addon_pack_qty) + '<select data-addon="e" data-i="' + i + '">' + qn + '</select></label>';
      // Astra rework 2, defect 3: a held/unresolved pack model must be confirmable in
      // the UI. Render the model select whenever more than one option exists OR the
      // selection is unresolved (s.eI < 0 with packs in play); an unresolved selection
      // gets an explicit "(to confirm)" placeholder so nothing looks chosen.
      var eUnresolved = s.eI < 0 && (s.e > 0 || (sel[e.u.h] && sel[e.u.h].ids && sel[e.u.h].ids.eI === '?'));
      if (o.e.length > 1 || eUnresolved) {
        h += '<label>' + esc(T.addon_pack) + '<select data-addon="eI" data-i="' + i + '">' +
          (eUnresolved ? '<option value="-1" selected>' + esc(T.cmp_unknown) + '</option>' : '') +
          o.e.map(function (it, j) {
            return '<option value="' + j + '"' + (s.eI === j ? ' selected' : '') + '>' + esc(optLabel(it)) + '</option>';
          }).join('') + '</select></label>';
      } else {
        h += '<p class="upsb-sb__addon-one">' + esc(optLabel(o.e[0])) + '</p>';
      }
    }
    h += pick('c', T.addon_card) + pick('x', T.addon_bypass) + pick('r', T.addon_rails);
    var pending = reconfirm[e.u.h];
    if (pending) pending.kinds.forEach(function (kind) {
      var isIncludedCard = e.u.h === '9px1500rtn-l' && kind.key === 'c' &&
        pending.missing.some(function (m) { return m.key === 'c' && m.handle === 'eaton-network-m3'; });
      var label = isIncludedCard ? T.saved_discard_included_card :
        (kind.key === 'eI' ? fill(T.saved_discard_pack, { n: s.e }) :
          fill(T.saved_discard, { k: kind.label }));
      h += '<button type="button" class="button button--tertiary" data-discard-saved-addon="' +
        esc(kind.key) + '" data-i="' + i + '">' + esc(label) + '</button>';
    });
    if (!h) return '';
    // RD.03d: a row with unrestorable saved choices opens its add-on panel so the
    // reconfirmation line and the controls sit together
    return '<details class="upsb-sb__addons" data-addons-h="' + esc(e.u.h) + '"' +
      ((openAdd[e.u.h] || reconfirm[e.u.h]) ? ' open' : '') + '><summary>' +
      esc(T.addons) + '</summary><p class="upsb-sb__addon-why">' + esc(T.addon_why) + '</p><div class="upsb-sb__addons-body">' + h + '</div></details>';
  }

  function readForm() {
    var f = $('[data-upsb-form]');
    if (!urlHolds.load) q.load = Math.max(0, parseFloat(f.elements.load.value) || 0);
    if (!urlHolds.runtime) q.runtime = Math.max(0, parseFloat(f.elements.runtime.value) || 0);
    if (!urlHolds.power) q.power = f.elements.power.value;
    if (!urlHolds.outputV) q.outputV = f.elements.outputV.value;
    if (!urlHolds.outlet) q.outlet = f.elements.outlet.value;
    if (!urlHolds.fit) q.fit = f.elements.fit.value;
    if (!urlHolds.chemistry) q.chemistry = f.elements.chemistry.value;
    if (!urlHolds.plugNeed) q.plugNeed = f.elements.plugNeed.value;
    if (!urlHolds.rackU) q.rackU = parseInt(f.elements.rackU.value, 10) || 0;
    if (!urlHolds.depth) q.depth = parseFloat(f.elements.depth.value) || 0;
    if (!urlHolds.gen) q.generator = f.elements.generator.checked;
    if (!urlHolds.card) q.card = f.elements.card.checked;
    if (!urlHolds.monitorWatts) q.monitorWatts = f.elements.monitorWatts.checked;
    if (!urlHolds.shutdownNeed) q.shutdownNeed = f.elements.shutdownNeed.value;
    if (!urlHolds.shutdownPlatform) q.shutdownPlatform = f.elements.shutdownPlatform.value;
    updateMonitoringForm();
  }
  function updateMonitoringForm() {
    var f = $('[data-upsb-form]');
    var needsPlatform = q.shutdownNeed === 'safe_os' || q.shutdownNeed === 'both' ||
      !!urlHolds.shutdownPlatform || !!(q.shutdownPlatform && q.shutdownNeed === 'unspecified');
    f.querySelector('[data-shutdown-platform]').hidden = !needsPlatform;
  }
  function writeForm() {
    var f = $('[data-upsb-form]');
    f.elements.load.value = initialNumericFromUrl.load !== undefined ? initialNumericFromUrl.load : q.load;
    f.elements.runtime.value = initialNumericFromUrl.runtime !== undefined ? initialNumericFromUrl.runtime : q.runtime;
    f.elements.power.value = q.power; f.elements.outputV.value = q.outputV; f.elements.outlet.value = q.outlet; f.elements.fit.value = q.fit;
    f.elements.chemistry.value = q.chemistry; f.elements.plugNeed.value = q.plugNeed;
    f.elements.rackU.value = initialNumericFromUrl.rackU !== undefined ? initialNumericFromUrl.rackU : (q.rackU || '');
    f.elements.depth.value = initialNumericFromUrl.depth !== undefined ? initialNumericFromUrl.depth : (q.depth || '');
    f.elements.generator.checked = !!q.generator; f.elements.card.checked = !!q.card;
    var generatorNote = root.querySelector('[data-generator-preset-note]');
    if (generatorNote) generatorNote.hidden = !generatorSuggested;
    f.elements.monitorWatts.checked = !!q.monitorWatts;
    f.elements.shutdownNeed.value = q.shutdownNeed;
    f.elements.shutdownPlatform.value = q.shutdownPlatform;
    ['power', 'outputV', 'outlet', 'fit', 'chemistry', 'plugNeed', 'shutdownNeed'].forEach(function (key) {
      var el = f.elements[key];
      if (!el || !el.querySelector) return;
      var old = el.querySelector('[data-invalid-placeholder]');
      if (old) old.remove();
      if (urlHolds[key]) {
        var option = document.createElement('option');
        option.value = ''; option.textContent = T.input_hold_choose;
        option.setAttribute('data-invalid-placeholder', '');
        el.insertBefore(option, el.firstChild); el.value = '';
      }
    });
    updateMonitoringForm();
    initialNumericFromUrl = {};
  }
  function renderInputHolds() {
    var panel = $('[data-input-holds]'), keys = Object.keys(urlHolds);
    var savedCount = quote.reduce(function (n, x) { return n + (rowHolds(x).length ? 1 : 0); }, 0);
    if (!keys.length && !savedCount) { panel.hidden = true; panel.innerHTML = ''; return; }
    var html = '<strong>' + esc(T.input_hold_title) + '</strong><p>' + esc(T.input_hold_blocked) + '</p>';
    if (keys.length) html += '<ul>' + keys.map(function (key) {
      return '<li>' + esc(holdText(urlHolds[key], true)) +
        ' <button type="button" class="button button--tertiary" data-url-hold-remove="' + esc(key) + '">' +
        esc(T.input_hold_remove) + '</button></li>';
    }).join('') + '</ul>';
    if (savedCount) html += '<p>' + esc(fill(T.input_hold_saved_rows, { n: savedCount })) + '</p>';
    var otherPath = (FR ? '' : '/fr') + location.pathname.replace(/^\/fr(?=\/)/, '');
    html += '<a class="upsb-sb__req-locale" href="' + esc(otherPath + location.search) + '">' +
      esc(T.req_locale_link) + '</a>';
    panel.innerHTML = html; panel.hidden = false;
  }

  // RD.03d: the card shows the SELECTED pack count and exact model; availability is a
  // separate, clearly labelled count (Astra: "1 compatible battery pack(s)" with zero
  // selected read as included in the configuration).
  function packFact(e) {
    var s = selFor(e), pk = s.eI >= 0 ? e.opts.e[s.eI] : null;
    if (e.bundleReview) return ['confirm', s.e > 0 ?
      fill(T.bundle_saved_pack, { n: s.e, h: (s.ids && s.ids.eI) || T.cmp_unknown }) : T.bundle_no_extra];
    if (s.e > 0 && pk) return ['ok', fill(pl('packs_selected', s.e), { n: s.e }) + ' (' + pk[1] + ')'];
    if (s.e > 0) return ['confirm', fill(T.packs_missing, { n: s.e })];   // qty without a resolvable model
    if (e.packs) return ['', T.packs_none + ' (' + fill(pl('packs_available', e.packs), { n: e.packs }) + ')'];
    return ['', T.packs_none];
  }

  function bundleSourceText(e) {
    var s = e && e.bundleSource;
    if (!s || !Array.isArray(s.manufacturer_included)) return T.bundle_source_unavailable;
    var parts = s.manufacturer_included.map(function (c) {
      var label = c.kind === 'described_unquantified' ? T['bundle_component_' + c.model.replace(/ /g, '_')] :
        T['bundle_component_' + c.kind];
      if (c.kind === 'battery_module' && c.model == null && (c.size_u === 2 || c.size_u === 3))
        return (c.quantity == null ? '' : c.quantity + ' ') + fill(T.bundle_component_battery_class, { u: c.size_u });
      return (c.quantity == null ? '' : c.quantity + ' ') + (label || c.kind) +
        (c.kind === 'four_post_rail_kit' || c.kind === 'described_unquantified' ? '' : ' ' + c.model);
    });
    return T.bundle_source_heading + ': ' + parts.join(', ') + '. ' + T.bundle_source_offer_hold;
  }
  function bundleRuntimeText(e) {
    var r = B.bundleRuntimeReference && B.bundleRuntimeReference(e, q);
    if (!r || r.state === 'source_mismatch' || r.state === 'runtime_source_unavailable') return T.bundle_runtime_source_hold;
    if (r.state === 'transformer_path_review') return T.bundle_runtime_transformer_hold;
    if (r.state === 'output_setting_review') return T.bundle_runtime_output_hold;
    if (r.state === 'requested_load_review') return T.bundle_runtime_load_hold;
    return T.bundle_runtime_output_hold;
  }
  function bundleSourceProvenance(e) {
    var s = e && e.bundleSource;
    if (s && s.source_scope === 'manufacturer_description_only')
      return { decisionSha: s.accepted_decision_sha256, pdfSha: s.source_pdf_sha256,
        recordSha: s.record_sha256, page: s.source_page };
    return s ? { workbookSha: s.workbook_sha256, descriptionSha: s.workbook_description_sha256,
      runtimeSha: s.runtime_source_sha256, pack: s.runtime_pack_handle } : null;
  }

  function receptacleText(rec) {
    var s = String(rec).replace(/;\s*/g, ', ');
    if (!FR) return s.replace(/\(surge\)/g, '(surge only)').replace(/\(backup unverified\)/g, '(battery backup to confirm)')
      .replace(/Hardwire terminal block/g, 'hardwired terminal block');
    return s.replace(/\(surge\)/g, '(surtension seulement)').replace(/\(backup unverified\)/g, '(alimentation par batterie à confirmer)')
      .replace(/Hardwire terminal block/g, 'bornier (raccordement fixe)').replace(/battery-backed/g, 'sur batterie')
      .replace(/surge-only/g, 'surtension seulement').replace(/(\d)x /g, '$1 x ');
  }
  function outputConnectionText(e) {
    var record = e && e.u && e.u.outputConnection;
    if (!record) return '';
    return record.kind === 'hardwired_terminal_blocks' ? T.output_connection_tx91 :
      record.kind === 'hardwired_standard_optional_pod' ? T.output_connection_ita2 : '';
  }
  // Each fact is [class, text, key]. Key facts stay on the card; the rest go under "Details and checks" (UX pass 09-30).
  function facts(e) {
    if (Object.keys(urlHolds).length) return [['confirm', T.input_hold_blocked, 1]];
    var u = e.u, out = [];
    if (outputConnectionText(e)) out.push(['confirm', outputConnectionText(e), 1]);
    if (e.j60) out.push(['confirm', j60Summary(e), 1]);
    if (e.inputVoltage) out.push(['confirm', typedInputSummary(e), 1]);
    if (e.p91Capacity) out.push(['confirm', p91Detail(e), 1]);
    if (e.bundleReview) {
      out.push(['confirm', bundleSourceText(e), 1]);
      out.push(['confirm', bundleRuntimeText(e), 1]);
    }
    var sp = selFor(e), pr = B.packRuntime(e, sp, q.load);
    if (e.rt) {
      var rtText = e.rt.atLeast ? fill(T.rt_at_least, { m: rtNum(e.rt.min), w: watts(q.load) }) :
        fill(e.rt.est ? T.rt_estimate : T.rt_published, { m: rtNum(e.rt.min), w: watts(q.load) });
      var rtCls = e.p91Capacity ? 'confirm' : (e.rt.atLeast || e.meets ? 'ok' : 'warn');
      if (pr) out.push(['', T.ups_alone + rtText, 0]);   // the battery-pack line below is the runtime that counts
      else out.push([rtCls, rtText, 1]);
    } else {
      out.push(['confirm', T.rt_confirm, pr ? 0 : 1]);
    }
    if (!e.bundleReview && (e.packs || sp.e > 0)) { var pf = packFact(e); out.push([pf[0], pf[1], pf[0] === 'confirm' ? 1 : 0]); }
    if (pr) {
      var line = pr.atLeast ? T.rt_at_least : (pr.est ? T.rt_estimate : T.rt_published);
      out.push([e.p91Capacity ? 'confirm' : (pr.min >= q.runtime ? 'ok' : 'warn'), fill(pl('with_n_packs', sp.e), { n: sp.e }) + fill(line, { m: rtNum(pr.min), w: watts(q.load) }), 1]);
    } else if (sp.e > 0 && !e.bundleReview) {
      out.push(['confirm', fill(pl('rt_with_packs', sp.e), { n: sp.e }), 1]);
    }
    var status = runtimeStatus(e);
    if (status === 'short') out.push(['warn', T.cart_runtime_short, 1]);
    // Builder reviews (2 Oct 2026): Samuel's rule, keep the load under 80 % of the watt rating; and the outlets the
    // equipment plugs into (store spec, index field rec).
    if (e.loadPct >= 0.8) out.push(['warn', fill(T.near_capacity, { p: Math.round(e.loadPct * 100) }), 1]);
    if (u.rec && !outputConnectionText(e)) out.push(['', fill(T.outlets, { rec: receptacleText(u.rec) }), 1]);
    if (status === 'unknown') out.push(['confirm', T.cart_runtime_unknown, 1]);
    if (e.bundleReview) {
      out.push(['confirm', T.plug_confirm, 1]);
    } else if (q.outlet === 'unknown') {
      out.push(['confirm', T.outlet_unknown_hold, 0]);
      if (u.plug) out.push(['', fill(T.plug_is, { p: u.plug }), 1]);
    } else if (q.outlet !== 'unknown') {
      if (e.mismatch) out.push(['bad', fill(T.plug_no, { p: u.plug }), 1]);
      else if (outletIssue(e)) out.push(['confirm', outletIssue(e), 1]);
      else out.push(['ok', fill(T.plug_ok, { p: u.plug }), 1]);
    } else if (u.plug && !/HARD ?WIRE/i.test(u.plug)) {   // hardwired units get the electrician line instead
      out.push(['', fill(T.plug_is, { p: u.plug }), 1]);
    }
    if (u.h === 'gxt5-2000lvrt2uxl') out.push(['confirm', T.gxt5_adapter, 1]);
    var pStatus = physical(e).status;
    physicalLines(e).forEach(function (line) { out.push([pStatus === 'mismatch' ? 'bad' :
      (pStatus === 'review' && line !== T.physical_convertible ? 'confirm' : 'ok'), line, pStatus === 'mismatch' ? 1 : 0]); });
    var sc = selFor(e);
    if (u.card === '1') out.push(['ok', T.card_in, q.card ? 1 : 0]);
    else if (u.card === '') {
      out.push(['confirm', T.card_confirm, q.card ? 1 : 0]);
      if (sc.c >= 0 && e.opts.c[sc.c]) out.push(['confirm', T.card_selected, 1]);
    } else if (sc.c >= 0 && e.opts.c[sc.c]) out.push(['ok', T.card_selected, 1]);
    else if (q.card) out.push(['', T.card_out, 1]);   // "optional" only matters when the buyer asked for a card
    if (q.card && !networkReady(e)) out.push(['confirm', T.cart_card_unknown, 1]);
    if (u.lc === 'D') {   // round 13: the successor shows on the card as on the page (its short model name when we list it)
      var sv = u.succ ? savedUnit(u.succ) : null;
      var sm = sv ? shortModel({ t: sv.title, h: u.succ }).split(' ') : [];
      while (sm.length > 2 && (/^UPS$/i.test(sm[0]) || /^[a-z\u00e0-\u00ff]/.test(sm[0]) || sm[0].indexOf('/') >= 0)) sm.shift();   // FR titles lead with the type words
      out.push(sv ? ['', fill(T.discontinued_succ, { m: sm.join(' ') }), 1] : ['', T.discontinued, 0]);
    }
    out = out.concat(reconfirmFacts(e).map(function (f) { return [f[0], f[1], 1]; }));   // RD.03d: saved choices that need the buyer again
    (e.deps || []).forEach(function (d) {
      if (d[0] === 'card_separate' && sc.c >= 0) return;   // the buyer already added a card
      if (d[0] === 'rails' && sc.r >= 0) return;
      var outletNeed = /^(needs_|hardwired)/.test(d[0]);
      if (/^needs_/.test(d[0]) && q.outlet && q.outlet !== 'unknown' && B.plugFits(q.outlet, u.plug) === 'yes') return;   // round 13: the buyer's outlet already fits; no electrician line
      if (T['dep_' + d[0]]) out.push(['dep', fill(T['dep_' + d[0]], { x: d[1] }), outletNeed && q.outlet === 'unknown' ? 1 : 0]);
    });
    return out;
  }

  // The form fires 'input' (renders) and then 'change' on blur. Rendering again on that change replaced the results
  // under the buyer's pointer: typing a load and clicking "Add to cart" lost the first click. Same answers: no re-render.
  var lastQ = '';
  function resetShownIfRequirementsChanged(before) {
    if (JSON.stringify(normalizedRequirements(q)) !== before) shownCount = 12;
  }
  function renderIfChanged() {
    var before = JSON.stringify(normalizedRequirements(q));
    var nextFit = $('[data-upsb-form]').elements.fit.value;
    if (q.fit !== nextFit) q.towerPlacement = {};
    readForm(); resetShownIfRequirementsChanged(before);
    if (JSON.stringify(q) !== lastQ) render();
    commitRequirements('buyer');
  }
  function monitoringFacts(r, held) {
    var parts = [], platform = r.shutdownPlatform || T.req_shutdown_platform_tbc;
    if (r.monitorWatts && !held('monitorWatts')) parts.push(T.req_watts);
    if (held('shutdownNeed')) return parts;
    if (r.shutdownNeed === 'safe_os') parts.push(fill(T.req_shutdown_safe,
      { platform: held('shutdownPlatform') ? T.req_shutdown_platform_tbc : platform }));
    else if (r.shutdownNeed === 'power_off') parts.push(T.req_shutdown_power);
    else if (r.shutdownNeed === 'both') parts.push(fill(T.req_shutdown_both,
      { platform: held('shutdownPlatform') ? T.req_shutdown_platform_tbc : platform }));
    else if (r.shutdownNeed === 'help') parts.push(T.req_shutdown_help);
    else if (r.shutdownPlatform && !held('shutdownPlatform'))
      parts.push(fill(T.req_shutdown_mode_tbc, { platform: r.shutdownPlatform }));
    return parts;
  }
  function answersLine() {
    var parts = [];
    if (q.load && !urlHolds.load) parts.push(q.load.toLocaleString(FR ? 'fr-CA' : 'en-CA') + ' W');
    if (q.runtime && !urlHolds.runtime) parts.push(num(q.runtime) + ' min');
    var volts = { '120': '120 V', '208-240': '208-240 V', '230': '230 V',
                  'unknown': T.ans_volt_unknown, 'three-phase': T.ans_three_phase };
    if (volts[q.power] && !urlHolds.power) parts.push(fill(T.p91_input_label, { supply: volts[q.power] }));
    if (q.outputV && !urlHolds.outputV) parts.push(fill(T.p91_only_saved, { output: q.outputV + ' V' }));
    if (!urlHolds.outlet) parts.push(q.outlet === 'unknown' ? T.ans_outlet_unknown : q.outlet);
    if (!urlHolds.fit) parts.push(q.fit === 'rack' ? T.fit_rack : (q.fit === 'tower' ? T.fit_tower : T.fit_either));
    if (q.rackU && !urlHolds.rackU) parts.push(fill(T.rack_limit, { u: q.rackU }));
    if (q.depth && !urlHolds.depth) parts.push(fill(T.depth_limit, { d: num(q.depth) }));
    if (q.generator && !urlHolds.gen) parts.push(T.ans_generator);
    if (q.card && !urlHolds.card) parts.push(T.ans_card);
    if (q.chemistry === 'required_lithium' && !urlHolds.chemistry) parts.push(T.req_lithium);
    if (q.chemistry === 'discuss' && !urlHolds.chemistry) parts.push(T.req_discuss);
    if (q.plugNeed !== 'unspecified' && !urlHolds.plugNeed)
      parts.push(q.plugNeed === 'HW' ? T.req_hardwired : fill(T.req_plug, { p: q.plugNeed }));
    parts = parts.concat(monitoringFacts(q, function (field) { return !!urlHolds[field]; }));
    return parts.join(' · ');
  }
  function requirementFacts(r, holds) {
    var parts = [];
    function held(field) { return (holds || []).some(function (h) { return h.field === field; }); }
    if (!held('load')) parts.push(r.load ? fill(T.req_load, { w: r.load.toLocaleString(FR ? 'fr-CA' : 'en-CA') }) : T.req_load_tbc);
    if (!held('runtime')) parts.push(r.runtime ? fill(T.req_runtime, { m: num(r.runtime) }) : T.req_runtime_tbc);
    if (!held('chemistry')) parts.push(r.chemistry === 'required_lithium' ? T.req_lithium :
      (r.chemistry === 'discuss' ? T.req_discuss : T.req_chem_unspecified));
    if (!held('power')) parts.push(fill(T.p91_input_label, { supply: r.power === 'unknown' ? T.req_power_unknown :
      (r.power === 'three-phase' ? T.req_power_three : r.power + ' V') }));
    if (r.outputV && !held('outputV')) parts.push(fill(T.p91_only_saved, { output: r.outputV + ' V' }));
    if (!held('plugNeed') && r.plugNeed !== 'unspecified') parts.push(r.plugNeed === 'HW' ? T.req_hardwired :
      fill(T.req_plug, { p: r.plugNeed }));
    if (!held('outlet')) parts.push(r.outlet === 'unknown' ? T.req_outlet_unknown :
      (r.outlet === 'HW' ? T.req_hardwired : fill(T.req_outlet, { o: r.outlet })));
    if (!held('fit')) parts.push(r.fit === 'rack' ? T.fit_rack : (r.fit === 'tower' ? T.fit_tower : T.fit_either));
    if (r.rackU && !held('rackU')) parts.push(fill(T.rack_limit, { u: r.rackU }));
    if (r.depth && !held('depth')) parts.push(fill(T.req_depth_limit, { d: num(r.depth) }));
    if (r.generator && !held('generator')) parts.push(T.ans_generator);
    if (!held('card')) parts.push(r.card ? T.req_card : T.req_card_no);
    parts = parts.concat(monitoringFacts(r, held));
    parts.push(T.req_models);
    return parts.join('; ');
  }
  function currentRequirementAt() {
    if (!needsTechnicalReview()) return -1;
    var current = JSON.stringify(normalizedRequirements(q));
    return quote.findIndex(function (x) { return x.kind === 'requirements' && !rowHolds(x).length &&
      JSON.stringify(x.requirements) === current; });
  }
  function candidateCount(n) {
    return fill(n === 1 ? T.candidate_one : T.candidate_many, { n: n });
  }
  function candidateRuntime(r, point) {
    return fill(T.candidate_runtime, { w: num(r.load), target: num(r.runtime),
      gw: point.load, gm: point.minutes });
  }
  function candidateQuote(r, n) {
    var point = candidateEvidence(r);
    if (!point) return '';
    return T.candidate_title + ': ' + T.candidate_intro + ' ' + candidateCount(n) + ' ' +
      T.candidate_space + ' ' + candidateRuntime(r, point) + ' ' + T.candidate_disclosure +
      ' ' + T.candidate_quote_ref;
  }

  // RD.03b: compare panel. Selection is stored by product handle, so it survives re-renders;
  // handles that leave the visible list after a form change simply drop out.
  function packFactText(e) { return packFact(e)[1]; }   // comparison shows the same selected/available wording
  function cmpPrice(e) {
    var c = conf(e);
    return c.priced ? money(c.total) : (c.total ? money(c.total) + ' + ' + T.quote_price : T.quote_price);
  }
  function cmpRuntime(e) {
    if (e.bundleReview) return T.rt_confirm;
    if (e.p91Capacity) return p91RuntimeEvidence(selectedRuntime(e)) + ' ' + T.p91_runtime;
    var s = selFor(e), pr = B.packRuntime(e, s, q.load);
    if (pr) return fill(pl('with_n_packs', s.e), { n: s.e }) + fill(pr.atLeast ? T.rt_at_least : (pr.est ? T.rt_estimate : T.rt_published), { m: rtNum(pr.min), w: watts(q.load) });
    if (s.e > 0) return fill(pl('rt_with_packs', s.e), { n: s.e });
    if (!e.rt) return T.rt_confirm;
    if (e.rt.atLeast) return fill(T.rt_at_least, { m: rtNum(e.rt.min), w: q.load });
    return fill(e.rt.est ? T.rt_estimate : T.rt_published, { m: rtNum(e.rt.min), w: q.load });
  }
  function cmpPlug(e) {
    var u = e.u;
    if (e.bundleReview) return T.plug_confirm;
    if (q.outlet === 'unknown') return T.outlet_unknown_hold + (u.plug ? ' ' + fill(T.plug_is, { p: u.plug }) : '');
    if (q.outlet === 'HW' || /HARD ?WIRE/i.test(u.plug || '')) return T.hardwired_hold;
    if (q.outlet !== 'unknown') {
      if (e.mismatch) return fill(T.plug_no, { p: u.plug });
      if (outletIssue(e)) return outletIssue(e);
      return fill(T.plug_ok, { p: u.plug });
    }
    return u.plug ? fill(T.plug_is, { p: u.plug }) : T.cmp_unknown;
  }
  function cmpRu(e) {
    var p = physical(e);
    if (p.orientation !== 'rack') return p.reasons.indexOf('mounting_choice') >= 0 ?
      ((q.rackU || q.depth) ? T.physical_mounting : T.physical_convertible) : '-';
    if (p.available_u && p.known_min_u > p.available_u)
      return fill(p.required_u === null ? T.physical_u_over : T.physical_u_over_exact,
        { u: num(p.known_min_u), available: num(p.available_u) });
    if (p.required_u !== null) return fill(p.available_u ? T.physical_u_total : T.physical_u_unlimited,
      { u: num(p.required_u), available: num(p.available_u) });
    return p.known_min_u ? fill(T.physical_u_min, { u: num(p.known_min_u) }) : T.cmp_unknown;
  }
  function cmpDepth(e) {
    var p = physical(e);
    if (p.orientation !== 'rack') return '-';
    if (p.available_depth_in && p.known_min_depth_in > p.available_depth_in)
      return fill(T.physical_depth_over, { d: num(p.known_min_depth_in), available: num(p.available_depth_in) });
    if (p.required_depth_in !== null) return fill(T.physical_depth_total, { d: num(p.required_depth_in) });
    return p.known_min_depth_in ? fill(T.physical_depth_min, { d: num(p.known_min_depth_in) }) : T.cmp_unknown;
  }
  function cmpCard(e) { return e.u.card === '1' ? T.card_in :
    (e.u.card === '' ? T.card_confirm :
      (selFor(e).c >= 0 && e.opts.c[selFor(e).c] ? T.card_selected : T.card_out)); }
  function cmpTopo(e) {
    var m = { O: T.topo_online, L: T.topo_line, S: T.topo_standby };
    return m[e.u.tp] || T.cmp_unknown;
  }
  function cmpFf(e) {
    var u = e.u;
    if (u.ff === 'T') return T.fit_tower;
    if (u.ff === 'R') return T.fit_rack;
    if (u.ff === 'C') return T.fit_either;
    return T.cmp_unknown;
  }

  function p91Cmp(e) { return e.p91Capacity ? p91Detail(e) : '-'; }
  function typedInputCmp(e) { return e.inputVoltage ? typedInputSummary(e) : '-'; }

  function renderCmp() { renderCmpPanel(); updateTray(); }
  function updateTray() {
    var tray = $('[data-upsb-tray]');
    if (!tray) return;
    var cmpBtn = tray.querySelector('[data-tray-cmp]'), n = cmpHandles.length;
    cmpBtn.hidden = !n;
    if (!cmpBtn.getAttribute('data-flash')) cmpBtn.textContent = fill(T.tray_cmp, { n: n });
    var build = buildBarHtml();
    var buildBox = tray.querySelector('[data-tray-build]');
    if (!buildBox) { buildBox = document.createElement('div'); buildBox.className = 'upsb-sb__tray-build'; buildBox.setAttribute('data-tray-build', ''); tray.insertBefore(buildBox, tray.firstChild); }
    buildBox.innerHTML = build; buildBox.hidden = !build;
    tray.hidden = !n && !quote.length && !build;
    var trayQuote = tray.querySelector('[data-quote-review]');
    if (trayQuote && quote.length) trayQuote.textContent = fill(T.tray_quote, { n: quote.length });
    root.classList.toggle('has-tray', !tray.hidden);
  }
  function renderCmpPanel() {
    var panel = $('[data-upsb-cmp]');
    if (Object.keys(urlHolds).length) { panel.hidden = true; panel.innerHTML = ''; return; }
    var shown = lastRes.filter(function (e, i) {
      /* G29: compare follows what is actually displayed — the main window
         (slice(0, shownCount)), a saved pack selection, or a tower extra — so a
         checked expanded card is never silently discarded, and after a requirements
         change only currently displayed rows stay compared. */
      return (i < shownCount || sel[e.u.h] ||
          (q.fit === 'tower' && i >= shownCount && !sel[e.u.h] && !e.mismatch &&
            TOWER_HANDLES.indexOf(e.u.h) >= 0)) && cmpHandles.indexOf(e.u.h) !== -1;
    });
    cmpHandles = shown.map(function (e) { return e.u.h; });
    if (shown.length < 2) { panel.hidden = true; panel.innerHTML = ''; panel.classList.remove('is-sheet'); return; }
    var fields = [
      [T.cmp_price, cmpPrice], [T.cmp_runtime, cmpRuntime], [T.input_voltage_cmp, typedInputCmp], [T.p91_cmp, p91Cmp], [T.cmp_packs, packFactText],
      [T.cmp_plug, cmpPlug], [T.cmp_ru, cmpRu], [T.cmp_depth, cmpDepth],
      [T.cmp_card, cmpCard], [T.cmp_topo, cmpTopo], [T.cmp_ff, cmpFf]
    ];
    var html = '<button type="button" class="upsb-sb__sheet-close" data-cmp-sheet-close>' + esc(T.sheet_close) + '</button>' +
      '<h2>' + esc(T.compare_title) + '</h2><div class="upsb-sb__cmptable-wrap"><table><thead><tr><th></th>' +
      shown.map(function (e) { return '<th scope="col" title="' + esc(e.u.t) + '">' + esc(shortModel(e.u)) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      fields.map(function (f) {
        var cells = shown.map(function (e) { return f[1](e); });
        if (cells.every(function (c) { return c === '-' || c === ''; })) return '';   // a row that applies to none of them
        return '<tr><th scope="row">' + esc(f[0]) + '</th>' +
          cells.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
      }).join('') + '</tbody></table></div>';
    panel.innerHTML = html;
    panel.hidden = false;
  }

  function showCmpMsg() {
    var el = $('[data-upsb-cmpmsg]');
    el.textContent = T.compare_max;
    el.hidden = false;
    var trayBtn = root.querySelector('[data-tray-cmp]');   // the panel message sits far below the cards; the tray is on screen
    if (trayBtn) {
      trayBtn.textContent = T.compare_max;
      trayBtn.setAttribute('data-flash', '1');
      setTimeout(function () { trayBtn.removeAttribute('data-flash'); updateTray(); }, 2600);
    }
    if (cmpMsgTimer) clearTimeout(cmpMsgTimer);
    cmpMsgTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  // E.05: on one-column screens the results sit below the long form; a sticky link takes the buyer to them.
  var tpAnswers = { v: 0, b: 0, s: 0, kw: '' };
  function tpHref() {
    var monitoring = q.card || q.monitorWatts || q.shutdownNeed !== 'unspecified';
    // Builder reviews (2 Oct 2026): a three-phase room gets its own kW; the single-phase load typed before is not reused.
    var kw = parseFloat(String(tpAnswers.kw || '').replace(',', '.'));
    var msg = fill(T.tp_message3, { kw: kw > 0 && kw < 100000 ? String(kw).replace('.', FR ? ',' : '.') + ' kW' : T.tp_kw_blank, m: q.runtime,
      v: tpAnswers.v ? T.tp_volt_opts[tpAnswers.v] : T.tp_volt_opts[0].toLowerCase(), b: T.tp_bypass_opts[tpAnswers.b].toLowerCase(),
      s: T.tp_seismic_opts[tpAnswers.s].toLowerCase(),
      n: monitoring ? T.tp_mon_yes : T.tp_mon_no });
    return quoteTransport(msg).href || quoteReceiverBase() + '&message=' + encodeURIComponent(msg);
  }
  var jumpWatch = null;
  function updateJump(n) {
    var j = $('[data-upsb-jump]');
    if (!j) return;
    if (n > 0) { j.textContent = fill(T.jump, { n: n }); j.hidden = false; } else j.hidden = true;
    if (!jumpWatch && window.IntersectionObserver) {
      var box = $('[data-upsb-results]');
      if (!box) return;
      jumpWatch = new IntersectionObserver(function (entries) {
        j.classList.toggle('is-results-visible', entries[0].isIntersecting);
      });
      jumpWatch.observe(box);
    }
  }
  // Builder UX pass (09-30): the preset that matches the answers shows as selected; the optional requirements open
  // when one is set; with the outlet not chosen, one click on the outlet unlocks the orderable options.
  function initLoadHelp() {
    var box = $('[data-load-help]');
    if (!box) return;
    box.querySelector('[data-load-rows]').innerHTML = T.load_devices.map(function (d) {
      return '<label class="upsb-sb__loadrow"><span>' + esc(d[1]) + ' <small>~' + d[2] + ' W</small></span>' +
        '<input type="number" min="0" max="99" step="1" inputmode="numeric" value="0" data-load-qty="' + d[2] + '"></label>';
    }).join('');
    box.querySelector('[data-load-note]').textContent = T.load_note;
    var apply = box.querySelector('[data-load-apply]');
    apply.textContent = T.load_apply;
    function total() {
      var t = 0;
      box.querySelectorAll('[data-load-qty]').forEach(function (el) {
        t += Math.max(0, Math.min(99, parseInt(el.value, 10) || 0)) * Number(el.getAttribute('data-load-qty'));
      });
      return t;
    }
    function show() {
      var t = total();
      box.querySelector('[data-load-total]').textContent = fill(T.load_total, { w: t.toLocaleString(FR ? 'fr-CA' : 'en-CA') });
      apply.disabled = !t;
    }
    // the estimator's own fields are not requirements: keep their typing away from the form listeners
    ['input', 'change'].forEach(function (type) {
      box.addEventListener(type, function (ev) { if (ev.target.hasAttribute('data-load-qty')) { ev.stopPropagation(); show(); } });
    });
    apply.addEventListener('click', function () {
      var t = total();
      if (!t) return;
      var load = $('[data-upsb-form]').elements.load;
      load.value = String(Math.max(50, Math.ceil(t / 50) * 50));   // the load field takes steps of 50 W; round up
      load.dispatchEvent(new Event('input', { bubbles: true }));
      load.dispatchEvent(new Event('change', { bubbles: true }));
    });
    show();
    var note = $('[data-rt-note]');
    if (note) note.textContent = T.rt_chips_note;
  }
  function markChips() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-rt-chip]'), function (b) {
      var on = Number(b.getAttribute('data-rt-chip')) === q.runtime;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function markPresets() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-preset]'), function (b) {
      var p = PRESETS[b.getAttribute('data-preset')];
      if (!p) return;
      var on = p.load === q.load && p.runtime === q.runtime && p.power === q.power && p.fit === q.fit &&
        !!p.generator === !!q.generator;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function syncAdvanced() {
    var adv = $('[data-upsb-advanced]');
    if (!adv) return;
    var n = [q.generator, q.monitorWatts, q.shutdownNeed !== 'unspecified', q.chemistry !== 'unspecified',
      q.plugNeed !== 'unspecified'].filter(Boolean).length;
    if (n && !adv.open) adv.open = true;
    var c = adv.querySelector('[data-advanced-count]');
    if (c) c.textContent = n ? ' (' + n + ')' : '';
  }
  // Continuous plug-in load is held to 80% of the circuit (15 A x 120 V x 0.8 = 1,440 W); 208 V for the L6 outlets.
  var CIRCUIT_W = { '5-15R': 1440, '5-20R': 1920, 'L5-20R': 1920, 'L5-30R': 2880, 'L6-20R': 3328, 'L6-30R': 4992 };
  function circuitNote() {
    var max = CIRCUIT_W[q.outlet];
    if (!max || !(q.load > max) || hasInputHolds()) return '';
    var loc = FR ? 'fr-CA' : 'en-CA';
    return '<p class="upsb-sb__circuit" role="note">' + esc(fill(T.circuit_note,
      { w: q.load.toLocaleString(loc), o: q.outlet, max: max.toLocaleString(loc) })) + '</p>';
  }
  function outletPicker() {
    if (q.outlet !== 'unknown' || hasInputHolds()) return '';
    var list = q.power === '208-240' ? T.outlet_pick_208 : (q.power === '120' || q.power === 'unknown' ? T.outlet_pick_120 : null);
    if (!list) return '';
    return '<div class="upsb-sb__outlet-pick"><p class="upsb-sb__outlet-pick-title">' + esc(T.outlet_pick_title) + '</p>' +
      '<p>' + esc(T.outlet_pick_intro) + '</p><div class="upsb-sb__outlet-chips">' + list.map(function (o) {
        return outletTile(o[0], o[1], false);   // Builder X item 3: receptacle pictures
      }).join('') + '</div><p class="upsb-sb__outlet-pick-hint">' +
      esc(q.power === '208-240' ? T.outlet_pick_hint_208 : T.outlet_pick_hint) + '</p></div>';
  }
  // A re-render (live prices arriving, a choice elsewhere) replaces the cards; keyboard focus returns to the same control.
  function focusKey() {
    var a = document.activeElement, box = $('[data-upsb-results]');
    if (!a || !box || !box.contains(a) || a === box) return null;
    var card = a.closest('.upsb-sb__sol');
    var keys = ['data-add', 'data-quote', 'data-cmp', 'data-addon', 'data-sort', 'data-brand', 'data-show-more',
      'data-outlet-pick', 'data-quote-requirements', 'data-budget', 'data-nopack', 'data-get-price', 'data-filter-clear'];
    var sel = a.matches('h3 a') ? 'h3 a' : '';
    for (var i = 0; !sel && i < keys.length; i++) if (a.hasAttribute(keys[i])) {
      var v = a.getAttribute(keys[i]);
      sel = '[' + keys[i] + (v && /^(data-addon|data-outlet-pick|data-budget)$/.test(keys[i]) ? '="' + v + '"' : '') + ']';
    }
    return sel ? { h: card ? card.getAttribute('data-solution-h') : '', sel: sel } : null;
  }
  function restoreFocus(k) {
    if (!k) return;
    var box = $('[data-upsb-results]');
    var scope = k.h ? box.querySelector('.upsb-sb__sol[data-solution-h="' + k.h + '"]') : box;
    var el = scope && scope.querySelector(k.sel);
    if (el && el !== document.activeElement && el.focus) el.focus({ preventScroll: true });
  }
  function render() {
    var keepFocus = focusKey();
    readForm();
    markPresets();
    markChips();
    // Three-phase designer round 2: its own load, runtime and site questions replace the single-phase ones on the left.
    if (q.power === 'three-phase' && window.UPSBThreePhase && !batteryMode) root.setAttribute('data-tp-mode', '1');
    else root.removeAttribute('data-tp-mode');
    syncAdvanced();
    lastQ = JSON.stringify(q);
    var box = $('[data-upsb-results]');
    $('[data-upsb-answers]').textContent = answersLine();
    var linkText = root.querySelector('[data-linkbar-text]');
    if (linkText) linkText.textContent = answersLine();
    syncOutletTiles();
    syncUrl();
    renderInputHolds();
    refreshQuoteSendState();
    if (needsTechnicalReview()) {
      lastRes = [];
      updateJump(0);
      updateP91OutputContext();
      if (!index) { renderCmp(); renderSavedReview(); }   // with the index, the options list below renders them
      var monitoring = q.monitorWatts || q.shutdownNeed !== 'unspecified' || !!q.shutdownPlatform;
      var intro = q.chemistry === 'required_lithium' ? T.req_intro_lithium :
        (q.chemistry === 'discuss' ? T.req_intro_discuss :
          (q.plugNeed !== 'unspecified' ? T.req_intro_plug : T.req_intro_monitoring));
      var secondary = q.chemistry !== 'unspecified' || q.plugNeed !== 'unspecified' ?
        T.req_secondary + (monitoring ? ' ' + T.req_secondary_monitoring : '') : T.req_secondary_monitoring;
      var otherPath = (FR ? '' : '/fr') + location.pathname.replace(/^\/fr(?=\/)/, '');
      var otherHref = esc(otherPath + location.search).replace(/"/g, '&quot;');
      var formError = requirementFormError();
      var currentAt = currentRequirementAt();
      var reqTitle = currentAt >= 0 && quote[currentAt].candidate === CANDIDATE_ID ?
        T.req_candidate_label : T.req_label;
      box.innerHTML = '<div class="upsb-sb__req"><h2>' + esc(reqTitle) + '</h2>' +
        '<p>' + esc(intro) + '</p><p>' + esc(secondary) + '</p>' +
        '<p class="upsb-sb__req-facts">' + esc(formError ? T.req_snapshot_hold :
          (Object.keys(urlHolds).length ? T.input_hold_blocked : requirementFacts(normalizedRequirements(q)))) + '</p>' +
        '<div class="upsb-sb__btns"><button type="button" class="button" data-quote-requirements>' +
        esc(T.req_add) + '</button><button type="button" class="button button--tertiary" data-quote-review hidden></button></div>' +
        '<p class="upsb-sb__quote-feedback" role="status" aria-live="polite" data-req-feedback></p>' +
        '<a class="upsb-sb__req-locale" href="' + otherHref + '">' + esc(T.req_locale_link) + '</a></div>';
      var candidatePoint = !formError && !hasInputHolds() && candidateEvidence(normalizedRequirements(q));
      if (candidatePoint) {
        var included = currentAt >= 0 && quote[currentAt].candidate === CANDIDATE_ID;
        var count = currentAt >= 0 ? quote[currentAt].qty : 1;
        box.innerHTML += '<section class="upsb-sb__candidate" data-candidate>' +
          '<h3>' + esc(T.candidate_title) + '</h3><p>' + esc(T.candidate_intro) + '</p>' +
          '<p data-candidate-count>' + esc(candidateCount(count)) + '</p>' +
          '<p>' + esc(T.candidate_space) + '</p><p>' + esc(T.candidate_disclosure) + '</p>' +
          '<details><summary>' + esc(T.candidate_evidence) + '</summary><p>' +
          esc(candidateRuntime(normalizedRequirements(q), candidatePoint)) + '</p><p>' +
          esc(T.candidate_revision) + '</p><a href="https://eg.eaton.com/ups-battery-runtime/en-us/9PX1500RTN-L" target="_blank" rel="noopener">' +
          esc(T.candidate_source) + '</a></details>' +
          '<button type="button" class="button button--secondary" data-candidate-toggle' +
          (currentAt < 0 ? ' disabled' : '') + '>' + esc(included ? T.candidate_remove : T.candidate_add) + '</button>' +
          (currentAt < 0 ? '<p>' + esc(T.candidate_save_first) + '</p>' : '') +
          '<p class="upsb-sb__quote-feedback" role="status" aria-live="polite" data-candidate-feedback></p></section>';
      }
      if (index && (formError || hasInputHolds())) { renderCmp(); renderSavedReview(); }
      if (index && !formError && !hasInputHolds()) {
        var reviewed = reviewFilter(B.solve(index, q, sel, qualifyP91)), reviewBrands = brandsOf(reviewed);
        if (brandFilter && reviewBrands.indexOf(brandFilter) < 0) brandFilter = '';
        lastRes = viewOrder(reviewed);
        if (lastRes.length) {
          var reviewHtml = '<section class="upsb-sb__review-list"><h2>' + esc(T.review_list_title) + '</h2><p>' +
            esc(T.review_list_intro) + '</p>' + resultsBar(Math.min(shownCount, lastRes.length), lastRes.length, reviewBrands);
          lastRes.slice(0, shownCount).forEach(function (e, i) { reviewHtml += solutionCard(e, i); });
          if (lastRes.length > shownCount) reviewHtml += '<button type="button" class="button button--secondary" data-show-more>' +
            esc(fill(T.show_more, { n: Math.min(12, lastRes.length - shownCount) })) + '</button>';
          box.insertAdjacentHTML('beforeend', reviewHtml + '</section>');
          restoreFocus(keepFocus);
          fillPrices(lastRes.slice(0, shownCount));
        }
        updateJump(lastRes.length);
        renderSavedReview();
        renderCmp();
      }
      updateReviewControls();
      return;
    }
    if (q.power === 'three-phase') {
      lastRes = [];
      updateP91OutputContext();
      renderCmp();
      renderSavedReview();
      // Three-phase designer (Master, 2 Oct 2026, assets/upsb-three-phase.js): sizing, the catalogue shortlist with
      // options, compare and one complete request. The short form below stays as the fallback if that file is absent.
      if (window.UPSBThreePhase && !hasInputHolds()) {
        window.UPSBThreePhase.mount(box, { index: index, FR: FR, PREFIX: PREFIX, B: B, emit: emit,
          href: function (msg) { return quoteTransport(msg).href || quoteReceiverBase() + '&message=' + encodeURIComponent(msg.slice(0, 1500)); } });
        return;
      }
      // E.08: the three-phase request carries what a specialist needs first (voltage, kW, runtime, bypass,
      // seismic, monitoring). The three answers stay on the card while the buyer edits the form.
      function tpSelect(key, label, opts) {
        var cur = tpAnswers[key] | 0;
        return '<label>' + esc(label) + '<select data-tp="' + key + '">' + opts.map(function (o, i) {
          return '<option value="' + i + '"' + (i === cur ? ' selected' : '') + '>' + esc(o) + '</option>';
        }).join('') + '</select></label>';
      }
      box.innerHTML = '<div class="upsb-sb__tp"><p>' + esc(T.tp_intro) + '</p>' +
        (hasInputHolds() ? '<p>' + esc(T.input_hold_blocked) + '</p>' :
          '<div class="upsb-sb__tp-q"><label>' + esc(T.tp_kw) + '<input type="text" inputmode="decimal" maxlength="8" data-tp-kw value="' +
          esc(tpAnswers.kw) + '"></label>' + tpSelect('v', T.tp_volt, T.tp_volt_opts) +
          tpSelect('b', T.tp_bypass, T.tp_bypass_opts) + tpSelect('s', T.tp_seismic, T.tp_seismic_opts) + '</div>' +
          '<a class="button" data-tp-link href="' + tpHref() + '">' + esc(T.tp_cta) + '</a>') + '</div>';
      return;
    }
    if (!index) {
      lastRes = []; updateP91OutputContext(); renderCmp(); renderSavedReview();
      box.innerHTML = indexStatus === 'error' ? '<div class="upsb-sb__index-error" role="alert"><p>' +
        esc(T.index_error) + '</p><button type="button" class="button button--secondary" data-index-retry>' +
        esc(T.index_retry) + '</button></div>' : '<p>' + esc(T.loading) + '</p>' +
        '<div class="upsb-sb__skel" aria-hidden="true"><i></i><i></i><i></i></div>';   // Builder X item 20
      return;
    }
    lastRes = B.solve(index, q, sel, qualifyP91);
    if (restoreUnmatched()) lastRes = B.solve(index, q, sel, qualifyP91);
    var brands = brandsOf(lastRes);
    if (brandFilter && brands.indexOf(brandFilter) < 0) brandFilter = '';
    var anySolved = lastRes.length > 0, engineView = filterView(lastRes);
    lastRes = viewOrder(lastRes);
    updateP91OutputContext();
    syncUrl();
    var shownResults = lastRes.slice(0, shownCount);
    var extraTower = q.fit === 'tower' ? lastRes.map(function (e, i) { return { e: e, i: i }; })
      .filter(function (x) { return x.i >= shownCount && !sel[x.e.u.h] && !x.e.mismatch &&
        TOWER_HANDLES.indexOf(x.e.u.h) >= 0; }) : [];
    function uniqueHandles(rows) {
      return new Set(rows.map(function (e) { return e.u.h; })).size;
    }
    var displayed = uniqueHandles(shownResults.concat(extraTower.map(function (x) { return x.e; })));
    var total = uniqueHandles(lastRes);
    var html = outletPicker() + circuitNote() + (total ? picksHtml(engineView) + resultsBar(displayed, total, brands) :
      (anySolved ? resultsBar(0, 0, brands) + filteredEmpty() : emptyState()));
    shownResults.forEach(function (e, i) {
      html += solutionCard(e, i);
    });
    if (lastRes.length > shownCount) html += '<button type="button" class="button button--secondary" data-show-more>' + esc(fill(T.show_more, { n: Math.min(12, lastRes.length - shownCount) })) + '</button>';
    if (extraTower.length) html += '<section class="upsb-sb__tower-more"><h2>' +
      esc(T.tower_placement_more) + '</h2>' + extraTower.map(function (x) {
        return solutionCard(x.e, x.i);
      }).join('') + '</section>';
    if (total) html += talkHtml();
    box.innerHTML = html;
    restoreFocus(keepFocus);
    updateEmail(shownResults);
    updateJump(total);
    renderSavedReview();
    updateReviewControls();
    renderCmp();
    fillPrices(lastRes.filter(function (e, i) { return i < shownCount || !!sel[e.u.h] ||
      extraTower.some(function (x) { return x.i === i; }); }));
  }

  function emitResultsSnapshot(extraKey) {
    if (!builderViewed || batteryMode || (!extraKey && measuredRevision === lastResultsRevision) ||
        requirementFormError() || Object.keys(urlHolds).length) return;
    var mode = needsTechnicalReview() ? 'technical_review' :
      (q.power === 'three-phase' ? 'specialist' : 'results');
    var counts = { mode: mode, visible_count: 0, eligible_count: 0, review_count: 0, mismatch_count: 0 };
    if (mode === 'results') {
      if (indexStatus !== 'ready') return;
      var cards = root.querySelectorAll('[data-upsb-results] .upsb-sb__sol');
      for (var i = 0; i < cards.length; i++) {
        var h = cards[i].getAttribute('data-solution-h');
        var e = lastRes.find(function (item) { return item.u.h === h; });
        if (!e) return; // An inconsistent render is not a measurable presentation.
        counts.visible_count++;
        if (e.mismatch || physical(e).status === 'mismatch') counts.mismatch_count++;
        else if (cartEligible(e) && !e.confirm && !e.plugUnknown && !reconfirm[h]) counts.eligible_count++;
        else counts.review_count++;
      }
    }
    emit('upsb_results_viewed', counts, 'revision-' + measuredRevision + (extraKey || ''));
    lastResultsRevision = measuredRevision;
  }
  function maybeViewBuilder() {
    if (builderViewed || batteryMode || indexStatus !== 'ready') return;
    builderViewed = true;
    committedSnapshot = JSON.stringify(normalizedRequirements(q));
    var recovered = !!(fromUrl || addonParams.length || quote.length);
    emit('upsb_builder_viewed', { entry: recovered ? 'recovered' : 'default' }, 'initial');
    if (recovered && !requirementFormError() && !Object.keys(urlHolds).length)
      emit('upsb_requirements_committed', { origin: 'recovery' });
    emitResultsSnapshot();
  }
  function commitRequirements(origin, preset) {
    if (!builderViewed || batteryMode || requirementFormError() || Object.keys(urlHolds).length) return;
    var next = JSON.stringify(normalizedRequirements(q));
    if (next === committedSnapshot) return;
    committedSnapshot = next;
    measuredRevision++;
    var fields = { origin: origin };
    if (origin === 'preset') fields.preset = preset;
    emit('upsb_requirements_committed', fields);
    emitResultsSnapshot();
  }
  function commitConfiguration(before, after) {
    if (!builderViewed || batteryMode || before === after) return;
    measuredRevision++;
    emitResultsSnapshot();
  }
  function commitPlacementAnswer(before, after) {
    if (!builderViewed || batteryMode || before === after) return;
    measuredRevision++;
    emit('upsb_requirements_committed', { origin: 'buyer' });
    emitResultsSnapshot();
  }
  function configurationStamp(e) {
    var s = selFor(e);
    function identity(key, index, list) {
      return s.ids && s.ids[key] ? s.ids[key] : (index >= 0 && list[index] ? String(list[index][0]) : '');
    }
    return JSON.stringify({ e: s.e, eI: s.eI, c: s.c, x: s.x, r: s.r,
      ids: { eI: identity('eI', s.eI, e.opts.e), c: identity('c', s.c, e.opts.c),
        x: identity('x', s.x, e.opts.x), r: identity('r', s.r, e.opts.r) },
      reconfirm: reconfirm[e.u.h] || null,
      placement: q.towerPlacement && q.towerPlacement[e.u.h] ? q.towerPlacement[e.u.h].answer : '' });
  }

  // Accessories added from evidenced link files carry no price in the data file: fetch it once from the store
  // (/products/<handle>.js), write it into the index row, then re-render. A true 0 stays "price on quote".
  var fetched = {};
  function fillPrices(res) {
    fillData(res);
    var want = [];
    res.forEach(function (e) {
      var list = conf(e).items.slice(1);
      if (openAdd[e.u.h]) list = list.concat(e.opts.e, e.opts.c, e.opts.x, e.opts.r);
      list.forEach(function (it) { if (!it[2] && !fetched[it[0]]) { fetched[it[0]] = 1; want.push(it[0]); } });
      // UX pass: the priced parts of the shown solutions get their current store price too (display + cart check)
      if (livePrices.__cartCur === 'CAD') conf(e).items.forEach(function (it) {
        if (it[2] && !fetched[it[0]]) { fetched[it[0]] = 1; want.push(it[0]); }
      });
    });
    if (!want.length || location.protocol === 'file:') return;
    Promise.all(want.map(function (h) {
      // Data lookups use the root path: /fr/products/<handle>.js is a 404 whenever the product has a French handle
      // (links stay localized; the store redirects those). Seen on the live theme 2026-09-27.
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pr) {
          var variant = pr && pr.variants && pr.variants.length === 1 ? pr.variants[0] : null;
          if (variant && variant.available !== true) liveUnavailable[h] = true;
          if (!variant || variant.available !== true) return;
          delete liveUnavailable[h];
          // G32: successful store responses are recorded in the SEPARATE live state;
          // the ranking index keeps its catalogue numbers (no mixed-currency snapshot)
          livePrices[h] = { cents: Number(variant.price), currency: livePrices.__cartCur || '', variantId: variant.id, source: 'fill', at: Date.now() };
          if (livePrices.__cartCur === 'CAD' && Number.isSafeInteger(Number(variant.price)) && Number(variant.price) > 0)
            seenLive[h] = Number(variant.price);
        }).catch(function () {});
    })).then(render);
  }

  // G32: current selected-solution prices live HERE, never in the ranking index.
  var livePrices = {};
  // UX pass: a store price that moved since the builder data was built is shown on the card after the first add
  // attempt; the next add compares with that shown price. Before, the add failed on every retry (supplier sync
  // moves prices daily; 7 of 40 sampled products differed on 09-30). CAD carts only; nothing is added unseen.
  var seenLive = {};
  // Round 5 (09-30): a part the store reports as not available keeps the card off the cart, with the reason on it.
  var liveUnavailable = {};
  function anyUnavailable(e) { return conf(e).items.some(function (it) { return liveUnavailable[it[0]]; }); }
  function shownCents(h, catalogue) { return seenLive[h] != null ? seenLive[h] : Number(catalogue); }
  function liveTotal(c) {
    return c.items.reduce(function (sum, it) { return sum + (it[2] ? shownCents(it[0], it[2]) * it[3] : 0); }, 0);
  }
  var currentSolution = null;
  var refreshNote = '';
  function moneyCur(cents, cur) {
    // G32-R1 f3: store/current money is ALWAYS a numeric amount plus its actual ISO
    // code; no dollar symbol on non-dollar currencies and none unqualified at all
    var digits = String(cents).padStart(3, '0');
    var whole = digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, FR ? '\u00a0' : ',');
    return (FR ? whole + ',' + digits.slice(-2) : whole + '.' + digits.slice(-2)) + ' ' + (cur || '');
  }
  function refreshSolution(e) {
    // G32-R1: bounded same-currency refresh; the currency context is sampled BEFORE and
    // RE-CHECKED AFTER the product fetch set — a mid-refresh change rejects the whole
    // refresh (currency-drift); any failure/unavailability invalidates, never stale.
    refreshNote = '';
    var items = conf(e).items;
    function cartCur() {
      return fetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          return cart && typeof cart.currency === 'string' && /^[A-Z]{3}$/.test(cart.currency) ? cart.currency : '';
        });
    }
    return cartCur().then(function (currency) {
      if (!currency) { currentSolution = null; refreshNote = 'currency'; return currentSolution; }
      return Promise.all(items.map(function (it) {
        return fetch('/products/' + encodeURIComponent(it[0]) + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        }).then(function (pr) {
          // No exact variant choice is recorded for every selected item. A product
          // with several variants cannot safely use the first one as its price.
          var variant = pr && pr.variants && pr.variants.length === 1 ? pr.variants[0] : null;
          if (!variant || variant.available !== true) return null;
          var cents = Number(variant.price);
          if ((pr.handle && pr.handle !== it[0]) || !Number.isSafeInteger(variant.id) ||
              variant.id <= 0 || !Number.isSafeInteger(cents) || cents <= 0 ||
              !Number.isSafeInteger(it[3]) || it[3] <= 0) return null;
          return { h: it[0], cents: cents, variantId: variant.id, q: it[3] };
        });
      })).then(function (lines) {
        if (lines.some(function (l) { return !l; })) {
          currentSolution = null; refreshNote = 'unavailable'; return currentSolution;
        }
        return cartCur().then(function (after) {
          if (after !== currency) { currentSolution = null; refreshNote = 'currency-drift'; return currentSolution; }
          var per = 0;
          for (var i = 0; i < lines.length; i++) {
            var extension = lines[i].cents * lines[i].q;
            if (!Number.isSafeInteger(extension) || !Number.isSafeInteger(per + extension)) {
              currentSolution = null; refreshNote = 'amount'; return currentSolution;
            }
            per += extension;
          }
          lines.forEach(function (l) { livePrices[l.h] = { cents: l.cents, currency: currency, variantId: l.variantId, source: 'refresh', at: Date.now() }; });
          currentSolution = { handle: e.u.h, currency: currency, at: Date.now(), lines: lines, per: per };
          return currentSolution;
        });
      });
    }).catch(function () { currentSolution = null; refreshNote = 'failed'; return currentSolution; });
  }
  // A saved row has its own check state. Keeping the row object as the key makes
  // status follow it when another quote line is removed ahead of it.
  var rowPriceChecks = new WeakMap();
  function rowPriceStatus(row) {
    var state = rowPriceChecks.get(row);
    if (!state) return '';
    if (state.busy) return '<p class="upsb-sb__pricecheck-status" role="status">' + esc(T.check_prices_busy) + '</p>';
    if (state.why) return '<p class="upsb-sb__pricecheck-status" role="status">' +
      esc(T.check_prices_fail + ' ' + (T['check_why_' + state.why] || T.check_why_failed)) + '</p>';
    var stamp = new Date(state.at);
    var time = String(stamp.getHours()).padStart(2, '0') + ':' + String(stamp.getMinutes()).padStart(2, '0');
    return '<p class="upsb-sb__pricecheck-status" role="status">' +
      esc(fill(T.check_prices_done, { time: time, cur: state.cur })) + '</p>';
  }
  function refreshRowPrices(row) {
    if (!row || row.kind !== 'solution' || !row.estimate || row.estimate.restored !== true ||
        !validEstimate(row.estimate, row.model) ||
        quote.indexOf(row) < 0) return Promise.resolve();
    var earlier = rowPriceChecks.get(row);
    if (earlier && earlier.busy) return earlier.promise;
    var priorIds = {};
    if (row.current && Array.isArray(row.current.lines)) row.current.lines.forEach(function (line) {
      if (line && Number.isSafeInteger(line.variantId) && line.variantId > 0) priorIds[line.h] = line.variantId;
    });
    var savedShape = JSON.stringify({ model: row.model, qty: row.qty, lines: row.estimate.lines });
    var lines = row.estimate.lines.map(function (line) { return { h: line.h, q: line.q }; });
    var state = { busy: true, promise: null };
    rowPriceChecks.set(row, state);
    if (row.current) row.current.stale = true; // no old amount can enter print or transfer while checking
    persistQuote(); renderQuote();
    function active() { return quote.indexOf(row) >= 0 && rowPriceChecks.get(row) === state; }
    function sameShape() {
      return savedShape === JSON.stringify({ model: row.model, qty: row.qty, lines: row.estimate && row.estimate.lines });
    }
    function finish(why, current) {
      if (!active()) return;
      if (!sameShape()) why = 'changed';
      state.busy = false;
      if (why) { state.why = why; delete state.at; delete state.cur; }
      else {
        row.current = current;
        state.at = current.at; state.cur = current.currency; delete state.why;
        current.lines.forEach(function (line) {
          livePrices[line.h] = { cents: line.cents, currency: current.currency,
            variantId: line.variantId, source: 'row-check', at: current.at };
        });
      }
      persistQuote(); renderQuote();
    }
    function cartCur() {
      return fetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          return cart && typeof cart.currency === 'string' && /^[A-Z]{3}$/.test(cart.currency) ? cart.currency : '';
        });
    }
    state.promise = cartCur().then(function (currency) {
      if (!active()) return;
      if (!sameShape()) { finish('changed'); return; }
      if (!currency) { finish('currency'); return; }
      return Promise.all(lines.map(function (line) {
        return fetch('/products/' + encodeURIComponent(line.h) + '.js').then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (!product || product.handle !== line.h ||
                !Array.isArray(product.variants) || !product.variants.length)
              return { why: 'unavailable' };
            var variants = product.variants, variant = null, priorId = priorIds[line.h];
            if (priorId) {
              variant = variants.find(function (v) { return v.id === priorId; });
              if (!variant) return { why: 'variant_changed' };
            } else if (variants.length === 1) variant = variants[0];
            else return { why: 'variant' };
            var cents = Number(variant.price);
            if (variant.available !== true || !Number.isSafeInteger(variant.id) || variant.id <= 0 ||
                !Number.isSafeInteger(cents) || cents <= 0 || !Number.isSafeInteger(line.q) || line.q <= 0)
              return { why: 'unavailable' };
            return { h: line.h, cents: cents, variantId: variant.id, q: line.q };
          });
      })).then(function (fresh) {
        if (!active()) return;
        if (!sameShape()) { finish('changed'); return; }
        var bad = fresh.find(function (line) { return line.why; });
        if (bad) { finish(bad.why); return; }
        var per = 0;
        for (var i = 0; i < fresh.length; i++) {
          var extension = fresh[i].cents * fresh[i].q;
          if (!Number.isSafeInteger(extension) || !Number.isSafeInteger(per + extension)) {
            finish('amount'); return;
          }
          per += extension;
        }
        if (!Number.isSafeInteger(per * row.qty)) { finish('amount'); return; }
        return cartCur().then(function (after) {
          if (!active()) return;
          if (after !== currency) { finish('currency_drift'); return; }
          finish('', { currency: currency, at: Date.now(), lines: fresh, per: per });
        });
      });
    }).catch(function () { finish('failed'); });
    return state.promise;
  }
  function setLivePrice(handle, cents) {
    // G32-R1 f2: record-only — the immutable ranking index is never overwritten with
    // live presentment amounts; cart consumers price from their own fetched variants
    if (Number.isSafeInteger(cents) && cents > 0 && livePrices.__cartCur) {
      livePrices[handle] = { cents: cents, currency: livePrices.__cartCur, source: 'store-cart', at: Date.now() };
    }
  }

  // FR page: the product and accessory titles the store holds in French (tf field, ac[5]); EN where none exists.
  function localize(j) {
    var ti = j.fields.indexOf('t'), fi = j.fields.indexOf('tf');
    if (fi >= 0) j.u.forEach(function (r) { if (r[fi]) r[ti] = r[fi]; });
    j.ac.forEach(function (x) { if (x[5]) x[1] = x[5]; });
  }

  function cardCommercialLine(e) {
    var selected = selFor(e), card = selected.c >= 0 ? e.opts.c[selected.c] : null;
    if (e.u.card === '1') return T.quote_card_included;
    if (e.u.card === '0') return card ?
      fill(T.quote_card_separate_selected, { model: card[1] }) : T.quote_card_separate_none;
    return card ? fill(T.quote_card_unknown_selected, { model: card[1] }) : T.quote_card_unknown;
  }

  function quoteVoltageStale(x) {
    if (!x.model) return '';
    var handles = x.model.match(/xpc-[a-z0-9-]+/ig) || [];
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i].toLowerCase();
      var fact = B.typedInputDecision(index, { h: h }, { power: 'unknown' });
      if (fact) {
        var overlay = index && index.input_voltage_v2;
        var record = overlay && overlay.records && overlay.records[h];
        var evidence = record && record.typed && record.typed.evidence;
        var saved = x.inputSource;
        if (fact.state === 'source_unavailable' || !evidence || !saved ||
            typeof saved !== 'object' || Array.isArray(saved) ||
            !/^[a-f0-9]{64}$/.test(saved.factSha || '') ||
            !/^[a-f0-9]{64}$/.test(saved.documentSha || '') ||
            !/^[a-f0-9]{64}$/.test(saved.sidecarSha || '') ||
            saved.factSha !== fact.source_fact_sha256 ||
            saved.documentSha !== evidence.sha256 ||
            saved.sidecarSha !== overlay.source_sidecar_sha256 ||
            saved.url !== fact.source_url || saved.revision !== fact.source_revision ||
            saved.page !== fact.source_page || saved.kind !== fact.source_kind)
          return T.input_voltage_saved;
      }
    }
    return '';
  }
  function quoteBundleStale(x) {
    var extendedMatch = (x.model || '').match(/\bxpc-p91-(?:6ktb[2-4]?|10ktb[1-2]?)\b/i);
    if (extendedMatch) {
      var extended = index && index.p91_tb_extension_v1;
      var record = extended && extended.records && extended.records[extendedMatch[0].toLowerCase()];
      var provenance = x.bundleSource;
      if (!record || !provenance || typeof provenance !== 'object' ||
          provenance.decisionSha !== record.accepted_decision_sha256 ||
          provenance.pdfSha !== record.source_pdf_sha256 ||
          provenance.recordSha !== record.record_sha256 ||
          provenance.page !== record.source_page) return T.bundle_source_stale;
      return '';
    }
    var match = (x.model || '').match(/\bxpc-p91-5k(?:b[1-3]?|tb[2-4]?)\b/i);
    if (!match) return '';
    var h = match[0].toLowerCase(), sidecar = index && index.p91_bundle_v1;
    var current = sidecar && sidecar.records && sidecar.records[h], saved = x.bundleSource;
    if (!current || !saved || typeof saved !== 'object' ||
        saved.workbookSha !== current.workbook_sha256 ||
        saved.descriptionSha !== current.workbook_description_sha256 ||
        saved.runtimeSha !== current.runtime_source_sha256 ||
        saved.pack !== current.runtime_pack_handle) return T.bundle_source_stale;
    return '';
  }
  function estimateModel(lines) {
    return lines.map(function (line) { return (line.q > 1 ? line.q + ' x ' : '') + line.h; }).join(' + ');
  }
  function validEstimate(value, model) {
    return !!value && value.version === 1 && Array.isArray(value.lines) &&
      value.lines.length > 0 && value.lines.length <= 20 &&
      value.lines.every(function (line) {
        return line && typeof line.h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(line.h) &&
          Number.isSafeInteger(line.q) && line.q > 0 &&
          (line.c === null || (Number.isSafeInteger(line.c) && line.c > 0));
      }) && estimateModel(value.lines) === model;
  }
  function snapshotEstimate(items) {
    var lines = items.map(function (item) {
      var c = Number.isSafeInteger(item[2]) && item[2] > 0 ? item[2] : null;
      // G32-R1 f1: the captured estimate is EXPLICITLY HISTORICAL (catalogue cents only);
      // current amounts come solely from the refresh state (row.current)
      return { h: item[0], c: c, q: item[3], s: c === null ? 'none' : 'catalogue', cur: null };
    });
    var value = { version: 1, lines: lines, savedAt: Date.now() };
    return validEstimate(value, estimateModel(lines)) ? value : null;
  }
  function estimateState(value) {
    if (!index || !Array.isArray(index.u) || !Array.isArray(index.ac) || !Array.isArray(index.fields))
      return 'saved';
    var handleAt = index.fields.indexOf('h'), priceAt = index.fields.indexOf('p');
    if (handleAt < 0 || priceAt < 0) return 'saved';
    var prices = {};
    index.u.forEach(function (row) { prices[row[handleAt]] = row[priceAt]; });
    index.ac.forEach(function (row) { prices[row[0]] = row[3]; });
    return value.lines.every(function (line) {
      var now = prices[line.h];
      return Object.prototype.hasOwnProperty.call(prices, line.h) &&
        (line.c === null ? !(Number.isSafeInteger(now) && now > 0) : now === line.c);
    }) ? 'index' : 'saved';
  }
  function estimateMoney(cents) {
    var digits = String(cents).padStart(3, '0');
    var whole = digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, FR ? '\u00a0' : ',');
    return FR ? whole + ',' + digits.slice(-2) + ' $' : '$' + whole + '.' + digits.slice(-2);
  }
  // G23: readable equipment labels from the SAME pinned index titles the cards use.
  // Identity contract untouched: estimate lines keep raw handles; cents/multiplicity
  // arithmetic unchanged; display adds the handle as a compact reference ID.
  var labelCache = null, labelIndex = null;
  function labelMap() {
    if (!index || !Array.isArray(index.u) || !Array.isArray(index.fields) || !Array.isArray(index.ac))
      return {};
    if (labelCache && labelIndex === index) return labelCache;
    var map = {};
    if (index && Array.isArray(index.u) && Array.isArray(index.fields)) {
      var hAt = index.fields.indexOf('h'), tAt = index.fields.indexOf('t'), frAt = index.fields.indexOf('tf');
      index.u.forEach(function (row) {
        if (hAt < 0) return;
        map[row[hAt]] = { en: tAt >= 0 && row[tAt] ? row[tAt] : null,
          fr: frAt >= 0 && row[frAt] ? row[frAt] : null };
      });
    }
    if (index && Array.isArray(index.ac)) {
      index.ac.forEach(function (row) {
        if (!Array.isArray(row)) return;
        map[row[0]] = { en: row[1] || null, fr: row[5] || null };
      });
    }
    labelIndex = index;
    labelCache = map;
    return map;
  }
  function labelFor(handle) {
    var e = labelMap()[handle];
    if (!e) return null;
    var title = FR ? (e.fr || e.en) : (e.en || e.fr);
    return title && String(title).trim() ? String(title).trim() : null;
  }
  function readableItem(handle) {
    var label = labelFor(handle);
    return label ? label + ' (' + handle + ')' : handle;   // fallback: exact identifier
  }
  function readableModel(model) {
    return String(model).split(' + ').map(function (part) {
      var m = part.match(/^(\d+) x (.+)$/);
      return m ? m[1] + ' x ' + readableItem(m[2]) : readableItem(part);
    }).join(' + ');
  }
  function quoteEstimateText(x) {
    if (!validEstimate(x.estimate, x.model)) return T.quote_estimate_legacy;
    var lines = x.estimate.lines;
    /* G32: a total exists ONLY across one proven currency: all-catalogue (the existing
       unverified estimate) or all-store in ONE currency. Never blend, never cross. */
    var storeCurs = lines.filter(function (l) { return l.s === 'store' && /^[A-Z]{3}$/.test(l.cur || ''); })
      .map(function (l) { return l.cur; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    var allStoreOneCur = storeCurs.length === 1 &&
      lines.every(function (l) { return (l.c === null) || (l.s === 'store' && l.cur === storeCurs[0]); });
    var noStore = lines.every(function (l) { return l.s !== 'store'; });
    var totalAllowed = noStore || allStoreOneCur;
    var per = 0, complete = true, anyPriced = false;
    var details = lines.map(function (line) {
      var amt;
      if (line.c === null) { complete = false; amt = T.quote_price; }
      else {
        anyPriced = true;
        amt = line.s === 'store' && line.cur ? moneyCur(line.c, line.cur) : estimateMoney(line.c);
        if (totalAllowed) {
          var extension = line.c * line.q;
          if (!Number.isSafeInteger(extension) || !Number.isSafeInteger(per + extension)) complete = false;
          else per += extension;
        }
      }
      return line.q + ' x ' + readableItem(line.h) + ' @ ' + amt;
    }).join(', ');
    var total = per * x.qty;
    if (!Number.isSafeInteger(x.qty) || x.qty <= 0 || !Number.isSafeInteger(total)) complete = false;
    var totalsText;
    if (anyPriced && !totalAllowed) {
      totalsText = T.quote_estimate_nocross;
      complete = false;
    } else if (complete) {
      totalsText = fill(T.quote_estimate_totals, { per: noStore ? estimateMoney(per) : moneyCur(per, storeCurs[0]),
        n: x.qty, total: noStore ? estimateMoney(total) : moneyCur(total, storeCurs[0]) });
    } else totalsText = T.quote_estimate_unknown;
    /* G32-R1 f1: the CURRENT total derives ONLY from the exact fresh refresh state */
    var curLine = '';
    if (x.current && x.current.stale !== true && x.current.lines && x.current.currency) {
      var cper = 0, cok = true;
      var citems = x.current.lines.map(function (l) {
        var ext = l.cents * l.q;
        if (!Number.isSafeInteger(l.cents) || l.cents <= 0 ||
            !Number.isSafeInteger(l.q) || l.q <= 0 ||
            !Number.isSafeInteger(ext) || !Number.isSafeInteger(cper + ext)) cok = false;
        else cper += ext;
        return l.q + ' x ' + readableItem(l.h) + ' @ ' + moneyCur(l.cents, x.current.currency);
      }).join(', ');
      if (!Number.isSafeInteger(x.qty) || x.qty <= 0 || !Number.isSafeInteger(cper * x.qty)) cok = false;
      curLine = fill(T.current_store_prices, { cur: x.current.currency, lines: citems }) + ' ' +
        (cok ? fill(T.quote_estimate_totals, { per: moneyCur(cper, x.current.currency), n: x.qty, total: moneyCur(cper * x.qty, x.current.currency) }) : T.quote_estimate_unknown) + '. ';
    }
    if (curLine && x.current.lines.length) return curLine + T.quote_estimate_disclaimer;   // today's prices read: say them once
    /* the label keeps its accepted state-based meaning; a restored estimate is always SAVED */
    return (estimateState(x.estimate) === 'index' && x.estimate.restored !== true ? T.quote_estimate_current : T.quote_estimate_saved) + ': ' +
      fill(T.quote_estimate_lines, { lines: details }) + '. ' + totalsText + '. ' + curLine + T.quote_estimate_disclaimer;
  }
  function quoteLine(x) {
    if (rowHolds(x).length) {
      var valid = x.kind === 'requirements' ? T.req_label + ' ' +
        requirementFacts(x.requirements, rowHolds(x)) :
        fill(T.input_hold_equipment, { model: x.model }) + (x.note ? ' ' + x.note : '');
      return T.input_hold_title + ' ' + valid + ' ' +
        rowHolds(x).map(function (h) { return holdText(h, false); }).join(' ');
    }
    if (x.kind === 'requirements') {
      var hasCandidate = x.candidate === CANDIDATE_ID && candidateEligible(x.requirements);
      return (hasCandidate ? T.req_candidate_label : T.req_label) + ' ' +
        fill(x.qty === 1 ? T.req_one : T.req_many,
          { n: x.qty, facts: requirementFacts(x.requirements) }) +
        (hasCandidate ? '\n' + candidateQuote(x.requirements, x.qty) : '');
    }
    if (x.kind === 'saved_review') return fill(x.qty === 1 ? T.saved_review_quote_one : T.saved_review_quote_many,
      { n: x.qty, model: x.model, note: x.note || '' }) + (quoteVoltageStale(x) ? ' ' + quoteVoltageStale(x) : '') +
      (quoteBundleStale(x) ? ' ' + quoteBundleStale(x) : '');
    var model = readableModel(x.model) + (x.note ? ' (' + x.note + ')' : '');
    return fill(x.qty === 1 ? T.quote_one : T.quote_many, { n: x.qty, model: model }) +
      ' ' + quoteEstimateText(x) +
      (quoteVoltageStale(x) ? ' ' + quoteVoltageStale(x) : '') +
      (quoteBundleStale(x) ? ' ' + quoteBundleStale(x) : '');
  }

  // Runtime curve (Master, 2 Oct 2026, from the makers' selectors): the maker's runtime table drawn as runtime against
  // load, one line per pack count, with the buyer's load and runtime marked. Only units with a maker table (no derived
  // curve is drawn); points under 20 % of the rating are left out so the scale stays readable.
  function runtimeChart(e) {
    var u = e.u;
    if (!u.rtab || !u.rtab.length || e.bundleReview || hasInputHolds() || !u.w) return '';
    var byN = {};
    u.rtab.forEach(function (pt) { if (pt[1] >= u.w * 0.2 && pt[1] <= u.w) (byN[pt[0]] = byN[pt[0]] || []).push(pt); });
    var ns = Object.keys(byN).map(Number).filter(function (n) { return byN[n].length >= 3; }).sort(function (a, b) { return a - b; }).slice(0, 4);
    if (!ns.length) return '';
    var maxM = 0;
    ns.forEach(function (n) { byN[n].forEach(function (pt) { maxM = Math.max(maxM, pt[2]); }); });
    if (!maxM) return '';
    var W = 300, H = 150, L = 34, R = 8, Tp = 8, Bt = 26;
    function x(w) { return (L + w / u.w * (W - L - R)).toFixed(1); }
    function y(m) { return (H - Bt - Math.min(m, maxM) / maxM * (H - Bt - Tp)).toFixed(1); }
    var dash = ['', '4 3', '2 3', '6 2 2 2'];
    var lines = ns.map(function (n, k) {
      var pts = byN[n].slice().sort(function (a, b) { return a[1] - b[1]; }).map(function (pt) { return x(pt[1]) + ',' + y(pt[2]); }).join(' ');
      return '<polyline points="' + pts + '" fill="none" stroke="currentColor" stroke-width="1.6"' + (dash[k] ? ' stroke-dasharray="' + dash[k] + '"' : '') + '></polyline>';
    }).join('');
    var you = q.load > 0 && q.load <= u.w ? '<line x1="' + x(q.load) + '" x2="' + x(q.load) + '" y1="' + Tp + '" y2="' + (H - Bt) + '" stroke="currentColor" stroke-opacity="0.45"></line>' +
      '<text x="' + x(q.load) + '" y="' + (Tp + 9) + '" font-size="9" text-anchor="middle" fill="currentColor">' + esc(T.rtc_you) + '</text>' : '';
    var need = q.runtime > 0 && q.runtime <= maxM ? '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + y(q.runtime) + '" y2="' + y(q.runtime) + '" stroke="currentColor" stroke-opacity="0.35" stroke-dasharray="3 3"></line>' : '';
    var axes = '<line x1="' + L + '" x2="' + L + '" y1="' + Tp + '" y2="' + (H - Bt) + '" stroke="currentColor" stroke-opacity="0.5"></line>' +
      '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + (H - Bt) + '" y2="' + (H - Bt) + '" stroke="currentColor" stroke-opacity="0.5"></line>' +
      '<text x="' + (L + 4) + '" y="' + (Tp + 8) + '" font-size="9" fill="currentColor">' + Math.round(maxM) + ' min</text>' +
      '<text x="' + (L - 4) + '" y="' + (H - Bt) + '" font-size="9" text-anchor="end" fill="currentColor">0</text>' +
      '<text x="' + x(u.w) + '" y="' + (H - 12) + '" font-size="9" text-anchor="end" fill="currentColor">' + esc(watts(u.w)) + ' W</text>' +
      '<text x="' + ((L + W - R) / 2) + '" y="' + (H - 2) + '" font-size="9" text-anchor="middle" fill="currentColor">' + esc(T.rtc_x) + '</text>' +
      '';
    // Builder X item 14: what-if load slider on the maker table (same points, same interpolation as the ranking).
    var wl = Math.min(u.w, Math.max(Math.ceil(u.w * 0.2 / 50) * 50, Math.round((q.load || u.w / 2) / 50) * 50));
    you += '<line data-whatif-line x1="' + x(wl) + '" x2="' + x(wl) + '" y1="' + Tp + '" y2="' + (H - Bt) + '" stroke="currentColor" stroke-width="1.4" stroke-dasharray="1 2"></line>';
    var whatif = '<label class="upsb-sb__whatif">' + esc(T.whatif_label) + '<input type="range" data-whatif="' + esc(u.h) + '" min="' +
      Math.ceil(u.w * 0.2 / 50) * 50 + '" max="' + u.w + '" step="50" value="' + wl + '"></label><p class="upsb-sb__whatif-out" data-whatif-out aria-live="polite">' +
      esc(whatifText(u, ns, wl)) + '</p>';
    var legend = ns.map(function (n, k) { return '<li><svg width="22" height="8" aria-hidden="true"><line x1="0" x2="22" y1="4" y2="4" stroke="currentColor" stroke-width="1.6"' +
      (dash[k] ? ' stroke-dasharray="' + dash[k] + '"' : '') + '></line></svg> ' + esc(n ? fill(T.rtc_packs, { n: n }) : T.rtc_internal) + '</li>'; }).join('');
    return '<details class="upsb-sb__rtc"><summary>' + esc(T.rtc_title) + '</summary><svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + esc(T.rtc_title) + '">' +
      axes + need + lines + you + '</svg><ul class="upsb-sb__rtc-legend">' + legend + (need ? '<li>- - ' + esc(T.rtc_need) + '</li>' : '') + '</ul>' + whatif + '</details>';
  }

  // Builder X (3 Oct 2026): the card's status, shared by the card and the quick picks above the list.
  function cardState(e) {
    var u = e.u, c = conf(e);
    var runtime = runtimeStatus(e), cardReady = networkReady(e);
    var reason = hasInputHolds() ? T.input_hold_blocked : needsTechnicalReview() ? reviewReason() :
      (e.p91Capacity ? T.p91_status : (e.bundleReview ? T.bundle_review : (outletIssue(e) ? outletIssue(e) :
      (!physicalCartOk(e) ? (physicalHeadline(e) || T.physical_review) :
      (runtime === 'short' && !cardReady ? (u.card === '' ? T.fit_runtime_short + ' ' + T.fit_card_inclusion_review : T.fit_runtime_card) :
      (runtime === 'short' ? T.fit_runtime_short :
      (!cardReady ? (u.card === '' ? T.fit_card_inclusion_review : T.fit_card_needed) :
      (runtime === 'meets' && !e.confirm && !e.plugUnknown && !reconfirm[u.h] ?
        (physical(e).status === 'pass' ? T.fit_supported : (physicalHeadline(e) || T.fit_supported)) : T.fit_review))))))));
    // Builder UX pass (09-30): one status label, key facts on the card, the rest folded under Details.
    if (e.tooBig && !hasInputHolds()) reason = e.u.ru_src === 'm' && q.rackU && e.u.ru > q.rackU ?
      fill(T.too_big_u, { ru: num(e.u.ru), free: num(q.rackU) }) : fill(T.too_big_depth, { dp: num(e.u.dp), max: num(q.depth) });
    else if (reason === T.physical_review && (q.rackU || q.depth) && physical(e).orientation !== 'tower') reason = T.typed_limit_review;
    var bad = e.mismatch || e.tooBig || physical(e).status === 'mismatch';
    if (!bad && discontinuedNoStock(e) && reason === T.fit_supported && T.discontinued_no_stock) reason = T.discontinued_no_stock;
    var shownTot = liveTotal(c), gone = anyUnavailable(e), overQuote = c.priced && shownTot >= 1000000 && c.total < 1000000;
    if (!bad && c.priced && gone) reason = T.cart_unavailable;
    else if (!bad && overQuote) reason = T.cart_quote_only;
    else if (!bad && c.priced && c.total >= 1000000 && T.over_limit_quote) reason = T.over_limit_quote;   // round 13: say why a 10,000+ setup is quote-only
    var orderable = c.priced && c.total < 1000000 && shownTot < 1000000 && !gone && cartEligible(e);
    var st = bad ? 'bad' : (orderable ? (reason === T.fit_supported ? 'ready' : 'check') :
      (q.outlet === 'unknown' && reason === T.outlet_unknown_hold && ['120', '208-240', 'unknown'].indexOf(q.power) >= 0 ? 'outlet' :
        (runtime === 'short' && !hasInputHolds() ? 'short' : 'quote')));
    if (st === 'short') reason = fill(e.packs && !e.bundleReview ? T.short_add_packs : T.short_pick_other, { m: num(q.runtime) });
    // D-FREIGHT in the builder (item 12): an orderable setup with a piece over 67.95 kg goes through a freight quote.
    if (orderable && freightOf(c)) { orderable = false; st = 'freight'; reason = T.freight_reason; }
    return { c: c, runtime: runtime, reason: reason, bad: bad, shownTot: shownTot, gone: gone, orderable: orderable, st: st };
  }
  function solutionCard(e, i) {
    var u = e.u, s = cardState(e), c = s.c, reason = s.reason, bad = s.bad, orderable = s.orderable, st = s.st;
    var all = facts(e).filter(function (f) { return f[1] !== reason && !(st === 'short' && f[1] === T.cart_runtime_short); });
    var pinned = !!pinH && u.h === pinH && sortMode === 'best';
    var best = !pinned && i === 0 && sortMode !== 'price' && sortMode !== 'runtime' && !brandFilter && !budget && !noPack &&
      !(pinH && lastRes[0] && lastRes[0].u.h === pinH) && (st === 'ready' || st === 'check');
    var keyFacts = all.filter(function (f) { return f[2]; }), moreFacts = all.filter(function (f) { return !f[2]; });
    var href = PREFIX + '/products/' + encodeURIComponent(u.h);
    return '<article class="upsb-sb__sol' + (bad ? ' is-mismatch' : '') +
      '" data-solution-h="' + esc(u.h) + '">' +
      '<a class="upsb-sb__media" href="' + href + '" tabindex="-1" aria-hidden="true">' +
      imgTag(u, 100) + '</a>' +
      '<div class="upsb-sb__card">' + (best ? '<p class="upsb-sb__best">' + esc(T.best_match) + '</p>' : '') +
      (pinned ? '<p class="upsb-sb__best upsb-sb__best--pin">' + esc(T.pinned_label) + '</p>' : '') +
      '<div class="upsb-sb__top"><h3><a href="' + href + '">' + esc(u.t) + '</a>' +
      (!e.bundleReview && selFor(e).e > 0 && !e.meets ? ' <span class="upsb-sb__plus">' + esc(T.plus_packs) + '</span>' : '') + '</h3>' +
      '<div class="upsb-sb__price">' + esc(c.priced ? money(liveTotal(c)) : (c.total ? money(liveTotal(c)) + ' + ' + T.quote_price : T.quote_price)) + '</div></div>' +
      (c.priced || c.total ? '<p class="upsb-sb__price-note">' + esc(T.price_note) + '</p>' : '') +
      availLine(s) +
      rbLine(e) +
      specLine(e) + '<p class="upsb-sb__status is-' + st + '"><b>' + esc(T['status_' + st]) + '</b>' +
        (st === 'outlet' ? '' : '<span class="upsb-sb__reason">' + esc(reason) + '</span>') + '</p>' +
      (c.items.length > 1 ? '<ol class="upsb-sb__items">' + c.items.map(function (it) { return '<li title="' + esc(itemLabel(it)) + '">' +
        esc((it[3] > 1 ? it[3] + ' x ' : '') + shortModel({ t: it[1], h: it[0] })) + ' <span>' + esc(money(it[2] ? shownCents(it[0], it[2]) * it[3] : 0)) + '</span></li>'; }).join('') + '</ol>' : '') +
      (keyFacts.length ? '<ul class="upsb-sb__facts">' + keyFacts.map(function (f) { return '<li class="' + f[0] + '">' + esc(f[1]) + '</li>'; }).join('') + '</ul>' : '') +
      (!hasInputHolds() && (e.rt || B.packRuntime(e, selFor(e), q.load)) ? '<p class="upsb-sb__rt-note">' + esc(T.rt_note) + '</p>' : '') +
      (moreFacts.length ? '<details class="upsb-sb__more-facts"><summary>' + esc(fill(T.details, { n: moreFacts.length })) + '</summary><ul>' +
        moreFacts.map(function (f) { return '<li class="' + f[0] + '">' + esc(f[1]) + '</li>'; }).join('') + '</ul></details>' : '') +
      j60Detail(e) +
      runtimeChart(e) +
      (e.inputVoltage ? '<details class="upsb-sb__input-source"><summary>' + esc(T.input_voltage_details) + '</summary><p>' + esc(typedInputDetail(e)) + '</p>' +
        (typedInputSourceUrl(e) ? '<p><a href="' + esc(typedInputSourceUrl(e)) + '" target="_blank" rel="noopener noreferrer">' +
          esc(T.input_voltage_source_link) + '</a></p>' : '') + '</details>' : '') +
      placementCard(e) +
      addons(e, i) +
      '<div class="upsb-sb__btns">' +
      '<label class="upsb-sb__cmpbox"><input type="checkbox" data-cmp="' + esc(u.h) + '"' + (cmpHandles.indexOf(u.h) !== -1 ? ' checked' : '') + '> ' + esc(T.compare) + '</label>' +
      (cartUncertain[u.h] ? '<a class="button button--secondary" href="' + PREFIX + '/cart">' + esc(T.view_cart) + '</a>' :
      cartCurrent(e) ? '<span class="upsb-sb__added">' + esc(T.added) + '</span><a class="button button--secondary" href="' + PREFIX +
        '/cart">' + esc(T.view_cart) + '</a><a class="button" href="/checkout' + (FR ? '?locale=fr' : '') + '">' + esc(T.checkout) + '</a>' :
        (inCart[u.h] ? '<p class="upsb-sb__cart-notice">' + esc(T.cart_stale) + '</p>' +
          (orderable ? '<button type="button" class="button" data-add="' + i + '"' + (cartPending[u.h] ? ' disabled' : '') + '>' + esc(c.items.length > 1 ? T.add_solution : T.add_cart) + '</button>' : '') :
        (orderable ? '<button type="button" class="button" data-add="' + i + '"' + (cartPending[u.h] ? ' disabled' : '') + '>' + esc(c.items.length > 1 ? T.add_solution : T.add_cart) + '</button>' : ''))) +
      (getPriceShown(s) ? '<button type="button" class="button" data-get-price="' + i + '">' + esc(st === 'freight' ? T.freight_btn : T.get_price) + '</button>' : '') +
      '<button type="button" class="button button--secondary" data-quote="' + i + '">' + esc(T.add_quote) + '</button>' +
      '<button type="button" class="button button--tertiary upsb-sb__check" data-check-build="' + i + '">' + esc(T.check_build) + '</button>' +
      '<button type="button" class="button button--tertiary" data-quote-review hidden></button></div>' +
      (getPriceShown(s) ? '<p class="upsb-sb__gp-note">' + esc(T.get_price_note) + '</p>' : '') +
      '<p class="upsb-sb__quote-feedback" role="status" aria-live="polite" data-quote-feedback></p>' +
      (i < 12 && sel[u.h] ? '<button type="button" class="button button--tertiary" data-saved-remove="' + esc(u.h) + '">' +
        esc(T.saved_review_remove) + '</button>' : '') +
      (cartNotice[u.h] ? '<p class="upsb-sb__cart-notice" role="status">' + esc(cartNotice[u.h]) + '</p>' : '') + '</div></article>';
  }
  // ---- Builder X (Master, 3 Oct 2026) ----
  // Live per-product facts from the product page itself (templates/product.upsb-data.liquid): availability as the
  // product page states it, and D-FREIGHT (a piece over 67.95 kg sells through a freight quote). Never the index
  // snapshot: stock changes every supplier sync.
  var liveData = {}, dataFetched = {}, budget = '', noPack = false, pinH = '';
  function fillData(res) {
    var want = [];
    res.forEach(function (e) {
      conf(e).items.forEach(function (it) { if (!dataFetched[it[0]]) { dataFetched[it[0]] = 1; want.push(it[0]); } });
    });
    if (!want.length || location.protocol === 'file:' || typeof fetch !== 'function') return;
    Promise.all(want.map(function (h) {
      var req;
      try { req = fetch('/products/' + encodeURIComponent(h) + '?view=upsb-data'); } catch (x) { return null; }
      return Promise.resolve(req).then(function (r) { return r && r.ok && r.text ? r.text() : ''; })
        .then(function (t) {
          var d = null;
          try { d = JSON.parse(t); } catch (x) { d = null; }
          if (d && d.h === h && ['in', 'made', 'order', 'none'].indexOf(d.s) >= 0) liveData[h] = d;
        }).catch(function () {});
    })).then(function () { if (index && !batteryMode) render(); });
  }
  // Card images (Christian, 3 Oct: "some images of products in the solutions builder are not rendering properly"): the
  // index keeps a snapshot of each product's featured image, and replaced photos left 123 dead links. The image now comes
  // from the live product data once it arrives, and an image that still fails to load is hidden instead of shown broken.
  function imgTag(u, size) {
    var d = liveData[u.h], src = d && d.img ? d.img : (u.img ? thumb(u.img) : '');
    return src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="' + size + '" height="' + size +
      '" onerror="this.style.visibility=\'hidden\'">' : '';
  }
  function freightOf(c) { return c.items.some(function (it) { return liveData[it[0]] && liveData[it[0]].fq === true; }); }
  function quoteOnly(s) { return !s.c.priced || s.c.total >= 1000000 || s.shownTot >= 1000000; }
  function availLine(s) {
    if (s.bad || s.gone) return '';
    var k = quoteOnly(s) ? 'quote' : '';
    if (!k) {
      var states = s.c.items.map(function (it) { return liveData[it[0]] ? liveData[it[0]].s : ''; });
      if (states.some(function (x) { return !x || x === 'none'; })) return '';
      k = states.every(function (x) { return x === 'in'; }) ? 'in' :
        (states.every(function (x) { return x === 'in' || x === 'made'; }) ? 'made' : 'order');
    }
    return '<p class="upsb-sb__avail is-' + k + '">' + esc(T['avail_' + k]) + '</p>';
  }
  // Battery-life line (item 13): the UPS's own replacement batteries from its product page (ups.compatible_batteries).
  function rbLine(e) {
    var d = liveData[e.u.h], rb = d && d.rb;
    if (!rb || typeof rb[0] !== 'string' || !(rb[1] > 0)) return '';
    return '<p class="upsb-sb__rb">' + esc(fill(rb[2] > 1 ? T.rb_from : T.rb_one, { p: money(rb[1]) })) + ' <a href="' + PREFIX + '/products/' +
      encodeURIComponent(rb[0]) + '">' + esc(T.rb_see) + '</a></p>';
  }
  function getPriceShown(s) {
    return !hasInputHolds() && !needsTechnicalReview() &&
      (s.st === 'freight' || (quoteOnly(s) && ['bad', 'short', 'outlet'].indexOf(s.st) < 0));
  }
  function talkHtml() {
    return '<p class="upsb-sb__talk">' + esc(T.talk_line).replace('438-881-3363', '<a href="tel:+14388813363">438-881-3363</a>') + '</p>';
  }
  // Results view filters (item 5): budget on the setup's shown total, and UPS-alone setups only.
  function filterView(list) {
    return list.filter(function (e) {
      if (brandFilter && e.u.v !== brandFilter) return false;
      if (noPack && selFor(e).e > 0) return false;
      if (budget) {
        var c = conf(e);
        if (!c.priced) return false;
        var t = liveTotal(c);
        if (budget === '1' ? t >= 100000 : (budget === '2' ? t < 100000 || t > 300000 : t <= 300000)) return false;
      }
      return true;
    });
  }
  // The UPS a product page sent the shopper from shows first, in the default order, with its verdict for their answers.
  function pinFirst(list) {
    if (!pinH || sortMode !== 'best') return list;
    var at = list.findIndex(function (e) { return e.u.h === pinH; });
    if (at <= 0) return list;
    var out = list.slice();
    out.unshift(out.splice(at, 1)[0]);
    return out;
  }
  function filtersHtml() {
    return '<div class="upsb-sb__filters"><span class="upsb-sb__filters-k">' + esc(T.budget_label) + '</span>' +
      ['', '1', '2', '3'].map(function (b) {
        return '<button type="button" class="upsb-sb__chip upsb-sb__chip--sm' + (budget === b ? ' is-active' : '') +
          '" data-budget="' + b + '" aria-pressed="' + (budget === b ? 'true' : 'false') + '">' +
          esc(b ? T['budget_' + b] : T.budget_any) + '</button>';
      }).join('') + '<label class="upsb-sb__nopack"><input type="checkbox" data-nopack' + (noPack ? ' checked' : '') + '> ' +
      esc(T.nopack_label) + '</label></div>';
  }
  function filteredEmpty() {
    return '<div class="upsb-sb__filter-empty"><p>' + esc(T.filter_empty) + '</p><button type="button" class="button button--secondary" data-filter-clear>' +
      esc(T.filter_clear) + '</button></div>';
  }
  // Three quick picks (item 4) from the orderable setups, in the engine's order (its "Best match" order stays as is).
  function picksHtml(engineList) {
    if (hasInputHolds() || needsTechnicalReview()) return '';
    var ok = [];
    for (var i = 0; i < engineList.length && ok.length < 400; i++) {
      var e = engineList[i], s = cardState(e), rt = selectedRuntime(e);
      if ((s.st === 'ready' || s.st === 'check') && s.c.priced) ok.push({ e: e, s: s, t: liveTotal(s.c), m: rt && rt.min > 0 ? rt.min : 0 });
    }
    if (ok.length < 2) return '';
    var low = ok[0], long = ok[0];
    ok.forEach(function (x) { if (x.t < low.t) low = x; if (x.m > long.m) long = x; });
    var picks = [], byH = {};
    [[ok[0], T.pick_best, 'best'], [low, T.pick_low, 'price'], [long, T.pick_long, 'runtime']].forEach(function (p) {
      var h = p[0].e.u.h;
      if (byH[h]) { byH[h].labels.push(p[1]); return; }
      byH[h] = { x: p[0], labels: [p[1]], sort: p[2] };
      picks.push(byH[h]);
    });
    return '<section class="upsb-sb__picks" aria-label="' + esc(T.picks_title) + '"><h2 class="upsb-sb__picks-title">' + esc(T.picks_title) + '</h2>' +
      '<div class="upsb-sb__picks-row">' + picks.map(function (p) {
        var u = p.x.e.u, n = selFor(p.x.e).e;
        return '<div class="upsb-sb__pick"><p class="upsb-sb__pick-k">' + esc(p.labels.join(' · ')) + '</p>' +
          '<div class="upsb-sb__pick-body">' + imgTag(u, 56) +
          '<div><p class="upsb-sb__pick-m">' + esc(shortModel(u)) + '</p><p class="upsb-sb__pick-p">' + esc(money(p.x.t)) + '</p>' +
          '<p class="upsb-sb__pick-r">' + esc([p.x.m ? fill(T.pick_rt, { m: rtNum(p.x.m) }) : '',
            n > 0 ? fill(n === 1 ? T.packs_selected_1 : T.packs_selected, { n: n }) : ''].filter(Boolean).join(' · ')) + '</p></div></div>' +
          '<button type="button" class="button button--tertiary" data-pick="' + esc(u.h) + '" data-pick-sort="' + p.sort + '">' +
          esc(T.pick_see) + '</button></div>';
      }).join('') + '</div></section>';
  }
  // "Email this build" (item 17): the buyer's own mail app, a plain summary and the build link. Nothing is sent or kept.
  function updateEmail(list) {
    var a = $('[data-email-build]');
    if (!a) return;
    var lines = [fill(T.email_answers, { a: answersLine() }), ''];
    var top = (list || []).slice(0, 3);
    if (top.length) {
      lines.push(T.email_options);
      top.forEach(function (e, k) {
        var s = cardState(e);
        lines.push((k + 1) + '. ' + e.u.t + (s.c.priced ? ': ' + money(liveTotal(s.c)) : '') +
          (s.st === 'ready' ? ' (' + T.email_ready + ')' : (s.st === 'check' ? ' (' + T.email_check + ')' : (quoteOnly(s) || s.st === 'freight' ? ' (' + T.email_quote + ')' : ''))));
      });
      lines.push('');
    }
    lines.push(T.email_link, location.href);
    a.href = 'mailto:?subject=' + encodeURIComponent(T.email_subject) + '&body=' + encodeURIComponent(lines.join('\r\n'));
  }
  // Outlet pictures (item 3): NEMA receptacle faces, drawn, so the shopper can match the wall.
  function outletIcon(code) {
    var face = '<rect x="7" y="4" width="26" height="32" rx="7"/>';
    var ground = '<path d="M17.6 30.5v-2.6a2.4 2.4 0 0 1 4.8 0v2.6z" fill="currentColor" stroke="none"/>';
    var lock = '<circle cx="20" cy="20" r="15"/>' +
      '<path d="M12.8 14.6A9 9 0 0 1 17.2 11.4M22.8 11.4A9 9 0 0 1 27.2 14.6M24.6 27.7A9 9 0 0 1 15.4 27.7l-1.4-2.4" stroke-width="3" stroke-linecap="round"/>';
    var art = {
      '5-15R': face + '<rect x="12.5" y="10" width="3" height="10" rx="1" fill="currentColor" stroke="none"/><rect x="24.5" y="11" width="3" height="8" rx="1" fill="currentColor" stroke="none"/>' + ground,
      '5-20R': face + '<rect x="12.5" y="10" width="3" height="10" rx="1" fill="currentColor" stroke="none"/><rect x="9.5" y="17" width="6" height="3" rx="1" fill="currentColor" stroke="none"/><rect x="24.5" y="11" width="3" height="8" rx="1" fill="currentColor" stroke="none"/>' + ground,
      'HW': '<rect x="8" y="6" width="24" height="18" rx="2"/><path d="M20 24v10M14 34h12M17 12l4 4-3 1 4 4"/>',
      'unknown': '<circle cx="20" cy="20" r="15"/><path d="M16 16a4 4 0 1 1 5.5 3.7c-1 .5-1.5 1.2-1.5 2.3v1.5"/><circle cx="20" cy="28" r="1.3" fill="currentColor" stroke="none"/>'
    }[code] || lock;
    return '<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.6">' + art + '</svg>';
  }
  function outletTile(code, label, active) {
    return '<button type="button" class="upsb-sb__otile' + (active ? ' is-active' : '') + '" data-outlet-pick="' + esc(code) + '"' +
      (active ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' + outletIcon(code) + '<span>' + esc(label) + '</span>' +
      (code === '5-15R' ? '<small>' + esc(T.outlet_std) + '</small>' : '') + '</button>';
  }
  var OUTLET_TILES = {
    '120': ['5-15R', '5-20R', 'L5-20R', 'L5-30R', 'HW', 'unknown'],
    '208-240': ['L6-20R', 'L6-30R', 'HW', 'unknown'],
    'unknown': ['5-15R', '5-20R', 'L5-20R', 'L5-30R', 'L6-20R', 'L6-30R', 'HW', 'unknown']
  };
  function outletLabel(code) {
    var f = $('[data-upsb-form]'), o = f && f.elements.outlet && f.elements.outlet.querySelector('option[value="' + code + '"]');
    return code === 'unknown' ? T.outlet_unknown_tile : (o ? o.textContent.trim() : code);
  }
  function syncOutletTiles() {
    var box = root.querySelector('[data-otiles]');
    if (!box) return;
    var list = OUTLET_TILES[q.power];
    box.hidden = !list;
    if (!list) return;
    var html = '<p class="upsb-sb__otiles-k">' + esc(T.outlet_tiles_title) + '</p><div class="upsb-sb__otiles-row">' +
      list.map(function (code) { return outletTile(code, outletLabel(code), q.outlet === code); }).join('') + '</div>';
    if (box.getAttribute('data-html') !== html) { box.innerHTML = html; box.setAttribute('data-html', html); }
  }
  function initOutletTiles() {
    var f = $('[data-upsb-form]'), sel = f && f.elements.outlet;
    if (!sel || root.querySelector('[data-otiles]')) return;
    var box = document.createElement('div');
    box.className = 'upsb-sb__otiles'; box.setAttribute('data-otiles', '');
    var lab = sel.closest('label');
    lab.parentNode.insertBefore(box, lab.nextSibling);
  }
  // Results first from a link (item 2): answers that arrive in the URL fold the starting points and, on a phone or a
  // tablet, the form into one line with "Edit answers".
  function initLinkbar() {
    var body = root.querySelector('.upsb-sb__body');
    if (!body || root.querySelector('[data-linkbar]')) return;
    var bar = document.createElement('div');
    bar.className = 'upsb-sb__linkbar'; bar.setAttribute('data-linkbar', '');
    bar.innerHTML = '<p><b>' + esc(T.linkbar_title) + '</b> <span data-linkbar-text></span></p>' +
      '<button type="button" class="button button--secondary" data-linkbar-edit>' + esc(T.linkbar_edit) + '</button>' +
      '<p class="upsb-sb__linkbar-note" data-linkbar-note hidden></p>';
    body.parentNode.insertBefore(bar, body);
  }
  // Product page link (item 15): ?ups=<handle> starts from that UPS (80 % of its watts, its supply, outlet and form)
  // when the link carries no answers of its own.
  function applyUpsParam() {
    var h = upsFromLink;
    upsFromLink = '';
    var u = h && B.rows(index).find(function (r) { return r.h === h; });
    if (!u || !u.w || u.ph === '3') { if (h && !fromUrl) root.classList.remove('is-from-link'); return; }
    q.load = Math.max(50, Math.round(u.w * 0.8 / 50) * 50);
    q.power = u.volt === '120' ? '120' : (u.volt === '208' || u.volt === '240' ? '208-240' : (u.volt === '230' ? '230' : 'unknown'));
    var P = String(u.plug || '').toUpperCase().replace(/NEMA\s*/, '').trim();
    q.outlet = /HARD ?WIRE/.test(P) ? 'HW' : (OUTLET_OF_PLUG[P] || 'unknown');
    q.fit = u.ff === 'R' ? 'rack' : (u.ff === 'T' ? 'tower' : 'either');
    pinH = u.h;
    writeForm();
    root.classList.add('is-from-link');
    var note = root.querySelector('[data-linkbar-note]');
    if (note) { note.textContent = fill(T.rl_set, { m: u.t, w: q.load }); note.hidden = false; }
  }
  function initEmailBuild() {
    var tools = $('[data-upsb-tools]'), copy = tools && tools.querySelector('[data-copy-link]');
    if (!tools || tools.querySelector('[data-email-build]')) return;
    var a = document.createElement('a');
    a.className = 'button button--tertiary'; a.setAttribute('data-email-build', ''); a.href = 'mailto:';
    a.textContent = T.email_build;
    tools.insertBefore(a, copy ? copy.nextSibling : null);
  }
  // Battery search on a model the maker discontinued (item 9): offer the current model or a replacement UPS.
  var discHit = null;
  function initBatteryDiscontinued() {
    var input = root.querySelector('[data-upsb-bf-input]'), mode = root.querySelector('[data-upsb-battery-mode]');
    if (!input || !mode || mode.querySelector('[data-bf-disc]')) return;
    var box = document.createElement('div');
    box.className = 'upsb-sb__bfdisc'; box.setAttribute('data-bf-disc', ''); box.hidden = true;
    mode.appendChild(box);
    var timer = null;
    function check() {
      var k = String(input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      discHit = null;
      if (k.length >= 4 && index) {
        var rows = B.rows(index);
        for (var i = 0; i < rows.length && !discHit; i++) {
          var u = rows[i];
          if (u.lc !== 'D' || u.ph === '3') continue;
          var toks = String(u.t || '').split(/\s+/).map(function (x) { return x.toUpperCase().replace(/[^A-Z0-9]/g, ''); });
          if (u.h.toUpperCase().replace(/[^A-Z0-9]/g, '') === k || toks.indexOf(k) >= 0) discHit = u;
        }
      }
      if (!discHit) { box.hidden = true; box.innerHTML = ''; return; }
      var succ = discHit.succ && succModel(discHit.succ);
      var succRow = discHit.succ && B.rows(index).find(function (r) { return r.h === discHit.succ; });
      box.innerHTML = '<h2>' + esc(T.batt_disc_title) + '</h2><p><b>' + esc(discHit.t) + '</b></p><p>' + esc(T.batt_disc_text) + '</p>' +
        '<div class="upsb-sb__btns">' + (succ && succRow ? '<a class="button button--secondary" href="' + PREFIX + '/products/' +
        encodeURIComponent(discHit.succ) + '">' + esc(fill(T.batt_disc_succ, { m: succ })) + '</a>' : '') +
        '<button type="button" class="button button--tertiary" data-bf-disc-build>' + esc(T.batt_disc_build) + '</button></div>';
      box.hidden = false;
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(check, 250); });
    box.addEventListener('click', function (ev) {
      if (!ev.target.closest || !ev.target.closest('[data-bf-disc-build]') || !discHit) return;
      applyUpsRow(discHit);
      chooseMode(false);
      render(); commitRequirements('buyer');
      var rb = $('[data-upsb-results]');
      if (rb && rb.scrollIntoView) rb.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  // Item 14: runtime at a what-if load, per pack count shown on the chart (maker table points only).
  function whatifText(u, ns, load) {
    var parts = [];
    ns.forEach(function (n) {
      var r = B.tableAt(u.rtab, n, load, u.rtmethod);
      if (r && r.min > 0) parts.push((n ? fill(T.rtc_packs, { n: n }) : T.rtc_internal) + ' ' + fill(T.pick_rt, { m: rtNum(r.min) }));
    });
    return fill(T.whatif_at, { w: watts(load) }) + ' ' + (parts.length ? parts.join(' · ') : T.whatif_none);
  }
  // Item 6: on a phone, the bottom tray carries the setup the shopper last worked on, its total and its own main button.
  var chosenH = '';
  function buildBarHtml() {
    if (!chosenH || !window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return '';
    var card = root.querySelector('[data-upsb-results] .upsb-sb__sol[data-solution-h="' + chosenH + '"]');
    var e = lastRes.find(function (x) { return x.u.h === chosenH; });
    if (!card || !e) return '';
    var act = card.querySelector('.upsb-sb__btns [data-add], .upsb-sb__btns [data-get-price]') || card.querySelector('.upsb-sb__btns [data-quote]');
    var c = conf(e);
    return '<button type="button" class="upsb-sb__tray-build-go" data-tray-build-go><span>' + esc(T.build_label) + '</span> <b>' + esc(shortModel(e.u)) +
      '</b>' + (c.priced ? ' · ' + esc(money(liveTotal(c))) : '') + '</button>' +
      (act ? '<button type="button" class="button" data-tray-build-act>' + esc(act.hasAttribute('data-add') ? T.add_cart : act.textContent) + '</button>' : '');
  }
  function initBuilderX() {
    initLinkbar();
    initOutletTiles();
    initEmailBuild();
    initBatteryDiscontinued();
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var edit = t.closest('[data-linkbar-edit]');
      if (edit) {
        root.classList.remove('is-from-link');
        var f = $('[data-upsb-form]');
        if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (f && f.elements.load && f.elements.load.focus) f.elements.load.focus({ preventScroll: true });
        return;
      }
      var b = t.closest('[data-budget]');
      if (b) { budget = b.getAttribute('data-budget'); render(); return; }
      if (t.closest('[data-filter-clear]')) { budget = ''; noPack = false; brandFilter = ''; render(); return; }
      var pick = t.closest('[data-pick]');
      if (pick) {
        var h = pick.getAttribute('data-pick');
        chosenH = h;
        sortMode = pick.getAttribute('data-pick-sort') || 'best';
        var at = viewOrder(lastRes).findIndex(function (e) { return e.u.h === h; });
        if (at >= shownCount) shownCount = at + 1;
        render();
        var card = root.querySelector('[data-upsb-results] .upsb-sb__sol[data-solution-h="' + h + '"]');
        if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var link = card && card.querySelector('h3 a');
        if (link) link.focus({ preventScroll: true });
        return;
      }
      if (t.closest('[data-tray-build-go]')) {
        var goCard = root.querySelector('[data-upsb-results] .upsb-sb__sol[data-solution-h="' + chosenH + '"]');
        if (goCard && goCard.scrollIntoView) goCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (t.closest('[data-tray-build-act]')) {
        var actCard = root.querySelector('[data-upsb-results] .upsb-sb__sol[data-solution-h="' + chosenH + '"]');
        var act = actCard && (actCard.querySelector('.upsb-sb__btns [data-add], .upsb-sb__btns [data-get-price]') || actCard.querySelector('.upsb-sb__btns [data-quote]'));
        if (act && !act.disabled) act.click();
        return;
      }
      if (t.closest('[data-tray-cmp]')) {
        var sheet = $('[data-upsb-cmp]');
        if (sheet && !sheet.hidden && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
          sheet.classList.add('is-sheet'); root.classList.add('has-sheet');
          var closeBtn = sheet.querySelector('[data-cmp-sheet-close]');
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        }
        return;
      }
      if (t.closest('[data-cmp-sheet-close]')) {
        var sh = $('[data-upsb-cmp]');
        if (sh) sh.classList.remove('is-sheet');
        root.classList.remove('has-sheet');
        var tc = root.querySelector('[data-tray-cmp]');
        if (tc) tc.focus({ preventScroll: true });
        return;
      }
      var touched = t.closest('[data-upsb-results] .upsb-sb__sol');
      if (touched && !t.closest('h3 a, .upsb-sb__media')) { chosenH = touched.getAttribute('data-solution-h') || ''; updateTray(); }
      var gp = t.closest('[data-get-price]');
      if (gp) {
        var cardEl = gp.closest('.upsb-sb__sol');
        var qb = cardEl && cardEl.querySelector('[data-quote="' + gp.getAttribute('data-get-price') + '"]');
        if (!qb) return;
        qb.click();
        var send = $('[data-quote-send]');
        if (send && quote.length) send.click();
      }
    });
    root.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.matches || !ev.target.matches('[data-nopack]')) return;
      noPack = !!ev.target.checked; render();
    });
    root.addEventListener('input', function (ev) {
      var r = ev.target;
      if (!r || !r.matches || !r.matches('[data-whatif]')) return;
      var e = lastRes.find(function (x) { return x.u.h === r.getAttribute('data-whatif'); });
      var box = r.closest('.upsb-sb__rtc');
      if (!e || !box) return;
      var u = e.u, load = Number(r.value), byN = {};
      u.rtab.forEach(function (pt) { if (pt[1] >= u.w * 0.2 && pt[1] <= u.w) (byN[pt[0]] = byN[pt[0]] || []).push(pt); });
      var ns = Object.keys(byN).map(Number).filter(function (n) { return byN[n].length >= 3; }).sort(function (a, b) { return a - b; }).slice(0, 4);
      box.querySelector('[data-whatif-out]').textContent = whatifText(u, ns, load);
      var line = box.querySelector('[data-whatif-line]'), xx = (34 + load / u.w * (300 - 34 - 8)).toFixed(1);
      if (line) { line.setAttribute('x1', xx); line.setAttribute('x2', xx); }
    });
    root.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      var sh = $('[data-upsb-cmp]');
      if (sh && sh.classList.contains('is-sheet')) { sh.classList.remove('is-sheet'); root.classList.remove('has-sheet'); }
    });
  }
  function specLine(e) {
    var u = e.u, parts = [];
    if (u.va && u.w) parts.push(Number(u.va).toLocaleString(FR ? 'fr-CA' : 'en-CA') + ' VA / ' +
      Number(u.w).toLocaleString(FR ? 'fr-CA' : 'en-CA') + ' W');
    var topo = { O: T.topo_online, L: T.topo_line, S: T.topo_standby }[u.tp];
    if (topo) parts.push(topo);
    var ff = u.ff === 'R' ? T.fit_rack : (u.ff === 'T' ? T.fit_tower : (u.ff === 'C' ? T.fit_either : ''));
    if (ff) parts.push(ff + (u.ru && u.ru_src === 'm' && u.ff !== 'T' ? ' ' + u.ru + 'U' : ''));   // derived heights are not shown as fact
    if (e.loadPct > 0) parts.push(fill(T.spec_load, { p: Math.round(e.loadPct * 100) }));
    return (parts.length || u.cond === 'R' ? '<p class="upsb-sb__spec">' + (u.cond === 'R' ? '<span class="upsb-sb__cond">' +
      esc(T.refurbished) + '</span> ' : '') + esc(parts.join(' · ')) + '</p>' : '');
  }
  function rtNum(m) { return m >= 10 ? String(Math.round(m)) : num(m); }   // "about 35 min", "about 7.4 min"
  function reviewReason() {
    if (q.chemistry === 'required_lithium') return T.review_reason_lithium;
    if (q.chemistry === 'discuss') return T.review_reason_discuss;
    if (q.plugNeed !== 'unspecified') return T.review_reason_plug;
    return T.review_reason_monitoring;
  }
  // Review mode shows the options that meet the answers it can check; the requirement itself stays for a specialist.
  function reviewFilter(list) {
    return list.filter(function (e) {
      if (e.mismatch || e.tooBig) return false;
      var plug = String(e.u.plug || '').toUpperCase();
      if (q.plugNeed === 'HW' && !/HARD ?WIRE/.test(plug)) return false;
      if (q.plugNeed !== 'unspecified' && q.plugNeed !== 'HW' &&
          !new RegExp('(^|[^A-Z])' + q.plugNeed.replace('-', '\\-') + '($|[^0-9A-Z])').test(plug)) return false;
      if (q.chemistry === 'required_lithium' && !/LITHIUM|LI-ION|LIFEPO/i.test((e.u.t || '') + ' ' + (e.u.tf || ''))) return false;
      return true;
    });
  }
  var sortMode = 'best', brandFilter = '';
  function brandsOf(list) {
    var seen = {};
    list.forEach(function (e) { if (e.u.v) seen[e.u.v] = 1; });
    return Object.keys(seen).sort();
  }
  function viewOrder(list) {
    var out = pinFirst(filterView(list));
    if (sortMode !== 'price' && sortMode !== 'runtime') return out;
    function key(e) {
      if (sortMode === 'price') { var c = conf(e); return c.priced ? liveTotal(c) : 1e15; }
      var rt = selectedRuntime(e); return rt && rt.min > 0 ? -rt.min : 1e15;
    }
    // wrong fit last, then options that miss the runtime, then the chosen order
    return out.map(function (e, i) { return { e: e, i: i, k: key(e),
      bad: e.mismatch || e.tooBig || physical(e).status === 'mismatch' ? 2 : (runtimeStatus(e) === 'meets' ? 0 : 1) }; })
      .sort(function (a, b) { return a.bad - b.bad || a.k - b.k || a.i - b.i; })
      .map(function (x) { return x.e; });
  }
  function resultsBar(displayed, total, brands) {
    function opt(v, label, cur) { return '<option value="' + esc(v) + '"' + (v === cur ? ' selected' : '') + '>' + esc(label) + '</option>'; }
    return '<div class="upsb-sb__resbar"><p class="upsb-sb__count">' + esc(fill(T.count, { shown: displayed, total: total })) + '</p>' +
      '<div class="upsb-sb__resctl"><label>' + esc(T.sort_label) + '<select data-sort>' +
      opt('best', T.sort_best, sortMode) + opt('price', T.sort_price, sortMode) + opt('runtime', T.sort_runtime, sortMode) +
      '</select></label>' + (brands.length > 1 ? '<label>' + esc(T.brand_label) + '<select data-brand>' +
      opt('', T.brand_all, brandFilter) + brands.map(function (b) { return opt(b, b, brandFilter); }).join('') +
      '</select></label>' : '') + '</div>' + filtersHtml() + '</div>';
  }
  function emptyState() {
    var biggest = 0, maxAll = 0, max208 = 0;
    B.rows(index).forEach(function (u) {
      if (u.ph === '3' || !u.w || (u.ph !== '1' && /three-phase|triphas/i.test(u.t || ''))) return;
      if (u.w > maxAll) maxAll = u.w;
      if (u.w > max208 && B.voltFits('208-240', u.volt) === 'yes') max208 = u.w;
      if (u.w > biggest && B.voltFits(q.power, u.volt) !== 'no') biggest = u.w;
    });
    var nf = function (n) { return Number(n).toLocaleString(FR ? 'fr-CA' : 'en-CA'); };
    var kw = String(Math.round(q.load / 100) / 10).replace('.', FR ? ',' : '.');
    var tail = '<p class="upsb-sb__quote-feedback" role="status" aria-live="polite" data-req-feedback></p></div>';
    // Builder fix (Christian, 2 Oct 2026): a load no single-phase UPS carries goes straight to the three-phase designer,
    // with its kW carried over; a load that only fits a higher single-phase supply offers that supply in one click.
    if (q.load > maxAll && maxAll > 0) {
      return '<div class="upsb-sb__empty upsb-sb__empty--three"><h2>' + esc(fill(T.empty3_title, { w: nf(q.load) })) + '</h2><p>' +
        esc(fill(T.empty3_text, { max: nf(maxAll), kw: kw })) + '</p><div class="upsb-sb__btns"><button type="button" class="button" data-to-three="' +
        esc(kw.replace(',', '.')) + '">' + esc(fill(T.empty3_btn, { kw: kw })) + '</button><button type="button" class="button button--secondary" data-quote-requirements>' +
        esc(T.empty_quote) + '</button><button type="button" class="button button--tertiary" data-quote-review hidden></button></div>' + tail;
    }
    if (q.load > biggest && q.load <= max208 && q.power !== '208-240' && q.power !== 'three-phase') {
      return '<div class="upsb-sb__empty"><h2>' + esc(fill(T.emptyv_title, { supply: q.power === 'unknown' ? '' : q.power + ' V', w: nf(q.load) }).replace('  ', ' ')) +
        '</h2><p>' + esc(fill(T.emptyv_text, { max: nf(max208) })) + '</p><div class="upsb-sb__btns"><button type="button" class="button" data-set-power="208-240">' +
        esc(T.emptyv_btn) + '</button>' + (q.load >= 10000 ? '<button type="button" class="button button--secondary" data-to-three="' +
        esc(kw.replace(',', '.')) + '">' + esc(fill(T.empty3_btn, { kw: kw })) + '</button>' : '') +
        '<button type="button" class="button button--secondary" data-quote-requirements>' + esc(T.empty_quote) +
        '</button><button type="button" class="button button--tertiary" data-quote-review hidden></button></div>' + tail;
    }
    return '<div class="upsb-sb__empty"><h2>' + esc(T.empty_title) + '</h2><p>' +
      esc((q.load > biggest ? fill(T.empty_load, { w: q.load.toLocaleString(FR ? 'fr-CA' : 'en-CA') }) + ' ' : '') + T.empty_other) +
      '</p><div class="upsb-sb__btns"><button type="button" class="button" data-quote-requirements>' + esc(T.empty_quote) +
      '</button><button type="button" class="button button--secondary" data-preset="three">' + esc(T.empty_three) +
      '</button><button type="button" class="button button--tertiary" data-quote-review hidden></button></div>' +
      '<p class="upsb-sb__quote-feedback" role="status" aria-live="polite" data-req-feedback></p></div>';
  }
  function pl(key, n) { return T[key + (n === 1 ? '_1' : '')] || T[key]; }   // "1 battery pack", "2 battery packs"
  function thumb(src) {
    return /^https:\/\/cdn\.shopify\.com\//.test(src) ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=200' : src;
  }

  function savedChoice(h) {
    var a = unmatchedSaved[h], s = sel[h], keys = ['eI', 'c', 'x', 'r'];
    var out = { count: a ? a.e : (s ? s.e : 0), fields: {} };
    keys.forEach(function (key, i) {
      var f = a ? a.fields[i] : null, id = s && s.ids && s.ids[key];
      out.fields[key] = a ? { handle: f.handle || '', legacy: f.legacy >= 0,
        unresolved: !!f.unresolved } :
        { handle: id && id !== '?' ? id : '', legacy: false, unresolved: id === '?' };
    });
    return out;
  }

  function savedDetails(h) {
    var choice = savedChoice(h), labels = addonKindLabels(), lines = [], parts = [h];
    var pack = choice.fields.eI;
    if (choice.count > 0) {
      var packName = pack.handle || T.cmp_unknown;
      lines.push(fill(T.saved_review_pack, { n: choice.count, h: packName }));
      parts.push(choice.count + ' x ' + packName);
      if (pack.legacy) lines.push(fill(T.saved_review_legacy, { k: labels[0] }));
      else if (pack.unresolved) lines.push(fill(T.saved_review_unresolved, { k: labels[0] }));
    }
    ['c', 'x', 'r'].forEach(function (key, i) {
      var f = choice.fields[key], label = labels[i + 1];
      if (f.handle) { lines.push(fill(T.saved_review_component, { k: label, h: f.handle })); parts.push(f.handle); }
      else if (f.legacy) { lines.push(fill(T.saved_review_legacy, { k: label })); parts.push(label + ': ' + T.cmp_unknown); }
      else if (f.unresolved) { lines.push(fill(T.saved_review_unresolved, { k: label })); parts.push(label + ': ' + T.cmp_unknown); }
    });
    return { lines: lines, model: parts.join(' + ') };
  }

  // A successor's model for the buyer ("Tripp Lite SU2200XLCD"), never the raw handle: the longest title token that is a
  // model code inside the handle, after the brand; the title when no token qualifies.
  function succModel(h) {
    var H = String(h || '').toUpperCase().replace(/[^A-Z0-9]/g, ''), rows = index ? B.rows(index) : [];
    for (var i = 0; i < rows.length; i++) if (rows[i].h === h) {
      var s = rows[i], best = '', bn = '';
      String(s.t || '').split(/\s+/).forEach(function (w) {
        var w2 = w.replace(/^[(\[]+|[)\],;:]+$/g, ''), n = w2.toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (n.length >= 4 && /\d/.test(n) && /[A-Z]/.test(n) && H.indexOf(n) >= 0 && n.length > bn.length) { best = w2; bn = n; }
      });
      return best ? (s.v ? s.v + ' ' : '') + best : (s.t || '');
    }
    return '';
  }

  function savedUnit(h) {
    if (!index) return null;
    var hCol = index.fields.indexOf('h'), tCol = index.fields.indexOf('t');
    for (var i = 0; i < index.u.length; i++) if (index.u[i][hCol] === h)
      return { title: index.u[i][tCol] || h };
    return null;
  }

  function renderSavedReview() {
    var panel = $('[data-saved-review]');
    if (!panel) return;
    var handles = Object.keys(unmatchedSaved).concat(Object.keys(sel)).filter(function (h, i, all) {
      return all.indexOf(h) === i && !lastRes.slice(0, shownCount).some(function (e) { return e.u.h === h; });
    });
    if (!index || (!handles.length && !invalidSavedRaw.length)) { panel.hidden = true; panel.innerHTML = ''; return; }
    var html = '<h2>' + esc(T.saved_review_title) + '</h2><p>' + esc(T.saved_review_intro) + '</p>';
    if (invalidSavedRaw.length) html += '<div class="upsb-sb__saved-entry"><p role="alert">' +
      esc(T.saved_review_bad) + '</p><button type="button" class="button button--tertiary" data-saved-invalid-remove>' +
      esc(T.saved_review_bad_remove) + '</button></div>';
    handles.forEach(function (h) {
      var at = lastRes.findIndex(function (e) { return e.u.h === h; });
      html += '<div class="upsb-sb__saved-entry" data-saved-h="' + esc(h) + '">';
      if (at >= 12) {
        html += '<p>' + esc(T.saved_review_below) + '</p>' + solutionCard(lastRes[at], at);
      } else {
        var unit = savedUnit(h), reason = unit ? T.saved_review_filtered : T.saved_review_missing;
        var details = savedDetails(h);
        if (unit && index.input_voltage_v2 && Array.isArray(index.input_voltage_v2.target_handles) &&
            index.input_voltage_v2.target_handles.indexOf(h) >= 0)
          details.lines.push(T.input_voltage_saved);
        html += '<h3>' + esc(unit ? unit.title : h) + '</h3><p>' + esc(reason) + '</p>' +
          '<p>' + esc(fill(T.saved_review_current, { a: answersLine() })) + '</p>' +
          '<ul>' + details.lines.map(function (line) { return '<li>' + esc(line) + '</li>'; }).join('') + '</ul>' +
          '<div class="upsb-sb__btns"><button type="button" class="button button--secondary" data-saved-quote="' + esc(h) + '">' + esc(T.saved_review_quote) + '</button>' +
          '<button type="button" class="button button--tertiary" data-saved-requirements>' + esc(T.saved_review_requirements) + '</button></div>';
      }
      html += '<button type="button" class="button button--tertiary" data-saved-remove="' + esc(h) + '">' +
        esc(T.saved_review_remove) + '</button></div>';
    });
    panel.innerHTML = html;
    panel.hidden = false;
  }

  function restoreUnmatched() {
    var available = {};
    var changed = false;
    lastRes.forEach(function (e) { available[e.u.h] = true; });
    Object.keys(unmatchedSaved).forEach(function (h) {
      if (available[h]) { applyAddonParams([unmatchedSaved[h]]); changed = true; }
    });
    return changed;
  }

  function quoteMessage(previewAt, previewQty) {
    var hasReq = quote.some(function (x) { return x.kind === 'requirements'; });
    var hasSolution = quote.some(function (x) { return x.kind === 'solution' || x.kind === 'saved_review'; });
    var header = hasReq ? T.req_header : T.quote_header;
    if (hasReq && hasSolution) header += '\n' + T.req_mixed;
    return (checkBuild ? T.check_build_line + '\n' : '') + header + '\n' + quote.map(function (x, i) {
        var input = root.querySelector('[data-quote-qty="' + i + '"]');
        var raw = input ? String(input.value).trim() : '';
        var liveQty = /^[1-9]\d*$/.test(raw) && Number.isSafeInteger(Number(raw)) ? Number(raw) : x.qty;
        var qty = i === previewAt ? previewQty : liveQty;
        return quoteLine(Object.assign({}, x, { qty: qty }));
      }).join('\n');
  }

  function quoteReceiverBase() {
    var base = PREFIX + '/pages/request-a-quote?view=builder-quote';
    var preview = window.UPSBQuoteTransfer && window.UPSBQuoteTransfer.previewThemeId ?
      window.UPSBQuoteTransfer.previewThemeId() : new URLSearchParams(location.search).get('preview_theme_id');
    return /^\d{8,20}$/.test(preview || '') ? base + '&preview_theme_id=' + preview : base;
  }

  var quoteTransferCache = null;
  function quoteTransport(message) {
    var base = quoteReceiverBase(), locale = FR ? 'fr' : 'en';
    var transfer = window.UPSBQuoteTransfer;
    if (!transfer) {
      var directHref = base + '&message=' + encodeURIComponent(message);
      if (message.length > 8000) return { error: 'too_long' };
      return directHref.length <= 1800 ? { href: directHref, mode: 'url' } : { error: 'storage' };
    }
    if (message.length > transfer.maxBody) return { error: 'too_long' };
    if (quoteTransferCache && quoteTransferCache.message === message &&
        quoteTransferCache.base === base && quoteTransferCache.locale === locale) {
      var check = transfer.resolve(quoteTransferCache.token, locale);
      if (check.message === message) return { href: quoteTransferCache.href, mode: 'storage' };
    }
    // GLM review P0-3 (2 Oct 2026): a short reference in the URL, the request itself in this browser's storage.
    var prepared = transfer.prepare(base, message, locale, true);
    if (prepared.error === 'storage') {
      var shortHref = transfer.direct(base, message);
      if (shortHref) return { href: shortHref, mode: 'url' };
    }
    if (prepared.mode === 'storage') {
      quoteTransferCache = { message: message, base: base, locale: locale,
        href: prepared.href, token: new URLSearchParams(prepared.href.split('?')[1]).get('qt') };
    }
    return prepared;
  }

  function quoteSendHref(previewAt, previewQty) {
    return quoteTransport(quoteMessage(previewAt, previewQty)).href || '#';
  }

  function showQuoteTransferRecovery(message, error) {
    var recovery = $('[data-quote-transfer-recovery]');
    var copy = $('[data-quote-transfer-copy]');
    var manual = $('[data-quote-transfer-manual]');
    $('[data-quote-transfer-error]').textContent = error === 'too_long' ?
      T.quote_transfer_too_long : T.quote_transfer_unavailable;
    copy.value = message;
    manual.href = quoteReceiverBase();
    manual.textContent = error === 'too_long' ? T.quote_transfer_manual_short : T.quote_transfer_manual_full;
    recovery.hidden = false;
    copy.focus();
    copy.select();
  }

  function currentRequirementsSaved() {
    return !needsTechnicalReview() || currentRequirementAt() >= 0;
  }

  function refreshQuoteSendState() {
    var missing = !currentRequirementsSaved() || !!invalidSavedRaw.length || hasInputHolds();
    var invalid = root.querySelector('[data-quote-qty][aria-invalid="true"]');
    var formError = needsTechnicalReview() ? requirementFormError() : null;
    var formNotice = $('[data-req-form-error]');
    formNotice.textContent = formError ? (formError.field === 'shutdownPlatform' ?
      T.req_platform_invalid : fill(T.req_invalid, { field: T['req_field_' + formError.field] })) : '';
    formNotice.hidden = !formError;
    var send = $('[data-quote-send]');
    var tooLong = quoteMessage().length > 8000;
    send.textContent = tooLong ? T.quote_transfer_review : T.quote_transfer_continue;
    if (missing || invalid || formError) send.setAttribute('aria-disabled', 'true');
    else send.removeAttribute('aria-disabled');
    var warning = $('[data-quote-requirement-warning]');
    var currentReq = JSON.stringify(normalizedRequirements(q));
    var prior = needsTechnicalReview() && quote.some(function (x) {   // options picked under these same requirements are covered
      return (x.kind === 'solution' || x.kind === 'saved_review') && x.req !== currentReq; });
    warning.textContent = (prior ? T.req_prior_unchecked + ' ' : '') +
      (invalidSavedRaw.length ? T.saved_review_bad :
        (hasInputHolds() ? T.input_hold_blocked : (missing ? T.req_not_in_list : '')))
      + (tooLong ? ' ' + T.quote_transfer_too_long : '');
    warning.hidden = !warning.textContent;
  }

  function updateReviewControls() {
    var label = fill(T.quote_review, { n: quote.length });
    root.querySelectorAll('[data-quote-review]').forEach(function (button) {
      button.textContent = label;
      if (button.hasAttribute('data-quote-review-top') || !quote.length) button.hidden = !quote.length;
    });
    updateTray();
  }

  function renderQuote() {
    var el = $('[data-upsb-quote]');
    var recovery = root.querySelector('[data-quote-transfer-recovery]');
    if (recovery) recovery.hidden = true;
    renderInputHolds();
    updateReviewControls();
    if (!quote.length) { el.hidden = true; refreshQuoteSendState(); return; }
    el.hidden = false;
    var lines = quote.map(quoteLine);
    el.querySelector('[data-quote-lines]').innerHTML = lines.map(function (line, i) {
      var id = 'UpsbQuote-qty-error-' + i;
      var qtyHeld = rowHolds(quote[i]).some(function (h) { return h.field === 'qty'; });
      var controls = rowHolds(quote[i]).filter(function (h) { return h.field !== 'qty'; }).map(function (h) {
        var field = h.field, choices = INPUT_CHOICES[field];
        var input = choices || field === 'generator' || field === 'card' || field === 'monitorWatts' ?
          '<select data-saved-hold-field="' + esc(field) + '" data-row="' + i + '"><option value="">' +
          esc(T.input_hold_choose) + '</option>' +
          (choices || ['true', 'false']).map(function (v) { return '<option value="' + esc(v) + '">' +
            esc(choiceLabel(field, v)) + '</option>'; }).join('') + '</select>' :
          '<input type="text" data-saved-hold-field="' + esc(field) + '" data-row="' + i + '"' +
          (field === 'shutdownPlatform' ? ' maxlength="120"' : ' inputmode="decimal"') + '>';
        return '<div class="upsb-sb__hold-control"><label>' + esc(holdText(h, false)) + input + '</label></div>';
      }).join('');
      return '<li class="upsb-sb__quote-row" data-quote-row="' + i + '">' +
        '<p class="upsb-sb__quote-line">' + esc(line) + '</p>' +
        controls +
        '<div class="upsb-sb__quote-edit"><label for="UpsbQuote-qty-' + i + '">' +
        esc(quote[i].kind === 'requirements' ? T.req_qty :
          (quote[i].kind === 'saved_review' ? T.saved_review_qty : T.quote_qty)) + '</label>' +
        '<input id="UpsbQuote-qty-' + i + '" type="number" inputmode="numeric" min="1" step="1" ' +
        'value="' + (qtyHeld ? '' : quote[i].qty) + '" data-quote-qty="' + i + '" aria-describedby="' + id + '"' +
        (qtyHeld ? ' aria-invalid="true"' : '') + '>' +
        '<span class="upsb-sb__quote-error" id="' + id + '" role="alert" data-quote-error>' +
        (qtyHeld ? esc(T.input_hold_qty) : '') + '</span>' +
        (quote[i].kind === 'requirements' && quote[i].candidate === CANDIDATE_ID ?
          '<button type="button" class="button button--tertiary" data-candidate-remove="' + i + '">' +
          esc(T.candidate_remove) + '</button>' : '') +
        (quote[i].kind === 'solution' && quote[i].estimate && quote[i].estimate.restored === true &&
          validEstimate(quote[i].estimate, quote[i].model) ?
          '<button type="button" class="button button--tertiary" data-check-prices="' + i + '"' +
          (rowPriceChecks.get(quote[i]) && rowPriceChecks.get(quote[i]).busy ? ' disabled' : '') + '>' +
          esc(rowPriceChecks.get(quote[i]) && rowPriceChecks.get(quote[i]).busy ? T.check_prices_busy : T.check_prices) +
          '</button>' + rowPriceStatus(quote[i]) : '') +
        '<button type="button" class="button button--tertiary" data-quote-remove="' + i + '">' +
        esc(quote[i].kind === 'requirements' ? T.req_remove : T.quote_remove) + '</button></div></li>';
    }).join('');
    el.querySelector('[data-quote-send]').href = quoteSendHref();
    refreshQuoteSendState();
  }

  root.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-battery-return]')) { chooseMode(false); return; }
    if (ev.target.closest('[data-index-retry]')) { loadBuilderIndex(false); return; }
    var discardUrlHold = ev.target.closest('[data-url-hold-remove]');
    if (discardUrlHold) {
      var key = discardUrlHold.getAttribute('data-url-hold-remove');
      if (!urlHolds[key]) return;
      var beforeHoldRemoval = JSON.stringify(normalizedRequirements(q));
      delete urlHolds[key];
      q[key === 'gen' ? 'generator' : key] = safeDefault(key === 'gen' ? 'generator' : key);
      delete initialNumericFromUrl[key];
      resetShownIfRequirementsChanged(beforeHoldRemoval);
      writeForm(); render(); commitRequirements('buyer');
      return;
    }
    if (ev.target.closest('[data-saved-invalid-remove]')) {
      invalidSavedRaw = [];
      render();
      commitConfiguration('invalid_saved', 'cleared');
      var invalidRemovedStatus = $('[data-quote-global-status]');
      if (invalidRemovedStatus) invalidRemovedStatus.textContent = T.saved_review_removed;
      return;
    }
    var removeSaved = ev.target.closest('[data-saved-remove]');
    if (removeSaved) {
      var savedHandle = removeSaved.getAttribute('data-saved-remove');
      if (!unmatchedSaved[savedHandle] && !sel[savedHandle]) return;
      delete unmatchedSaved[savedHandle];
      delete sel[savedHandle];
      delete reconfirm[savedHandle];
      delete openAdd[savedHandle];
      delete cartNotice[savedHandle];
      cmpHandles = cmpHandles.filter(function (h) { return h !== savedHandle; });
      render();
      commitConfiguration('saved_present', 'saved_removed');
      var removedStatus = $('[data-quote-global-status]');
      if (removedStatus) removedStatus.textContent = T.saved_review_removed;
      return;
    }
    var reviewSavedRequirements = ev.target.closest('[data-saved-requirements]');
    if (reviewSavedRequirements) {
      var reviewForm = $('[data-upsb-form]');
      if (reviewForm.scrollIntoView) reviewForm.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (reviewForm.elements.load.focus) reviewForm.elements.load.focus();
      return;
    }
    var quoteSaved = ev.target.closest('[data-saved-quote]');
    if (quoteSaved) {
      var heldHandle = quoteSaved.getAttribute('data-saved-quote');
      if (!unmatchedSaved[heldHandle] && !sel[heldHandle]) return;
      if (lastRes.some(function (e) { return e.u.h === heldHandle; })) return;
      var held = savedDetails(heldHandle);
      var heldReason = savedUnit(heldHandle) ? T.saved_review_filtered : T.saved_review_missing;
      quote.push({ kind: 'saved_review', model: held.model, qty: 1,
        note: answersLine() + ' | ' + heldReason + ' | ' + (p91Target(heldHandle) ? T.p91_cart + ' | ' : '') + T.saved_review_quote_note +
          (held.lines.length ? ' | ' + held.lines.join(' | ') : '') });
      var heldSaved = persistQuote();
      quoteChanged('add', heldSaved);
      renderQuote(); render();
      var heldStatus = $('[data-quote-global-status]');
      if (heldStatus) heldStatus.textContent = quoteFeedback(fill(heldSaved ? T.quote_added : T.quote_added_visit, { n: quote.length }), heldSaved);
      return;
    }
    var discardSaved = ev.target.closest('[data-discard-saved-addon]');
    if (discardSaved) {
      var discardAt = parseInt(discardSaved.getAttribute('data-i'), 10);
      var solution = lastRes[discardAt];
      var discardKey = discardSaved.getAttribute('data-discard-saved-addon');
      if (!solution || ['eI', 'c', 'x', 'r'].indexOf(discardKey) < 0 ||
          !reconfirm[solution.u.h] ||
          !reconfirm[solution.u.h].kinds.some(function (kind) { return kind.key === discardKey; })) return;
      var saved = sel[solution.u.h] = Object.assign({}, selFor(solution));
      saved.ids = Object.assign({}, saved.ids || {});
      saved.ids[discardKey] = '';
      if (discardKey === 'eI') { saved.e = 0; saved.eI = -1; }
      else saved[discardKey] = -1;
      var pending = reconfirm[solution.u.h];
      pending.kinds = pending.kinds.filter(function (kind) { return kind.key !== discardKey; });
      pending.missing = pending.missing.filter(function (missing) { return missing.key !== discardKey; });
      if (!pending.kinds.length && !pending.missing.length) delete reconfirm[solution.u.h];
      delete inCart[solution.u.h];
      render();
      commitConfiguration('saved_hold', 'saved_discarded');
      var sameCard = root.querySelector('.upsb-sb__sol[data-solution-h="' + solution.u.h + '"]');
      var status = sameCard && sameCard.querySelector('[data-quote-feedback]');
      if (status) status.textContent = T.saved_discard_done;
      return;
    }
    var sendQuote = ev.target.closest('[data-quote-send]');
    if (sendQuote) {
      var invalidQuantity = root.querySelector('[data-quote-qty][aria-invalid="true"]');
      if (invalidQuantity) { ev.preventDefault(); invalidQuantity.focus();
        emit('upsb_quote_handoff', { result: 'blocked', reason: 'invalid_quantity' }); }
      else if (hasInputHolds()) {
        ev.preventDefault();
        var inputHold = $('[data-input-holds]');
        if (inputHold && inputHold.focus) inputHold.focus();
        emit('upsb_quote_handoff', { result: 'blocked', reason: Object.keys(urlHolds).length ? 'invalid_requirements' : 'saved_review' });
      }
      else if (invalidSavedRaw.length) {
        ev.preventDefault();
        var savedError = root.querySelector('[data-saved-review] [role="alert"]');
        if (savedError && savedError.focus) { savedError.setAttribute('tabindex', '-1'); savedError.focus(); }
        emit('upsb_quote_handoff', { result: 'blocked', reason: 'invalid_saved' });
      }
      else if (needsTechnicalReview() && requirementFormError()) {
        ev.preventDefault(); requirementFormError().element.focus();
        emit('upsb_quote_handoff', { result: 'blocked', reason: 'invalid_requirements' });
      }
      else if (!currentRequirementsSaved()) {
        ev.preventDefault();
        var addRequirements = root.querySelector('[data-quote-requirements]');
        if (addRequirements && addRequirements.focus) addRequirements.focus();
        emit('upsb_quote_handoff', { result: 'blocked', reason: 'requirements_not_saved' });
      }
      else {
        var message = quoteMessage();
        var prepared = quoteTransport(message);
        if (prepared.error || !prepared.href) {
          ev.preventDefault();
          showQuoteTransferRecovery(message, prepared.error);
          emit('upsb_quote_handoff', { result: 'blocked', reason: prepared.error === 'storage' ? 'storage' : 'transport' });
        } else {
          // G22: remember the buyer's requirements on this origin so the quote page's
          // return action can restore them. syncUrl() is the existing serializer (bounds-
          // validated params + a= selections); storage failure never blocks the handoff.
          try {
            syncUrl();
            localStorage.setItem('upsbBuilderReturnV1', location.pathname + location.search);
          } catch (e) { /* denied storage: return falls back to the plain builder link */ }
          sendQuote.href = prepared.href;
          $('[data-quote-transfer-recovery]').hidden = true;
          emit('upsb_quote_handoff', { result: 'initiated' });
        }
      }
      return;
    }
    var copyBtn = ev.target.closest('[data-copy-link]');
    if (copyBtn) {
      syncUrl();
      var url = location.href;
      function done() {
        copyBtn.textContent = T.copied;
        setTimeout(function () { copyBtn.textContent = T.copy_link; }, 2000);
      }
      function fallback() {
        // No clipboard API (old browser, http, permission refused): select the URL so
        // the buyer can copy it with one keystroke.
        var inp = document.createElement('input');
        inp.value = url;
        inp.setAttribute('readonly', '');
        inp.className = 'upsb-sb__copyfallback';
        copyBtn.parentNode.insertBefore(inp, copyBtn.nextSibling);
        inp.focus();
        inp.select();
        if (inp.setSelectionRange) inp.setSelectionRange(0, url.length);
        try { if (document.execCommand('copy')) { done(); inp.remove(); } } catch (e) { /* stays selected */ }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, fallback);
      } else fallback();
      return;
    }
    if (ev.target.closest('[data-print-btn]')) { window.print(); return; }
    var addRequirements = ev.target.closest('[data-quote-requirements]');
    if (addRequirements) {
      if (Object.keys(urlHolds).length) { $('[data-input-holds]').focus(); return; }
      if (!needsTechnicalReview() && lastRes.length) return;
      var invalidRequirement = requirementFormError();
      if (invalidRequirement) { refreshQuoteSendState(); invalidRequirement.element.focus(); return; }
      var sameReq = JSON.stringify(normalizedRequirements(q));
      if (needsTechnicalReview() ? currentRequirementsSaved() : quote.some(function (x) {
        return x.kind === 'requirements' && JSON.stringify(x.requirements) === sameReq; })) {
        var feedback = root.querySelector('[data-req-feedback]');
        if (feedback) feedback.textContent = T.req_already;
        return;
      }
      quote.push({ kind: 'requirements', qty: 1, requirements: normalizedRequirements(q), candidate: '' });
      var savedRequirements = persistQuote();
      quoteChanged('add', savedRequirements);
      renderQuote();
      render();
      var feedback = root.querySelector('[data-req-feedback]');
      if (feedback) feedback.textContent = quoteFeedback(fill(savedRequirements ? T.quote_added : T.quote_added_visit,
        { n: quote.length }), savedRequirements);
      var localReview = addRequirements.parentNode.querySelector('[data-quote-review]');
      if (localReview) { localReview.textContent = fill(T.quote_review, { n: quote.length }); localReview.hidden = false; }
      return;
    }
    var candidateToggle = ev.target.closest('[data-candidate-toggle]');
    if (candidateToggle) {
      if (hasInputHolds()) return;
      var candidateAt = currentRequirementAt(), current = normalizedRequirements(q);
      if (candidateAt < 0 || requirementFormError() || !candidateEligible(current)) return;
      var selecting = quote[candidateAt].candidate !== CANDIDATE_ID;
      quote[candidateAt].candidate = selecting ? CANDIDATE_ID : '';
      var candidateSaved = persistQuote();
      quoteChanged('update', candidateSaved);
      renderQuote(); render();
      var candidateFeedback = root.querySelector('[data-candidate-feedback]');
      if (candidateFeedback) candidateFeedback.textContent = quoteFeedback(selecting ? T.candidate_selected : T.candidate_unselected, candidateSaved);
      var nextToggle = root.querySelector('[data-candidate-toggle]');
      if (nextToggle && nextToggle.focus) nextToggle.focus();
      return;
    }
    var trayCmp = ev.target.closest('[data-tray-cmp]');
    if (trayCmp) {
      var cmpPanel = $('[data-upsb-cmp]');
      if (cmpHandles.length >= 2 && !cmpPanel.hidden) {
        if (cmpPanel.scrollIntoView) cmpPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var cmpHead = cmpPanel.querySelector('h2');
        if (cmpHead) { cmpHead.setAttribute('tabindex', '-1'); cmpHead.focus({ preventScroll: true }); }
      } else {
        trayCmp.textContent = T.tray_cmp_more;
        trayCmp.setAttribute('data-flash', '1');
        setTimeout(function () { trayCmp.removeAttribute('data-flash'); updateTray(); }, 2400);
      }
      return;
    }
    var rtChip = ev.target.closest('[data-rt-chip]');
    if (rtChip) {
      var rtField = $('[data-upsb-form]').elements.runtime;
      rtField.value = rtChip.getAttribute('data-rt-chip');
      rtField.dispatchEvent(new Event('input', { bubbles: true }));
      rtField.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var pickOutlet = ev.target.closest('[data-outlet-pick]');
    if (pickOutlet) {
      var outletField = $('[data-upsb-form]').elements.outlet;
      if (!outletField) return;
      outletField.value = pickOutlet.getAttribute('data-outlet-pick');
      outletField.dispatchEvent(new Event('input', { bubbles: true }));
      outletField.dispatchEvent(new Event('change', { bubbles: true }));
      var resultsBox = $('[data-upsb-results]');
      var firstCard = resultsBox && resultsBox.querySelector('.upsb-sb__sol h3 a');
      if (resultsBox && resultsBox.scrollIntoView) resultsBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (firstCard) firstCard.focus({ preventScroll: true });
      return;
    }
    var toThree = ev.target.closest('[data-to-three]');
    if (toThree) {
      var kwSeed = parseFloat(toThree.getAttribute('data-to-three'));
      if (window.UPSBThreePhase && window.UPSBThreePhase.seed && kwSeed > 0) window.UPSBThreePhase.seed({ mode: 'kw', val: String(kwSeed) });
      q.power = 'three-phase';
      writeForm(); render(); commitRequirements('preset', 'three');
      var rb = $('[data-upsb-results]'); if (rb && rb.scrollIntoView) rb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var setPow = ev.target.closest('[data-set-power]');
    if (setPow) {
      q.power = setPow.getAttribute('data-set-power');
      writeForm(); render(); commitRequirements('buyer');
      return;
    }
    var p = ev.target.closest('[data-preset]');
    if (p) {
      var beforePreset = JSON.stringify(normalizedRequirements(q));
      var k = p.getAttribute('data-preset');
      if (k === 'battery') { chooseMode(true); return; }
      if (k !== 'three' && k !== 'describe' && !PRESETS[k]) return;
      var hardNeeds = { chemistry: q.chemistry, plugNeed: q.plugNeed, outlet: q.outlet,
        card: q.card, monitorWatts: q.monitorWatts, shutdownNeed: q.shutdownNeed,
        shutdownPlatform: q.shutdownPlatform, rackU: q.rackU, depth: q.depth,
        generator: q.generator, outputV: q.outputV };
      if (PRESETS[k] && PRESETS[k].outlet && PRESETS[k].outlet !== 'unknown' && q.outlet === 'unknown') delete hardNeeds.outlet;
      var suggestGenerator = PRESETS[k] && PRESETS[k].generator === true &&
        !generatorExplicit && !urlHolds.gen && !q.generator;
      if (k === 'three') q.power = 'three-phase';
      else if (k === 'describe') q = Object.assign({}, BASE,
        { load: q.load, runtime: q.runtime, power: 'unknown', outlet: 'unknown', fit: 'either' }, hardNeeds);
      else if (PRESETS[k]) q = Object.assign({}, BASE, PRESETS[k], hardNeeds);
      if (suggestGenerator) { q.generator = true; generatorSuggested = true; }
      resetShownIfRequirementsChanged(beforePreset);
      writeForm(); root.classList.add('is-configuring'); render(); commitRequirements('preset', k);
      var f = $('[data-upsb-form]'); if (f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var moreBtn = ev.target.closest('[data-show-more]');
    if (moreBtn) {
      var firstNew = lastRes[shownCount] && lastRes[shownCount].u.h;
      shownCount = Math.min(lastRes.length, shownCount + 12); render();
      emitResultsSnapshot('-shown' + shownCount); // same requirements, more actually-visible cards
      var newlyShown = Array.prototype.find.call(root.querySelectorAll('[data-upsb-results] .upsb-sb__sol'),
        function (card) { return card.getAttribute('data-solution-h') === firstNew; });
      var focusTarget = newlyShown && newlyShown.querySelector('h3 a');
      if (!focusTarget) {
        focusTarget = root.querySelector('[data-upsb-results] .upsb-sb__count');
        if (focusTarget) focusTarget.setAttribute('tabindex', '-1');
      }
      if (focusTarget) focusTarget.focus();
      return;
    }
    var checkPrices = ev.target.closest('[data-check-prices]');
    if (checkPrices) {
      var rowAt = Number(checkPrices.getAttribute('data-check-prices'));
      if (Number.isInteger(rowAt) && rowAt >= 0 && rowAt < quote.length) refreshRowPrices(quote[rowAt]);
      return;
    }
    var a = ev.target.closest('[data-add]');
    if (a) {
      var sol = lastRes[+a.getAttribute('data-add')];
      if (!sol) return;
      if (cartPending[sol.u.h] || cartUncertain[sol.u.h]) return;
      if (!cartEligible(sol)) {
        var rf = reconfirmFacts(sol);
        cartNotice[sol.u.h] = p91Target(sol.u.h) ? T.p91_cart : outletIssue(sol) || physicalHeadline(sol) || (rf.length ? rf.map(function (x) { return x[1]; }).join(' ') :
          (!networkReady(sol) ? T.cart_card_unknown :
          (runtimeStatus(sol) === 'short' ? T.cart_runtime_short : T.cart_runtime_unknown)));
        emit('upsb_cart_result', { result: 'blocked', reason: cartBlockedReason(sol) });
        render(); return;
      }
      var selected = conf(sol), selectedParts = JSON.stringify(selected.items.map(function (it) { return [it[0], it[3]]; })),
        selectedQ = JSON.stringify(q);
      var submittedFingerprint = '';
      a.disabled = true;
      cartPending[sol.u.h] = true;
      var cartPostAttempted = false;
      var cartLineCount = 0;
      var cartMeasured = false;
      function cartTerminal(result, reason, lineCount) {
        if (cartMeasured) return;
        cartMeasured = true;
        var fields = { result: result };
        if (reason) fields.reason = reason;
        if (lineCount != null) fields.line_count = lineCount;
        emit('upsb_cart_result', fields);
      }
      // RD.03c W2: one add click = one group. Every line of the solution carries the same
      // two properties: a visible "Solution" label (the UPS as the row shows it, cut short
      // before the capacity numbers) and a hidden _upsb_solution id unique to this click,
      // so the order desk can regroup the lines of one job. The cart templates render
      // properties and skip keys starting with '_' (checked: snippets/cart-drawer.liquid
      // and sections/main-cart-items.liquid), so only the Solution label shows.
      var solId = 'sb-' + Date.now().toString(36);
      var solLabel = shortModel(sol.u);
      Promise.all(selected.items.map(function (it) {
        return fetch('/products/' + encodeURIComponent(it[0]) + '.js').then(function (r) { if (!r.ok) throw new Error('product_lookup'); return r.json(); })
          .then(function (pr) {
            if (!pr || (pr.handle && pr.handle !== it[0]) || !Array.isArray(pr.variants))
              throw new Error('product_lookup');
            if (pr.variants.length > 1) return { handle: it[0], ambiguous: true };
            var variant = pr.variants[0];
            var cents = variant && Number(variant.price);
            return { handle: it[0], cents: cents, available: !!(variant && variant.available === true &&
                       Number.isSafeInteger(variant.id) && variant.id > 0 &&
                       Number.isSafeInteger(cents) && cents > 0 && Number.isSafeInteger(it[3]) && it[3] > 0),
                     line: variant ? { id: variant.id, quantity: it[3],
                       properties: { 'Solution': solLabel, '_upsb_solution': solId } } : null };
          }).catch(function () { throw new Error('product_lookup'); });
      })).then(function (live) {
        // The buyer may have changed or removed a selected option while the
        // product requests were pending. Resolve that before recording prices.
        if (selectedParts !== JSON.stringify(conf(sol).items.map(function (it) { return [it[0], it[3]]; })) ||
            selectedQ !== JSON.stringify(q) || !cartEligible(sol)) {
          cartNotice[sol.u.h] = T.cart_configuration_changed; cartTerminal('blocked', 'configuration_changed'); return null;
        }
        if (live.some(function (x) { return x.ambiguous; })) {
          cartNotice[sol.u.h] = T.cart_variant_ambiguous; cartTerminal('blocked', 'variant_ambiguous'); return null;
        }
        live.forEach(function (x) { setLivePrice(x.handle, x.available ? x.cents : 0); if (x.available) delete liveUnavailable[x.handle]; else liveUnavailable[x.handle] = true; });
        if (live.some(function (x) { return !x.available; })) {
          cartNotice[sol.u.h] = T.cart_unavailable; cartTerminal('blocked', 'missing_product'); return null;
        }
        var total = live.reduce(function (sum, x, i) { return sum + x.cents * selected.items[i][3]; }, 0);
        if (!Number.isSafeInteger(total) || total >= 1000000) {
          cartNotice[sol.u.h] = T.cart_quote_only; cartTerminal('blocked', 'quote_only'); return null;
        }
        if (live.some(function (x, i) { return x.cents !== shownCents(x.handle, selected.items[i][2]); })) {
          if (livePrices.__cartCur === 'CAD') live.forEach(function (x) { seenLive[x.handle] = x.cents; });
          cartNotice[sol.u.h] = T.cart_price_changed; cartTerminal('price_changed', 'price_changed'); return null;
        }
        if (p91Target(sol.u.h)) { cartNotice[sol.u.h] = T.p91_cart; cartTerminal('blocked', 'capacity_review'); return null; }
        submittedFingerprint = cartFingerprint(sol); // snapshot after the last guard, before the mocked or real POST
        cartPostAttempted = true;
        cartLineCount = live.length;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: live.map(function (x) { return x.line; }) }) });
      }).then(function (r) {
        if (!r) return;
        if (!r.ok) throw new Error('cart_submit');
        delete cartNotice[sol.u.h]; inCart[sol.u.h] = submittedFingerprint;
        cartTerminal('success', null, cartLineCount);
      }).catch(function (error) {
        if (cartPostAttempted) {
          cartUncertain[sol.u.h] = true;
          cartNotice[sol.u.h] = T.cart_submit_uncertain;
        } else cartNotice[sol.u.h] = T.cart_product_error;
        cartTerminal('error', 'request_failed');
      }).finally(function () {
        delete cartPending[sol.u.h];
        render();
      });
      return;
    }
    var review = ev.target.closest('[data-quote-review]');
    if (review) {
      if (!quote.length) return;
      var heading = $('[data-quote-heading]');
      if (heading.scrollIntoView) heading.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (heading.focus) heading.focus();
      return;
    }
    var removeCandidate = ev.target.closest('[data-candidate-remove]');
    if (removeCandidate) {
      var candidateAt = parseInt(removeCandidate.getAttribute('data-candidate-remove'), 10);
      if (!Number.isInteger(candidateAt) || candidateAt < 0 || candidateAt >= quote.length ||
          quote[candidateAt].kind !== 'requirements' || quote[candidateAt].candidate !== CANDIDATE_ID) return;
      quote[candidateAt].candidate = '';
      var removedCandidateSaved = persistQuote();
      quoteChanged('update', removedCandidateSaved);
      renderQuote(); render();
      var candidateNotice = $('[data-quote-save-status]');
      candidateNotice.textContent = quoteFeedback(T.candidate_unselected, removedCandidateSaved);
      var sameQuantity = $('[data-quote-lines]').querySelector('[data-quote-qty="' + candidateAt + '"]');
      if (sameQuantity && sameQuantity.focus) sameQuantity.focus();
      return;
    }
    var remove = ev.target.closest('[data-quote-remove]');
    if (remove) {
      var removeAt = parseInt(remove.getAttribute('data-quote-remove'), 10);
      if (!Number.isInteger(removeAt) || removeAt < 0 || removeAt >= quote.length) return;
      quote.splice(removeAt, 1);
      if (!quote.length) setCheckBuild(false);
      var removedSaved = persistQuote();
      quoteChanged('remove', removedSaved);
      renderQuote();
      render();
      var removedNotice = quote.length ? $('[data-quote-save-status]') : $('[data-quote-global-status]');
      removedNotice.textContent = T.quote_removed + (removedSaved ? '' : ' ' + T.quote_changed);
      var nextQuantity = $('[data-quote-lines]').querySelector('[data-quote-qty="' + Math.min(removeAt, quote.length - 1) + '"]');
      if (nextQuantity && nextQuantity.focus) nextQuantity.focus();
      else if (removedNotice.focus) removedNotice.focus();
      return;
    }
    var checkBtn = ev.target.closest('[data-check-build]');
    if (checkBtn) {   // G.04: the same row as "Add to quote list", flagged for a specialist check, then the list
      if (Object.keys(urlHolds).length) { $('[data-input-holds]').focus(); return; }
      var checkCard = checkBtn.closest('.upsb-sb__sol');
      var addBtn = checkCard && checkCard.querySelector('[data-quote="' + checkBtn.getAttribute('data-check-build') + '"]');
      if (!addBtn || !lastRes[+checkBtn.getAttribute('data-check-build')]) return;
      var before = quote.length;
      addBtn.click();
      if (quote.length <= before) return;
      setCheckBuild(true);
      renderQuote();
      var checkFeedback = checkCard.querySelector('[data-quote-feedback]');
      if (checkFeedback) checkFeedback.textContent = T.check_build_added + ' ' + T.talk_line;
      var checkHeading = $('[data-quote-heading]');
      if (checkHeading && checkHeading.scrollIntoView) checkHeading.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (checkHeading && checkHeading.focus) checkHeading.focus();
      return;
    }
    var qb = ev.target.closest('[data-quote]');
    if (qb) {
      if (Object.keys(urlHolds).length) { $('[data-input-holds]').focus(); return; }
      var e = lastRes[+qb.getAttribute('data-quote')];
      if (!e) return;
      var rt = selectedRuntime(e), status = runtimeStatus(e);
      var rtText = rt ? fill(rt.atLeast ? T.rt_at_least : (rt.est ? T.rt_estimate : T.rt_published),
        { m: rtNum(rt.min), w: q.load }) : T.rt_confirm;
      var verdict = e.p91Capacity ? T.p91_runtime_verdict : status === 'meets' ? T.quote_runtime_meets :
        (status === 'short' ? T.quote_runtime_short : T.quote_runtime_unknown);
      var rf = reconfirmFacts(e);
      // A saved positional/blank pack choice can keep its requested quantity while
      // no exact pack model can be sold. The quote must carry that count even when
      // reconfirmFacts has no missing HANDLE to print it with.
      var chosen = selFor(e), pack = chosen.eI >= 0 ? e.opts.e[chosen.eI] : null;
      var packAlreadyInHold = reconfirm[e.u.h] && reconfirm[e.u.h].missing.some(function (m) { return m.key === 'eI'; });
      var packNeed = chosen.e > 0 && !pack && !packAlreadyInHold ? packFact(e)[1] : '';
      var selectedItems = conf(e).items;
      var row;   // G32: captured for the bounded same-currency refresh
      quote.push(row = { kind: 'solution', model: selectedItems.map(function (it) { return (it[3] > 1 ? it[3] + ' x ' : '') + it[0]; }).join(' + '),
        estimate: snapshotEstimate(selectedItems),
        qty: 1, note: answersLine() + ' | ' + verdict + ': ' + rtText +
          ' | ' + cardCommercialLine(e) +
          (placementQuoteLine(e) ? ' | ' + placementQuoteLine(e) : '') +
          (outletIssue(e) ? ' | ' + outletIssue(e) : '') +
          (outputConnectionText(e) ? ' | ' + outputConnectionText(e) : '') +
          (physicalLines(e).length ? ' | ' + T.physical_per_system + ' ' + physicalLines(e).join(' | ') : '') +
          (e.bundleReview ? ' | ' + T.bundle_quote_review + ' | ' + bundleSourceText(e) + ' | ' + bundleRuntimeText(e) : '') +
          (packNeed ? ' | ' + packNeed : '') +
          (rf.length ? ' | ' + rf.map(function (x) { return x[1]; }).join(' | ') : '') +
          (e.p91Capacity ? ' | ' + p91Quote(e, rt) : '') +
          (e.inputVoltage ? ' | ' + typedInputQuote(e) : '') +
          (e.j60 ? ' | ' + T.j60_quote : ''),
        inputSource: e.inputVoltage ? typedInputProvenance(e) : null,
        bundleSource: e.bundleReview ? bundleSourceProvenance(e) : null });
      refreshSolution(e).then(function (cur) {
        if (quote.indexOf(row) < 0) return;   // removed/cleared while requests were pending
        if (cur) row.current = cur;
        else row.refreshNote = refreshNote || 'unavailable';
        renderQuote(); persistQuote();
      });
      // UX pass: an option picked under a specialist requirement carries that requirement into the quote list
      if (needsTechnicalReview()) {
        row.req = JSON.stringify(normalizedRequirements(q));
        if (!currentRequirementsSaved() && !requirementFormError())
          quote.push({ kind: 'requirements', qty: 1, requirements: normalizedRequirements(q), candidate: '' });
      }
      var quoteSaved = persistQuote();
      quoteChanged('add', quoteSaved);
      renderQuote();
      var card = qb.closest ? qb.closest('.upsb-sb__sol') : null;
      if (card) {
        var feedback = card.querySelector('[data-quote-feedback]');
        var localReview = card.querySelector('[data-quote-review]');
        if (feedback) feedback.textContent = quoteFeedback(fill(quoteSaved ? T.quote_added : T.quote_added_visit, { n: quote.length }), quoteSaved);
        if (localReview) { localReview.textContent = fill(T.quote_review, { n: quote.length }); localReview.hidden = false; }
      }
      return;
    }
    if (ev.target.closest('[data-quote-clear]')) {
      if (!quote.length) return;
      quote = [];
      setCheckBuild(false);
      var clearSaved = persistQuote();
      quoteChanged('clear', clearSaved);
      renderQuote();
      render();
      var clearNotice = $('[data-quote-global-status]');
      clearNotice.textContent = T.quote_cleared + (clearSaved ? '' : ' ' + T.quote_changed);
      if (clearNotice.focus) clearNotice.focus();
      return;
    }
  });
  function updateQuoteQuantity(ev) {
    if (!ev.target || !ev.target.closest) return;
    var input = ev.target.closest('[data-quote-qty]');
    if (!input) return;
    var at = parseInt(input.getAttribute('data-quote-qty'), 10);
    if (!Number.isInteger(at) || at < 0 || at >= quote.length) return;
    var raw = String(input.value).trim(), next = Number(raw);
    var error = input.parentNode.parentNode.querySelector('[data-quote-error]');
    var row = input.closest('[data-quote-row]');
    var send = $('[data-quote-send]');
    if (!/^[1-9]\d*$/.test(raw) || !Number.isSafeInteger(next)) {
      input.setAttribute('aria-invalid', 'true');
      if (error) error.textContent = T.quote_qty_invalid;
      // An invalid replacement keeps the last committed count and request.
      if (row) row.querySelector('.upsb-sb__quote-line').textContent = quoteLine(quote[at]);
      send.href = quoteSendHref();
      refreshQuoteSendState();
      return;
    }
    // Paint the valid value while typing so the layout and destination settle
    // before a pointer click. Commit it only on change, after the final input
    // is valid; a rejected fractional or exponent entry cannot save a prefix.
    input.removeAttribute('aria-invalid');
    if (error) error.textContent = '';
    var hadSavedHold = false;
    if (ev.type === 'change') {
      var quantityBefore = JSON.stringify(quote[at]);
      hadSavedHold = Object.prototype.hasOwnProperty.call(quote[at], 'sourceQty');
      correctSavedQty(quote[at], next);
      if (quantityBefore !== JSON.stringify(quote[at])) {
        var qtySaved = persistQuote();
        quoteChanged('quantity', qtySaved);
        $('[data-quote-save-status]').textContent = quoteFeedback(qtySaved ? T.quote_updated : T.quote_changed, qtySaved);
      }
    }
    if (row) row.querySelector('.upsb-sb__quote-line').textContent =
      quoteLine(ev.type === 'change' ? quote[at] : Object.assign({}, quote[at], { qty: next }));
    send.href = quoteSendHref(at, next);
    var candidateCountEl = root.querySelector('[data-candidate-count]');
    if (candidateCountEl && at === currentRequirementAt()) candidateCountEl.textContent = candidateCount(next);
    refreshQuoteSendState();
    if (hadSavedHold) render();
  }
  root.addEventListener('input', updateQuoteQuantity);
  root.addEventListener('change', updateQuoteQuantity);
  root.addEventListener('change', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var control = ev.target.closest('[data-saved-hold-field]');
    if (!control) return;
    var at = parseInt(control.getAttribute('data-row'), 10), field = control.getAttribute('data-saved-hold-field');
    if (!Number.isInteger(at) || at < 0 || at >= quote.length || !quote[at].sourceRequirements) return;
    var raw = control.value, value = field === 'generator' || field === 'card' || field === 'monitorWatts' ? raw === 'true' :
      (INPUT_BOUNDS[field] ? Number(raw) : raw);
    if ((!raw && field !== 'shutdownPlatform') || (INPUT_BOUNDS[field] && value === 0) || !suppliedValid(field, value)) {
      control.setAttribute('aria-invalid', 'true'); return;
    }
    var row = quote[at];
    var savedFieldBefore = JSON.stringify(row);
    correctSavedField(row, field, value);
    if (savedFieldBefore === JSON.stringify(row)) return;
    var correctedSaved = persistQuote();
    quoteChanged('update', correctedSaved);
    renderQuote(); render();
    var correctedNotice = $('[data-quote-save-status]') || $('[data-quote-global-status]');
    if (correctedNotice) correctedNotice.textContent = quoteFeedback(T.quote_updated, correctedSaved);
  });
  root.addEventListener('click', function (ev) {
    var sm = ev.target.closest('.upsb-sb__addons > summary');
    if (!sm) return;
    var d = sm.parentNode, h = d.getAttribute('data-addons-h');
    openAdd[h] = !d.open;
    if (openAdd[h]) setTimeout(function () { fillPrices(lastRes.slice(0, shownCount)); }, 0);
  });
  root.addEventListener('change', function (ev) {
    var placement = ev.target.closest('[data-placement-answer]');
    if (placement) {
      var handle = placement.getAttribute('data-placement-answer');
      var target = lastRes.find(function (x) { return x.u.h === handle; });
      var context = target && placementContext(target);
      if (!context || ['yes', 'no', 'unsure'].indexOf(placement.value) < 0) return;
      var previousPlacement = q.towerPlacement && q.towerPlacement[handle] && q.towerPlacement[handle].answer;
      q.towerPlacement = q.towerPlacement || {};
      q.towerPlacement[handle] = Object.assign({}, context,
        { answer: placement.value, at: new Date().toISOString() });
      delete inCart[handle];
      render();
      commitPlacementAnswer(previousPlacement || '', placement.value);
      var backPlacement = root.querySelector('[data-placement-answer="' + handle + '"][value="' + placement.value + '"]');
      if (backPlacement) backPlacement.focus();
      return;
    }
    var el = ev.target.closest('[data-addon]');
    if (!el) return;
    var i = +el.getAttribute('data-i'), k = el.getAttribute('data-addon'), e = lastRes[i];
    if (!e) return;
    var configurationBefore = configurationStamp(e);
    var s = sel[e.u.h] = Object.assign({}, selFor(e));
    if (!s.ids) s.ids = { eI: '', c: '', x: '', r: '' };
    // Astra rework 2, defect 2: on the first edit of a row, record the identity of
    // every ALREADY-RESOLVED selection (engine defaults included, e.g. the Network-M3
    // card auto-selected when a card is required). Without this, editing the pack
    // quantity alone serialized a blank card field and the reload lost the card.
    (function backfillIds() {
      var lists = { eI: e.opts.e, c: e.opts.c, x: e.opts.x, r: e.opts.r };
      Object.keys(lists).forEach(function (key) {
        if (!s.ids[key] && s[key] >= 0 && lists[key][s[key]]) s.ids[key] = String(lists[key][s[key]][0]);
      });
    })();
    s[k] = parseInt(el.value, 10);
    if (q.towerPlacement) delete q.towerPlacement[e.u.h];
    delete inCart[e.u.h];   // a changed configuration can be added again
    if (!cartUncertain[e.u.h]) delete cartNotice[e.u.h];
    // RD.03d rework 1: keep the identity strings current for URL serialization. An
    // exact model choice records its handle; a qty change alone does not invent one.
    if (k !== 'e') {
      var listK = k === 'eI' ? e.opts.e : e.opts[k];
      s.ids[k] = (s[k] >= 0 && listK[s[k]]) ? String(listK[s[k]][0]) : '';
    } else if (s.e > 0 && s.eI >= 0 && e.opts.e[s.eI] && !s.ids.eI) {
      s.ids.eI = String(e.opts.e[s.eI][0]);   // qty on a default model: that model's handle
    }
    // Clearing rules (master): the pack-model hold clears ONLY on an exact model
    // selection (eI) or an explicit zero/removal (qty to 0). Raising the quantity of
    // a held/missing pack keeps the hold and the missing identity. Card/bypass/rail
    // holds clear when that kind is re-picked.
    var clearKeys = [];
    if (k === 'eI' || (k === 'e' && s.e === 0)) clearKeys.push('eI');
    else if (k !== 'e') clearKeys.push(k);
    // an explicit zero REMOVES the pack choice entirely: the identity string goes too,
    // otherwise the rewritten URL still carries the removed handle and a reload would
    // re-create the hold (Astra rework 2, defect 1)
    if (k === 'e' && s.e === 0) s.ids.eI = '';
    var r = reconfirm[e.u.h];
    if (r && clearKeys.length) {
      r.kinds = r.kinds.filter(function (x) { return clearKeys.indexOf(x.key) === -1; });
      r.missing = r.missing.filter(function (x) { return clearKeys.indexOf(x.key) === -1; });
      clearKeys.forEach(function (key) { if (s.ids[key] === '?') s.ids[key] = ''; });
      if (!r.kinds.length && !r.missing.length) delete reconfirm[e.u.h];
    }
    if (k === 'eI' && !s.e && s.eI >= 0) s.e = 1;   // picking a real model implies one pack
    render();
    commitConfiguration(configurationBefore, configurationStamp(e));
    // the solution keeps its place (choices do not change the ranking), so focus returns to the same control
    var back = root.querySelector('[data-addon="' + k + '"][data-i="' + i + '"]');
    if (back) back.focus();
  });
  $('[data-upsb-form]').addEventListener('input', function (ev) {
    var beforeInput = JSON.stringify(normalizedRequirements(q));
    var field = ev && ev.target ? ev.target.name : '';
    if (field) {
      var raw = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
      acceptUrlCorrection(field, raw);
      if (field === 'fit' && q.fit !== raw) q.towerPlacement = {};
      if (field === 'generator') {
        generatorExplicit = true;
        generatorSuggested = false;
        var note = root.querySelector('[data-generator-preset-note]');
        if (note) note.hidden = true;
      }
    }
    readForm(); resetShownIfRequirementsChanged(beforeInput);
    root.classList.add('is-configuring'); render();
  });
  $('[data-upsb-form]').addEventListener('change', renderIfChanged);
  root.addEventListener('change', function (ev) {
    var sortSel = ev.target.closest && ev.target.closest('[data-sort], [data-brand]');
    if (!sortSel) return;
    if (sortSel.hasAttribute('data-sort')) sortMode = sortSel.value; else brandFilter = sortSel.value;
    shownCount = 12;
    render();
    var again = root.querySelector(sortSel.hasAttribute('data-sort') ? '[data-sort]' : '[data-brand]');
    if (again) again.focus();
  });
  // Builder vs the makers' selectors (Master, 2 Oct 2026; 01-EVIDENCE/mac-lead/builder-vs-makers-2026-10-02/GAPS.md).
  // (1) Replace path, as Eaton's "Replace" and "Cross reference": the buyer types the model of the UPS they own; the
  // catalogue match shows its rating and, when discontinued, its current model; it fills the form from that unit or
  // opens the battery finder on it. (2) Room to grow, as APC, Eaton and CyberPower: chips raise the typed load.
  // Both only write the existing form fields, so saved rows, links and quotes keep their format.
  var OUTLET_OF_PLUG = { '5-15P': '5-15R', '5-20P': '5-20R', 'L5-20P': 'L5-20R', 'L5-30P': 'L5-30R', 'L6-20P': 'L6-20R', 'L6-30P': 'L6-30R' };
  function setField(name, value) {
    var el = $('[data-upsb-form]').elements[name];
    if (!el || value == null) return;
    el.value = String(value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function initReplaceLookup() {
    var fs = root.querySelector('.upsb-sb__quick');
    if (!fs || fs.querySelector('[data-rl]')) return;
    var d = document.createElement('details');
    d.className = 'upsb-sb__replace'; d.setAttribute('data-rl', '');
    d.innerHTML = '<summary>' + esc(T.rl_summary) + '</summary><label>' + esc(T.rl_label) +
      '<input type="text" data-rl-q maxlength="40" autocomplete="off" placeholder="' + esc(T.rl_ph) + '"></label>' +
      '<div class="upsb-sb__rl-list" data-rl-list role="list"></div><p class="upsb-sb__hint" data-rl-note aria-live="polite"></p>';
    var legend = fs.querySelector('legend');
    fs.insertBefore(d, legend ? legend.nextSibling : fs.firstChild);
    var inp = d.querySelector('[data-rl-q]'), list = d.querySelector('[data-rl-list]'), note = d.querySelector('[data-rl-note]');
    var hits = [];
    function norm(v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
    function search() {
      var k = norm(inp.value);
      list.innerHTML = ''; hits = [];
      if (k.length < 3 || !index) return;
      var rows = B.rows(index), scored = [];
      for (var i = 0; i < rows.length; i++) {
        var u = rows[i], h = norm(u.h), t = norm(u.t), toks = String(u.t || '').split(/\s+/).map(norm);
        var sc = h === k || toks.indexOf(k) >= 0 ? 0 : (h.indexOf(k) === 0 || toks.some(function (x) { return x.indexOf(k) === 0; }) ? 1 :
          (h.indexOf(k) >= 0 ? 2 : (t.indexOf(k) >= 0 ? 3 : -1)));
        if (sc >= 0) scored.push([sc, u]);
      }
      scored.sort(function (a, b) { return a[0] - b[0] || (a[1].lc === 'D') - (b[1].lc === 'D') || a[1].w - b[1].w; });
      hits = scored.slice(0, 6).map(function (x) { return x[1]; });
      if (!hits.length) { list.innerHTML = '<p class="upsb-sb__hint">' + esc(T.rl_none) + '</p>'; return; }
      list.innerHTML = hits.map(function (u, i) {
        return '<div class="upsb-sb__rl-hit" role="listitem"><b>' + esc(u.t) + '</b><span>' +
          esc([u.va ? u.va + ' VA' : '', u.w ? u.w + ' W' : '', u.plug || ''].filter(Boolean).join(' · ')) +
          (u.lc === 'D' ? ' · ' + esc(T.rl_disc) + (u.succ && succModel(u.succ) ? ', <button type="button" class="upsb-sb__rl-succ" data-rl-succ="' +
            i + '">' + esc(fill(T.rl_succ, { s: succModel(u.succ) })) + '</button>' : '') : '') + '</span>' +
          '<span class="upsb-sb__rl-acts"><button type="button" class="upsb-sb__chip upsb-sb__chip--sm" data-rl-use="' + i + '">' + esc(T.rl_use) +
          '</button><button type="button" class="upsb-sb__chip upsb-sb__chip--sm" data-rl-batt="' + i + '">' + esc(T.rl_batt) + '</button></span></div>';
      }).join('');
    }
    ['input', 'change'].forEach(function (type) {
      d.addEventListener(type, function (ev) { if (ev.target === inp) { ev.stopPropagation(); if (type === 'input') search(); } });
    });
    d.addEventListener('click', function (ev) {
      var nx = ev.target.closest && ev.target.closest('[data-rl-succ]');
      if (nx) {   // look the maker's current model up in place
        var cu = hits[parseInt(nx.getAttribute('data-rl-succ'), 10)], m = cu ? succModel(cu.succ).split(' ').pop() : '';
        if (m) { inp.value = m; search(); inp.focus(); }
        return;
      }
      var use = ev.target.closest && ev.target.closest('[data-rl-use]'), bat = ev.target.closest && ev.target.closest('[data-rl-batt]');
      if (!use && !bat) return;
      var u = hits[parseInt((use || bat).getAttribute(use ? 'data-rl-use' : 'data-rl-batt'), 10)];
      if (!u) return;
      if (bat) {
        chooseMode(true);
        var bf = root.querySelector('[data-upsb-bf-input]');
        if (bf) { bf.value = inp.value; bf.dispatchEvent(new Event('input', { bubbles: true })); bf.focus(); }
        return;
      }
      var load = applyUpsRow(u);
      note.textContent = fill(T.rl_set, { m: u.succ && u.lc === 'D' && succModel(u.succ) ? u.t + ' (' + fill(T.rl_succ, { s: succModel(u.succ) }) + ')' : u.t, w: load });
    });
  }
  // One UPS row -> the builder answers (80 % of its watts, its supply, outlet and form). Shared by the model lookup and
  // the battery search's discontinued-model offer.
  function applyUpsRow(u) {
    var load = Math.max(50, Math.round((u.w || 0) * 0.8 / 50) * 50);
    setField('power', u.ph === '3' ? 'three-phase' : (u.volt === '120' ? '120' : (u.volt === '208' || u.volt === '240' ? '208-240' : (u.volt === '230' ? '230' : 'unknown'))));
    var P = String(u.plug || '').toUpperCase().replace(/NEMA\s*/, '').trim();
    setField('outlet', /HARD ?WIRE/.test(P) ? 'HW' : (OUTLET_OF_PLUG[P] || 'unknown'));
    setField('fit', u.ff === 'R' ? 'rack' : (u.ff === 'T' ? 'tower' : 'either'));
    setField('load', load);
    return load;
  }
  function initGrowChips() {
    var f = $('[data-upsb-form]'), load = f && f.elements.load;
    if (!load || root.querySelector('[data-grow-box]')) return;
    var lab = load.closest('label'), box = document.createElement('div');
    box.className = 'upsb-sb__grow'; box.setAttribute('data-grow-box', '');
    box.innerHTML = '<span>' + esc(T.grow_label) + '</span>' + [10, 20, 50].map(function (p) {
      return '<button type="button" class="upsb-sb__chip upsb-sb__chip--sm" data-grow="' + p + '">+' + p + ' %</button>'; }).join('') +
      '<small class="upsb-sb__hint" data-grow-note aria-live="polite"></small>';
    lab.parentNode.insertBefore(box, lab.nextSibling);
    box.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-grow]');
      if (!b) return;
      var p = parseInt(b.getAttribute('data-grow'), 10), cur = parseFloat(load.value) || 0;
      if (!cur) { load.focus(); return; }
      var next = Math.ceil(cur * (1 + p / 100) / 50) * 50;
      setField('load', next);
      box.querySelector('[data-grow-note]').textContent = fill(T.grow_done, { p: p, w: next.toLocaleString(FR ? 'fr-CA' : 'en-CA') });
    });
  }
  initLoadHelp();
  initReplaceLookup();
  initGrowChips();
  initBuilderX();
  root.addEventListener('input', function (ev) {
    var k = ev.target.closest && ev.target.closest('[data-tp-kw]');
    if (!k) return;
    tpAnswers.kw = String(k.value).slice(0, 8);
    var a = root.querySelector('[data-tp-link]');
    if (a) a.href = tpHref();
  });
  root.addEventListener('change', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-tp]');
    if (!t) return;
    tpAnswers[t.getAttribute('data-tp')] = parseInt(t.value, 10) || 0;
    var a = root.querySelector('[data-tp-link]');
    if (a) a.href = tpHref();
  });

  root.addEventListener('change', function (ev) {
    var cb = ev.target;
    if (!cb || !cb.matches || !cb.matches('input[data-cmp]')) return;
    var h = cb.getAttribute('data-cmp');
    if (cb.checked) {
      if (cmpHandles.length >= 3) {
        cb.checked = false;
        showCmpMsg();
        return;
      }
      if (cmpHandles.indexOf(h) === -1) cmpHandles.push(h);
    } else {
      cmpHandles = cmpHandles.filter(function (x) { return x !== h; });
    }
    renderCmp();
  });

  function loadP91Projection() {
    if (!P91 || !P91.validProjection) return;
    fetch(root.getAttribute('data-p91-url')).then(function (r) {
      if (!r.ok) throw new Error('P91 projection HTTP error');
      return r.json();
    }).then(function (doc) {
      P91.validProjection(doc);
      p91Projection = doc;
      if (index) render();
    }).catch(function () { p91Projection = null; if (index) render(); });
  }

  function loadBuilderIndex(useInline) {
    var requestId = ++indexRequestId;
    indexStatus = 'loading';
    if (!index) render();
    var supplied = useInline && window.UPSB_BUILDER_INDEX;
    var loading = supplied ? Promise.resolve(supplied) :
      fetch(root.getAttribute('data-index-url')).then(function (r) {
        if (!r.ok) throw new Error('builder index HTTP error');
        return r.json();
      });
    loading.then(function (j) {
      if (requestId !== indexRequestId) return;
      if (!j || !Array.isArray(j.fields) || !Array.isArray(j.u) || !Array.isArray(j.ac) ||
          j.fields.indexOf('h') < 0 || !j.u.length) throw new Error('builder index malformed');
      if (!B.validOutputConnections || !B.validOutputConnections(j))
        throw new Error('builder output-connection source missing or malformed');
      if (FR) localize(j);
      index = j; indexStatus = 'ready'; applyAddonParams(addonParams); applyUpsParam(); renderQuote(); render(); maybeViewBuilder();
    }).catch(function () {
      if (requestId !== indexRequestId) return;
      index = null; indexStatus = 'error'; render();
    });
  }
  fetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
    if (cart && /^[A-Z]{3}$/.test(String(cart.currency || ''))) livePrices.__cartCur = cart.currency;
    // Round 6 (09-30 19:10 UTC, Lane D's note): when the builder data rendered before the cart currency was known, the priced
    // parts were not asked for their store price until the next render; ask now so the quote-only / unavailable
    // reason shows on the first result set.
    if (indexStatus === 'ready' && lastRes.length) fillPrices(lastRes.slice(0, shownCount));
  }).catch(function () {});
  var addonParams = parseAddonParams();
  var fromUrl = applyUrlParams();
  if (fromUrl || addonParams.length) root.classList.add('is-configuring');
  // Read once at start-up: the first render writes the default answers into the URL before the index is in.
  var upsFromLink = '';
  try {
    var startParams = new URLSearchParams(location.search);
    if (!batteryMode && startParams.get('ups') && !startParams.has('load')) upsFromLink = startParams.get('ups');
    if (!batteryMode && (upsFromLink || (fromUrl && startParams.has('load')))) root.classList.add('is-from-link');
  } catch (e) { /* no URL API: the full form stays open */ }
  var copyBtn = $('[data-copy-link]');
  if (copyBtn) copyBtn.textContent = T.copy_link;
  var printBtn = $('[data-print-btn]');
  if (printBtn) printBtn.textContent = T.print;
  window.addEventListener('beforeprint', function () {
    if (!batteryMode) { render(); renderQuote(); }
  });
  window.addEventListener('popstate', function () {
    var next = batteryModeFromUrl();
    if (next !== batteryMode) showMode(next, true);
    syncUrl();
  });
  writeForm(); showMode(batteryMode, false); renderQuote(); render(); loadP91Projection(); loadBuilderIndex(true);
})();
